/******/ (function() { // webpackBootstrap
/******/ 	var __webpack_modules__ = ({

/***/ 161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketForm_TicketForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketForm/TicketForm.vue?vue&type=template&id=c58368f6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{directives:[{name:"b-tooltip",rawName:"v-b-tooltip",value:({ title: _vm.isIcon !== false ? _vm.label : null }),expression:"{ title: isIcon !== false ? label : null }"}],tag:"component",class:{ 'p-0 pl-1': _vm.isIcon !== false },attrs:{"variant":_vm.isIcon !== false ? 'icon' : _vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[(_vm.isIcon !== false)?_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus-circle']}}):[_vm._v(" "+_vm._s(_vm.label)+" ")],_c('FormModal',{attrs:{"title":_vm.$t('tickets.ticket.createTitle'),"size":"xl"},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":"/ticket","value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',[_c('b-col',[_c('CustomerSelect',{attrs:{"withForm":false,"contactId":_vm.contactFilter},model:{value:(_vm.ticket.customer),callback:function ($$v) {_vm.$set(_vm.ticket, "customer", $$v)},expression:"ticket.customer"}})],1),_c('b-col',[_c('ContactSelect',{attrs:{"withForm":false,"customer":_vm.ticket.customer},model:{value:(_vm.ticket.contact),callback:function ($$v) {_vm.$set(_vm.ticket, "contact", $$v)},expression:"ticket.contact"}})],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('b-form-group',{staticStyle:{"width":"200px"},attrs:{"label":_vm.$t('tickets.ticket.priority')}},[_c('k-form-select',{attrs:{"options":_vm.ticketPriorities,"clearable":false,"reduce":opt => opt.id},model:{value:(_vm.ticket.priority),callback:function ($$v) {_vm.$set(_vm.ticket, "priority", $$v)},expression:"ticket.priority"}})],1)],1)],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.subject')}},[_c('k-form-input',{attrs:{"required":""},model:{value:(_vm.ticket.subject),callback:function ($$v) {_vm.$set(_vm.ticket, "subject", $$v)},expression:"ticket.subject"}})],1),(_vm.ticket.id === undefined)?_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.message')}},[_c('k-form-editor',{attrs:{"size":"sm","required":""},model:{value:(_vm.ticket.message),callback:function ($$v) {_vm.$set(_vm.ticket, "message", $$v)},expression:"ticket.message"}}),_c('b-row',_vm._l((_vm.temporaryFiles),function(file,i){return _c('b-col',{key:file.id,staticClass:"tickets-file-form mt-2"},[_c('FileItem',{attrs:{"value":file},on:{"deleted":function($event){return _vm.fileDeleted(i)}}})],1)}),1),_c('k-form-file',{staticClass:"mt-2",attrs:{"url":"/file","datas":{ temporary: 1 },"removeUploadedFile":"","multiple":"","btnMode":"","btnLabel":"Sélectionner des fichiers","btnSize":"sm"},on:{"onUpload":_vm.fileUploaded}})],1):_vm._e(),_c('b-row',[_c('b-col',[_c('b-form-group',{attrs:{"label":"Attribué à"}},[_c('TeamUserSelect',{attrs:{"role":"tickets","selectDefault":""},model:{value:(_vm.ticket.team_user),callback:function ($$v) {_vm.$set(_vm.ticket, "team_user", $$v)},expression:"ticket.team_user"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.tags')}},[_c('k-form-select',{attrs:{"options":_vm.tags,"multiple":""},model:{value:(_vm.ticket.tags),callback:function ($$v) {_vm.$set(_vm.ticket, "tags", $$v)},expression:"ticket.tags"}})],1)],1),_c('b-col',[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.category')}},[_c('k-form-select',{attrs:{"options":_vm.categories},model:{value:(_vm.ticket.category),callback:function ($$v) {_vm.$set(_vm.ticket, "category", $$v)},expression:"ticket.category"}})],1)],1)],1),_c('CustomFieldsForm',{attrs:{"type":"ticket"},model:{value:(_vm.ticket.custom_fields),callback:function ($$v) {_vm.$set(_vm.ticket, "custom_fields", $$v)},expression:"ticket.custom_fields"}})],1)],1)],2):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
// EXTERNAL MODULE: ./src/mixins/LoadTicketElements.ts
var LoadTicketElements = __webpack_require__(8086);
// EXTERNAL MODULE: ./src/mixins/TicketPriorities.ts
var TicketPriorities = __webpack_require__(515);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketForm/TicketForm.ts?vue&type=script&lang=ts&external










var TicketForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketForm, _super);
    function TicketForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.modalState = false;
        _this.temporaryFiles = [];
        _this.ticket = {
            custom_fields: [],
            tags: []
        };
        return _this;
    }
    Object.defineProperty(TicketForm.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketForm.prototype, "formDatas", {
        get: function () {
            var _a;
            var ticket = this.ticket;
            var datas = {
                customer: ticket.customer ? ticket.customer.id : null,
                contact: ticket.contact ? ticket.contact.id : null,
                subject: ticket.subject,
                tags: (_a = ticket.tags) === null || _a === void 0 ? void 0 : _a.map(function (tag) { return tag.id; }),
                category: ticket.category ? ticket.category.id : null,
                custom_fields: ticket.custom_fields.map(function (field) {
                    var _a;
                    return ({
                        id: field.id,
                        value: (_a = (typeof field.value === 'object' && 'id' in field.value ? field.value.id : field.value)) !== null && _a !== void 0 ? _a : null
                    });
                }),
                priority: ticket.priority,
                files: this.temporaryFiles.map(function (file) { return file.id; })
            };
            if (!this.ticket.id) {
                datas.message = ticket.message;
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketForm.prototype, "contactFilter", {
        get: function () {
            var _a;
            return this.ticket.customer ? undefined : (_a = this.ticket.contact) === null || _a === void 0 ? void 0 : _a.id;
        },
        enumerable: false,
        configurable: true
    });
    TicketForm.prototype.watchValue = function () {
        this.ticket = Object.assign({
            custom_fields: [],
            tags: [],
            priority: 2
        }, this.value ? JSON.parse(JSON.stringify(this.value)) : {});
    };
    TicketForm.prototype.fileUploaded = function (file) {
        this.temporaryFiles.push(file);
    };
    TicketForm.prototype.fileDeleted = function (index) {
        lib/* Vue */.lD.delete(this.temporaryFiles, index);
    };
    TicketForm.prototype.submitComplete = function (response) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.$router.push({
                            name: 'tickets-item',
                            params: {
                                id: String(response.data.id)
                            }
                        })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TicketForm.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'Créer un ticket' })
    ], TicketForm.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketForm.prototype, "isIcon", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketForm.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketForm.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TicketForm.prototype, "watchValue", null);
    TicketForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormFile: form_vue_.KFormFile, KFormSelect: form_vue_.KFormSelect,
                TeamUserSelect: interface_vue_.TeamUserSelect, FileItem: interface_vue_.FileItem, FormModal: interface_vue_.FormModal,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BFormGroup: external_bootstrap_vue_.BFormGroup,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], TicketForm);
    return TicketForm;
}((0,lib/* Mixins */.Xe)(LoadTicketElements/* default */.A, TicketPriorities/* default */.A)));
/* harmony default export */ var TicketFormvue_type_script_lang_ts_external = (TicketForm);

;// ./src/components/TicketForm/TicketForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketForm_TicketFormvue_type_script_lang_ts_external = (TicketFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketForm/TicketForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketForm_TicketFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketForm_TicketForm = (component.exports);

/***/ }),

/***/ 294:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),

/***/ 339:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var config = {
    enter: 2,
    fontSizeUnit: 'pt',
    zIndex: 999999,
    heightMin: 100,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'fontSize',
                '|',
                'textColor',
                'backgroundColor',
                '|',
                'formatUL',
                'formatOL',
                'quote',
                '|',
                'insertImage',
                'insertTable',
                'insertHR',
                'insertLink',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
                '|',
                'insertDynamicVariables'
            ],
            buttonsVisible: 18
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedAttrs: [
        'align', 'alt', 'background', 'bgcolor', 'border', 'cellpadding', 'cellspacing', 'checked', 'class', 'color',
        'cols', 'colspan', 'content', 'contenteditable', 'data', 'data-.*', 'datetime', 'disabled', 'form', 'height',
        'hidden', 'href', 'id', 'label', 'max', 'min', 'multiple', 'name', 'placeholder', 'radiogroup', 'readonly',
        'rel', 'required', 'rows', 'rowspan', 'selected', 'size', 'sizes', 'span', 'src', 'step', 'style', 'tabindex',
        'target', 'title', 'type', 'value', 'valign', 'width'
    ],
    tableEditButtons: [
        'tableRemove',
        'tableRows',
        'tableColumns',
        'tableBorder',
        'tableBackground',
        '-',
        'tableCells',
        'tableCellBackground',
        'tableCellBorder',
        'tableCellHorizontalAlign'
    ],
    /*
    imageUpload: true,
    imageAllowedTypes: ['jpeg', 'jpg', 'png'],
    imageMaxSize: 5 * 1024 * 1024, // 5MB
    imageUploadMethod: 'POST',
    imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageManager'],
    */
    imageInsertButtons: ['imageByURL'],
    imageDefaultDisplay: 'inline',
    imageEditButtons: ['imageReplace', 'imageRemove', 'imageSize'],
};
/* harmony default export */ __webpack_exports__.A = (config);


/***/ }),

/***/ 346:
/***/ (function(module) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),

/***/ 361:
/***/ (function(module) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),

/***/ 515:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);



var TicketPriorities = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(TicketPriorities, _super);
    function TicketPriorities() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ticketPriorities = [
            { id: 1, label: 'Basse', bgColor: '#e3e3e3', color: '#000' },
            { id: 2, label: 'Normale', bgColor: '', color: '' },
            { id: 3, label: 'Haute', bgColor: '', color: '' },
            { id: 4, label: 'Urgente', bgColor: '', color: '' }
        ];
        return _this;
    }
    TicketPriorities = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], TicketPriorities);
    return TicketPriorities;
}((vue__WEBPACK_IMPORTED_MODULE_1___default())));
/* harmony default export */ __webpack_exports__.A = (TicketPriorities);


/***/ }),

/***/ 564:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketItem_TicketItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketItem/TicketItem.vue?vue&type=template&id=473201e9
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ticket-item"},[_c('PageHeader',{attrs:{"page-title":_vm.pageTitle,"buttons":_vm.buttons,"buttonsOrder":3,"buttonsCols":12,"buttonsColsLg":12,"buttonsColsMd":12,"buttonsColsSm":12,"buttonsColsXl":12,"buttonsClass":{ 'text-center': false, 'text-sm-center': false, 'pl-3': true, 'pt-2': true }}},[_c('b-col'),_c('b-col',{staticClass:"mt-2 mt-lg-0",attrs:{"cols":"12","md":"auto"}},[_c('ul',{staticClass:"status-bar w-auto d-inline-block"},_vm._l((_vm.ticketStatus),function(status){return _c('li',{key:status.id,class:{
            selected: status.id === _vm.value?.status
          }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0)])],1),_c('AppMessages'),(_vm.team.is_root && _vm.value.team_id_admin)?_c('b-alert',{staticClass:"font-weight-bold",attrs:{"show":"","variant":"danger"}},[_c('p',{staticClass:"h5"},[_vm._v("Attention, client d'un revendeur !!!")]),_c('ul',{staticClass:"mb-0"},[_c('li',[_vm._v("Ne pas énumérer Kwixéo")]),_c('li',[_vm._v("Ne pas faire de copier/coller de lien avec kwixeo.fr")]),_c('li',[_vm._v("Pas de capture d'écran")])])]):_vm._e(),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"8","xxl":"9","order":"2","order-lg":"1"}},[(_vm.team.is_root)?_c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":"Échanges"}},[_c('TicketComments',{attrs:{"value":_vm.value},on:{"input":_vm.ticketUpdated}})],1),(_vm.can('admin-subscription', 1) && (_vm.value.customer?.admin_team_id || _vm.value.team_id_admin))?_c('b-tab',{attrs:{"title":"Abonnement","lazy":""}},[_c('TeamManagement',{attrs:{"value":{ id: _vm.value.team_id_admin ?? _vm.value.customer?.admin_team_id }}})],1):_vm._e()],1):_c('TicketComments',{attrs:{"value":_vm.value},on:{"input":_vm.ticketUpdated}})],1),_c('b-col',{staticClass:"mb-3 mb-lg-0",attrs:{"cols":"12","lg":"4","xxl":"3","order":"1","order-lg":"2"}},[_c('b-card',[_c('TicketItemInfos',{attrs:{"value":_vm.value},on:{"input":_vm.ticketUpdated}})],1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// external "@kwixeo/subscriptions-vue"
var subscriptions_vue_namespaceObject = require("@kwixeo/subscriptions-vue");
// EXTERNAL MODULE: ./src/mixins/TicketStatusMixin.ts
var TicketStatusMixin = __webpack_require__(5480);
// EXTERNAL MODULE: ./src/components/TicketItemInfos/TicketItemInfos.vue + 3 modules
var TicketItemInfos = __webpack_require__(9505);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketStatus/TicketStatus.vue?vue&type=template&id=87533f12
var TicketStatusvue_type_template_id_87533f12_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.continue'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.changeStatusMsg'))+" : "),_c('strong',[_vm._v(_vm._s(_vm.$t('tickets.ticket.status' + _vm.status)))]),_vm._v(" ? ")]],2)],1):_vm._e()
}
var TicketStatusvue_type_template_id_87533f12_staticRenderFns = []


;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketStatus/TicketStatus.ts?vue&type=script&lang=ts&external




var TicketClose = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketClose, _super);
    function TicketClose() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(TicketClose.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketClose.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('tickets.ticket.closed');
        },
        enumerable: false,
        configurable: true
    });
    TicketClose.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    TicketClose.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TicketClose.prototype.process = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwTickets.axios.put('/ticket/' + this.value.id, {
                                status: this.status
                            })
                                .then(function (response) {
                                _this.$emit('input', response.data);
                                _this.modalState = false;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketClose.prototype.closeModal = function () {
        this.$emit('closed');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketClose.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketClose.prototype, "status", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TicketClose.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketClose.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketClose.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketClose.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketClose.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketClose.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], TicketClose.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TicketClose.prototype, "watchModalState", null);
    TicketClose = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], TicketClose);
    return TicketClose;
}(lib/* Vue */.lD));
/* harmony default export */ var TicketStatusvue_type_script_lang_ts_external = (TicketClose);

;// ./src/components/TicketStatus/TicketStatus.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketStatus_TicketStatusvue_type_script_lang_ts_external = (TicketStatusvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketStatus/TicketStatus.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketStatus_TicketStatusvue_type_script_lang_ts_external,
  TicketStatusvue_type_template_id_87533f12_render,
  TicketStatusvue_type_template_id_87533f12_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketStatus = (component.exports);
// EXTERNAL MODULE: ./src/components/TicketDelete/TicketDelete.vue + 3 modules
var TicketDelete = __webpack_require__(729);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketMerge/TicketMerge.vue?vue&type=template&id=96dd54f4
var TicketMergevue_type_template_id_96dd54f4_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" "),_c('FormModal',{attrs:{"title":_vm.$t('tickets.ticket.mergeTitle'),"ok-title":_vm.$t('tickets.ticket.mergeBtn'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading,"size":"xl"},on:{"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[_c('k-form',{attrs:{"action":'/ticket/' + _vm.value.id + '/merge',"method":"PUT"},on:{"submitComplete":_vm.submitComplete}},[_c('k-form-checkbox',{staticClass:"mb-3",model:{value:(_vm.sameContact),callback:function ($$v) {_vm.sameContact=$$v},expression:"sameContact"}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.mergeSameContact'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.mergeDestination')}},[_c('input',{attrs:{"type":"hidden","name":"id"},domProps:{"value":_vm.ticket ? _vm.ticket.id : null}}),_c('k-form-select',{attrs:{"ajax":"/ticket","ajaxDatas":_vm.ajaxDatas,"getOptionLabel":_vm.getOptionLabel,"label":"fullname","required":""},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}})],1)],1),_c('b-alert',{staticClass:"mt-3 mb-0",attrs:{"show":"","variant":"danger"}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.mergeExplain1'))+" ")]),_c('span',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.mergeExplain2'))+" ")])])],1)],1):_vm._e()
}
var TicketMergevue_type_template_id_96dd54f4_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketMerge/TicketMerge.ts?vue&type=script&lang=ts&external





var TicketMerge = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketMerge, _super);
    function TicketMerge() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        _this.sameContact = true;
        _this.ticket = null;
        return _this;
    }
    Object.defineProperty(TicketMerge.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketMerge.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('tickets.ticket.mergeTitle');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketMerge.prototype, "ajaxDatas", {
        get: function () {
            var _a, _b;
            var filter = {
                exclude: this.value.id
            };
            if (this.sameContact) {
                var ids = [];
                if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.customer_id) {
                    ids.push(this.value.customer_id);
                }
                if ((_b = this.value) === null || _b === void 0 ? void 0 : _b.contact_id) {
                    ids.push(this.value.contact_id);
                }
                filter.customer_or_contact = ids;
            }
            return {
                sort: 'created_at:desc',
                filter: filter
            };
        },
        enumerable: false,
        configurable: true
    });
    TicketMerge.prototype.getOptionLabel = function (ticket) {
        var label = '';
        if (ticket.reference) {
            label += '[' + ticket.reference + '] ';
        }
        return label + this.datetime(ticket.created_at) + ' - ' + ticket.subject;
    };
    TicketMerge.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    TicketMerge.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TicketMerge.prototype.submitComplete = function (response) {
        return response.data;
    };
    TicketMerge.prototype.closeModal = function () {
        this.$emit('closed');
    };
    TicketMerge.prototype.canceled = function () {
        this.$emit('canceled');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketMerge.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TicketMerge.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketMerge.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketMerge.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketMerge.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketMerge.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketMerge.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], TicketMerge.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TicketMerge.prototype, "watchModalState", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Emit */.O5)('merged')
    ], TicketMerge.prototype, "submitComplete", null);
    TicketMerge = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BAlert: external_bootstrap_vue_.BAlert, BFormGroup: external_bootstrap_vue_.BFormGroup,
                Spinner: interface_vue_.Spinner, FormModal: interface_vue_.FormModal,
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormCheckbox: form_vue_.KFormCheckbox
            }
        })
    ], TicketMerge);
    return TicketMerge;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var TicketMergevue_type_script_lang_ts_external = (TicketMerge);

;// ./src/components/TicketMerge/TicketMerge.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketMerge_TicketMergevue_type_script_lang_ts_external = (TicketMergevue_type_script_lang_ts_external); 
;// ./src/components/TicketMerge/TicketMerge.vue





/* normalize component */
;
var TicketMerge_component = (0,componentNormalizer/* default */.A)(
  TicketMerge_TicketMergevue_type_script_lang_ts_external,
  TicketMergevue_type_template_id_96dd54f4_render,
  TicketMergevue_type_template_id_96dd54f4_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketMerge_TicketMerge = (TicketMerge_component.exports);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketComments/TicketComments.vue?vue&type=template&id=74f1fe8c
var TicketCommentsvue_type_template_id_74f1fe8c_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"ticket-item-card"},[(_vm.can('tickets', 3))?_c('p',[_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){_vm.addComment = true}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.reply'))+" ")]),_c('b-button',{staticClass:"ml-4",attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){_vm.addNote = true}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.addComment'))+" ")])],1):_vm._e(),_c('b-card',[_c('p',{staticClass:"mb-2"},[_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.view === 0 ? 'secondary' : 'light',"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.view = 0}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.all'))+" ("+_vm._s(_vm.totals)+") ")]),_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.view === 1 ? 'secondary' : 'light',"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.view = 1}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.messages'))+" ("+_vm._s(_vm.totalMessages)+") ")]),_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.view === 2 ? 'secondary' : 'light',"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.view = 2}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.comments'))+" ("+_vm._s(_vm.totalComments)+") ")]),_c('b-button',{staticClass:"mr-2",attrs:{"variant":_vm.view === 3 ? 'secondary' : 'light',"size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.view = 3}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.history'))+" ("+_vm._s(_vm.totalHistorics)+") ")])],1),_c('div',{staticClass:"ticket-comments"},[(_vm.loadingComment)?_c('Spinner'):(_vm.filteredComments.length === 0)?_c('div',{staticClass:"text-center p-4"},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.noElements'))+" ")]):_vm._l((_vm.filteredComments),function(comment,i){return [(comment.is_historic && _vm.showCommentDate(i))?_c('div',{key:'date' + i,staticClass:"historic-date"},[(comment.team_user)?_c('Avatar',{attrs:{"size":"2rem","team-user":comment.team_user}}):_vm._e(),_vm._v(" "+_vm._s(_vm.datetime(comment.created_at))+" ")],1):_vm._e(),_c('CommentItem',{key:i,attrs:{"ticket-id":_vm.value.id,"ticket":_vm.value},on:{"deleted":function($event){return _vm.commentDeleted(i)}},model:{value:(_vm.comments[comment.index]),callback:function ($$v) {_vm.$set(_vm.comments, comment.index, $$v)},expression:"comments[comment.index]"}})]}),(_vm.totals > _vm.perPage)?_c('b-pagination',{staticClass:"mt-4",attrs:{"size":"sm","align":"center","total-rows":_vm.totals,"per-page":_vm.perPage},model:{value:(_vm.page),callback:function ($$v) {_vm.page=$$v},expression:"page"}}):_vm._e()],2),_c('CommentForm',{attrs:{"modal":_vm.addComment || _vm.addNote,"is-note":_vm.addNote,"ticket-id":_vm.value.id,"ticket":_vm.value},on:{"hidden":function($event){_vm.addComment = false; _vm.addNote = false},"submitted":_vm.commentAdded}})],1)],1)
}
var TicketCommentsvue_type_template_id_74f1fe8c_staticRenderFns = []


// EXTERNAL MODULE: ./src/components/CommentItem/CommentItem.vue + 3 modules
var CommentItem = __webpack_require__(3335);
// EXTERNAL MODULE: ./src/components/CommentForm/CommentForm.vue + 5 modules
var CommentForm = __webpack_require__(6090);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketComments/TicketComments.ts?vue&type=script&lang=ts&external







var TicketComments = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketComments, _super);
    function TicketComments() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addComment = false;
        _this.addNote = false;
        _this.totals = 0;
        _this.totalMessages = 0;
        _this.totalComments = 0;
        _this.totalHistorics = 0;
        _this.view = 0;
        _this.loadingComment = false;
        _this.page = 1;
        _this.perPage = 100;
        _this.comments = [];
        return _this;
    }
    TicketComments.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadComments()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TicketComments.prototype, "filteredComments", {
        get: function () {
            var comments = this.comments.map(function (comment, i) {
                comment.index = i;
                return comment;
            });
            switch (this.view) {
                case 1:
                    return comments.filter(function (comment) { return !comment.is_note && !comment.is_historic; });
                case 2:
                    return comments.filter(function (comment) { return comment.is_note; });
                case 3:
                    return comments.filter(function (comment) { return comment.is_historic; });
                default:
                    return comments;
            }
        },
        enumerable: false,
        configurable: true
    });
    TicketComments.prototype.watchPage = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0: return [4 /*yield*/, this.loadComments()];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketComments.prototype.loadComments = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loadingComment = true;
                        return [4 /*yield*/, this.$kwTickets.axios.get('/ticket/' + this.value.id + '/comment', {
                                params: {
                                    per_page: this.perPage,
                                    page: this.page,
                                    sort: ['datetime:desc', 'is_historic:asc'],
                                    include: 'teamUser,files',
                                    with_file: 1
                                }
                            })
                                .then(function (response) {
                                var data = response.data;
                                var comments = data.data;
                                _this.comments = comments;
                                _this.totals = data.meta.total;
                                _this.totalMessages = comments.filter(function (comment) { return !comment.is_note && !comment.is_historic; }).length;
                                _this.totalComments = comments.filter(function (comment) { return comment.is_note; }).length;
                                _this.totalHistorics = comments.filter(function (comment) { return comment.is_historic; }).length;
                                _this.loadingComment = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketComments.prototype.commentAdded = function (comment) {
        this.comments.unshift(comment);
        this.$emit('input', comment.ticket);
    };
    TicketComments.prototype.commentDeleted = function (index) {
        lib/* Vue */.lD.delete(this.comments, index);
    };
    TicketComments.prototype.showCommentDate = function (index) {
        var previousIndex = index - 1;
        if (previousIndex < 0) {
            return true;
        }
        var previous = this.comments[previousIndex];
        var comment = this.comments[index];
        return !previous.is_historic || (previous.created_at.substr(0, 16) !== comment.created_at.substr(0, 16)
            && previous.team_user_id === comment.team_user_id);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketComments.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value'),
        (0,lib/* Watch */.ox)('page')
    ], TicketComments.prototype, "watchPage", null);
    TicketComments = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner, Avatar: interface_vue_.Avatar,
                BButton: external_bootstrap_vue_.BButton, BCard: external_bootstrap_vue_.BCard, BPagination: external_bootstrap_vue_.BPagination,
                CommentItem: CommentItem/* default */.A,
                CommentForm: CommentForm/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team', 'teamUser', 'can']))
        })
    ], TicketComments);
    return TicketComments;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var TicketCommentsvue_type_script_lang_ts_external = (TicketComments);

;// ./src/components/TicketComments/TicketComments.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketComments_TicketCommentsvue_type_script_lang_ts_external = (TicketCommentsvue_type_script_lang_ts_external); 
;// ./src/components/TicketComments/TicketComments.vue





/* normalize component */
;
var TicketComments_component = (0,componentNormalizer/* default */.A)(
  TicketComments_TicketCommentsvue_type_script_lang_ts_external,
  TicketCommentsvue_type_template_id_74f1fe8c_render,
  TicketCommentsvue_type_template_id_74f1fe8c_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketComments_TicketComments = (TicketComments_component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketItem/TicketItem.ts?vue&type=script&lang=ts&external












var TicketItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketItem, _super);
    function TicketItem() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TicketItem.prototype, "buttons", {
        get: function () {
            var _this = this;
            var buttons = [];
            if (this.can('tickets', 3)) {
                if (this.value.status === 2) {
                    buttons.push({
                        component: TicketStatus,
                        attributes: {
                            value: this.value,
                            status: 3,
                            label: 'Marquer comme "Répondu"'
                        },
                        events: {
                            input: function (ticket) { return _this.$emit('input', ticket); }
                        }
                    });
                }
                if (this.value.status === 3) {
                    buttons.push({
                        component: TicketStatus,
                        attributes: {
                            value: this.value,
                            status: 2,
                            label: 'Marquer comme "À traiter / En cours"'
                        },
                        events: {
                            input: function (ticket) { return _this.$emit('input', ticket); }
                        }
                    });
                }
                if (this.value.status === 4) {
                    buttons.push({
                        component: TicketStatus,
                        attributes: {
                            value: this.value,
                            status: 2,
                            label: 'Réouvrir le ticket'
                        },
                        events: {
                            deleted: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, Promise, function () {
                                return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                    switch (_a.label) {
                                        case 0: return [4 /*yield*/, this.$router.push({ name: 'tickets-list' })];
                                        case 1:
                                            _a.sent();
                                            return [2 /*return*/];
                                    }
                                });
                            }); }
                        }
                    });
                }
                if (this.value.status < 4) {
                    buttons.push({
                        component: TicketStatus,
                        attributes: {
                            value: this.value,
                            status: 4,
                            label: 'Clôturer'
                        },
                        events: {
                            input: function (ticket) { return _this.$emit('input', ticket); }
                        }
                    });
                }
            }
            if (this.can('tickets', 4)) {
                buttons.push({
                    items: [
                        {
                            component: TicketMerge_TicketMerge,
                            attributes: {
                                element: 'dropdown',
                                value: this.value
                            },
                            events: {
                                merged: function (ticket) { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, Promise, function () {
                                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.$router.push({ name: 'tickets-item', params: { id: String(ticket.id) } })];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }
                            }
                        },
                        {
                            component: TicketDelete/* default */.A,
                            attributes: {
                                element: 'dropdown',
                                value: this.value
                            },
                            events: {
                                deleted: function () { return (0,tslib_es6/* __awaiter */.sH)(_this, void 0, Promise, function () {
                                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                                        switch (_a.label) {
                                            case 0: return [4 /*yield*/, this.$router.push({ name: 'tickets-list' })];
                                            case 1:
                                                _a.sent();
                                                return [2 /*return*/];
                                        }
                                    });
                                }); }
                            }
                        }
                    ]
                });
            }
            return buttons;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketItem.prototype, "pageTitle", {
        get: function () {
            var title = '';
            if (this.value.reference) {
                title += this.value.reference + ' - ';
            }
            return title + this.value.subject;
        },
        enumerable: false,
        configurable: true
    });
    TicketItem.prototype.ticketUpdated = function (ticket) {
        this.$emit('input', ticket);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketItem.prototype, "value", void 0);
    TicketItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PageHeader: interface_vue_.PageHeader, Spinner: interface_vue_.Spinner, Avatar: interface_vue_.Avatar, AppMessages: interface_vue_.AppMessages,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BCard: external_bootstrap_vue_.BCard, BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab, BAlert: external_bootstrap_vue_.BAlert,
                TicketItemInfos: TicketItemInfos/* default */.A, TicketComments: TicketComments_TicketComments,
                TeamManagement: subscriptions_vue_namespaceObject.TeamManagement
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['team', 'teamUser', 'can']))
        })
    ], TicketItem);
    return TicketItem;
}((0,lib/* Mixins */.Xe)(TicketStatusMixin/* default */.A)));
/* harmony default export */ var TicketItemvue_type_script_lang_ts_external = (TicketItem);

;// ./src/components/TicketItem/TicketItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketItem_TicketItemvue_type_script_lang_ts_external = (TicketItemvue_type_script_lang_ts_external); 
;// ./src/components/TicketItem/TicketItem.vue





/* normalize component */
;
var TicketItem_component = (0,componentNormalizer/* default */.A)(
  TicketItem_TicketItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketItem_TicketItem = (TicketItem_component.exports);

/***/ }),

/***/ 622:
/***/ (function(module) {

"use strict";
module.exports = require("vue");

/***/ }),

/***/ 641:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseFor = __webpack_require__(6649),
    keys = __webpack_require__(5950);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),

/***/ 650:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ TicketItemView_TicketItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TicketItemView/TicketItemView.vue?vue&type=template&id=011ff6be
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('TicketItem',{on:{"input":data => _vm.ticket = data},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/fetchDatas/ticket.ts
var ticket = __webpack_require__(6886);
// EXTERNAL MODULE: ./src/components/TicketItem/TicketItem.vue + 16 modules
var TicketItem = __webpack_require__(564);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/TicketItemView/TicketItemView.ts?vue&type=script&lang=ts&external






var TicketItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketItemView, _super);
    function TicketItemView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.ticket = null;
        return _this;
    }
    TicketItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                TicketItem: TicketItem/* default */.A
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0,ticket/* fetchTicket */.vA)(to.params.id)
                                    .then(function (ticket) {
                                    next(function (vm) {
                                        vm.ticket = ticket;
                                        vm.loading = false;
                                    });
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.loading = true;
                                this.ticket = null;
                                return [4 /*yield*/, (0,ticket/* fetchTicket */.vA)(to.params.id)
                                        .then(function (ticket) {
                                        _this.ticket = ticket;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], TicketItemView);
    return TicketItemView;
}((external_vue_default())));
/* harmony default export */ var TicketItemViewvue_type_script_lang_ts_external = (TicketItemView);

;// ./src/views/TicketItemView/TicketItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketItemView_TicketItemViewvue_type_script_lang_ts_external = (TicketItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TicketItemView/TicketItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketItemView_TicketItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketItemView_TicketItemView = (component.exports);

/***/ }),

/***/ 659:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),

/***/ 695:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseTimes = __webpack_require__(8096),
    isArguments = __webpack_require__(2428),
    isArray = __webpack_require__(6449),
    isBuffer = __webpack_require__(3656),
    isIndex = __webpack_require__(361),
    isTypedArray = __webpack_require__(7167);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),

/***/ 729:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketDelete_TicketDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketDelete/TicketDelete.vue?vue&type=template&id=6404dc1c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.deleteMsg'))+" ")]],2)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketDelete/TicketDelete.ts?vue&type=script&lang=ts&external




var TicketDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketDelete, _super);
    function TicketDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(TicketDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    TicketDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    TicketDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TicketDelete.prototype.process = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwTickets.axios.delete('/ticket/' + this.value.id)
                                .then(function () {
                                _this.$emit('deleted');
                                _this.modalState = false;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TicketDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], TicketDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TicketDelete.prototype, "watchModalState", null);
    TicketDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], TicketDelete);
    return TicketDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var TicketDeletevue_type_script_lang_ts_external = (TicketDelete);

;// ./src/components/TicketDelete/TicketDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketDelete_TicketDeletevue_type_script_lang_ts_external = (TicketDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketDelete/TicketDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketDelete_TicketDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketDelete_TicketDelete = (component.exports);

/***/ }),

/***/ 735:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TemplatesList_TemplatesList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TemplatesList/TemplatesList.vue?vue&type=template&id=711e97d1
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":"/ticket/template","createTitle":_vm.$t('tickets.templates.createTitle'),"updateTitle":_vm.$t('tickets.templates.editTitle'),"deleteMsg":_vm.$t('tickets.templates.deleteMsg'),"columns":_vm.columns,"sort":"label","modalSize":"xl"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TemplatesList/TemplatesList.ts?vue&type=script&lang=ts&external



var TemplatesList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TemplatesList, _super);
    function TemplatesList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TemplatesList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('tickets.templates.label'),
                    key: 'label',
                    required: true
                },
                {
                    label: this.$t('tickets.templates.message'),
                    key: 'message',
                    required: true,
                    hideOnList: false,
                    type: 'editor'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    TemplatesList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], TemplatesList);
    return TemplatesList;
}(lib/* Vue */.lD));
/* harmony default export */ var TemplatesListvue_type_script_lang_ts_external = (TemplatesList);

;// ./src/components/TemplatesList/TemplatesList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TemplatesList_TemplatesListvue_type_script_lang_ts_external = (TemplatesListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TemplatesList/TemplatesList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TemplatesList_TemplatesListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TemplatesList_TemplatesList = (component.exports);

/***/ }),

/***/ 906:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f067';
var svgPathData = 'M416 208H272V64c0-17.67-14.33-32-32-32h-32c-17.67 0-32 14.33-32 32v144H32c-17.67 0-32 14.33-32 32v32c0 17.67 14.33 32 32 32h144v144c0 17.67 14.33 32 32 32h32c17.67 0 32-14.33 32-32V304h144c17.67 0 32-14.33 32-32v-32c0-17.67-14.33-32-32-32z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.QL = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 909:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseForOwn = __webpack_require__(641),
    createBaseEach = __webpack_require__(8329);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),

/***/ 1017:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ MyTicketItemView_MyTicketItemView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/MyTicketItemView/MyTicketItemView.vue?vue&type=template&id=07958be6
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('MyTicketItem',{on:{"input":data => _vm.ticket = data},model:{value:(_vm.ticket),callback:function ($$v) {_vm.ticket=$$v},expression:"ticket"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/fetchDatas/myTicket.ts
var myTicket = __webpack_require__(7124);
// EXTERNAL MODULE: ./src/components/MyTicketItem/MyTicketItem.vue + 3 modules
var MyTicketItem = __webpack_require__(4501);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/views/MyTicketItemView/MyTicketItemView.ts?vue&type=script&lang=ts&external






var MyTicketItemView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MyTicketItemView, _super);
    function MyTicketItemView() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = true;
        _this.ticket = null;
        return _this;
    }
    MyTicketItemView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                MyTicketItem: MyTicketItem/* default */.A
            },
            beforeRouteEnter: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0: return [4 /*yield*/, (0,myTicket/* fetchMyTicket */.HR)(to.params.id)
                                    .then(function (ticket) {
                                    next(function (vm) {
                                        vm.ticket = ticket;
                                        vm.loading = false;
                                    });
                                })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            },
            beforeRouteUpdate: function (to, from, next) {
                return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
                    var _this = this;
                    return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                this.loading = true;
                                this.ticket = null;
                                return [4 /*yield*/, (0,myTicket/* fetchMyTicket */.HR)(to.params.id)
                                        .then(function (ticket) {
                                        _this.ticket = ticket;
                                        _this.loading = false;
                                        next();
                                    })];
                            case 1:
                                _a.sent();
                                return [2 /*return*/];
                        }
                    });
                });
            }
        })
    ], MyTicketItemView);
    return MyTicketItemView;
}((external_vue_default())));
/* harmony default export */ var MyTicketItemViewvue_type_script_lang_ts_external = (MyTicketItemView);

;// ./src/views/MyTicketItemView/MyTicketItemView.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MyTicketItemView_MyTicketItemViewvue_type_script_lang_ts_external = (MyTicketItemViewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/MyTicketItemView/MyTicketItemView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  MyTicketItemView_MyTicketItemViewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MyTicketItemView_MyTicketItemView = (component.exports);

/***/ }),

/***/ 1229:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_TagsListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TagsListView.vue?vue&type=template&id=c2e27518
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TagsList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/TagsList/TagsList.vue + 3 modules
var TagsList = __webpack_require__(6553);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TagsListView.vue?vue&type=script&lang=ts



var TagsListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TagsListView, _super);
    function TagsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TagsListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TagsList: TagsList/* default */.A
            }
        })
    ], TagsListView);
    return TagsListView;
}(lib/* Vue */.lD));
/* harmony default export */ var TagsListViewvue_type_script_lang_ts = (TagsListView);

;// ./src/views/TagsListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TagsListViewvue_type_script_lang_ts = (TagsListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TagsListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_TagsListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TagsListView = (component.exports);

/***/ }),

/***/ 1377:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'comments-alt';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f4b6';
var svgPathData = 'M416 224V64c0-35.3-28.7-64-64-64H64C28.7 0 0 28.7 0 64v160c0 35.3 28.7 64 64 64v54.2c0 8 9.1 12.6 15.5 7.8l82.8-62.1H352c35.3.1 64-28.6 64-63.9zm96-64h-64v64c0 52.9-43.1 96-96 96H192v64c0 35.3 28.7 64 64 64h125.7l82.8 62.1c6.4 4.8 15.5.2 15.5-7.8V448h32c35.3 0 64-28.7 64-64V224c0-35.3-28.7-64-64-64z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.$P = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 1416:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Mailbox_Mailbox; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Mailbox/Mailbox.vue?vue&type=template&id=b4630c5c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('h2',{staticClass:"form-title-alt mt-0"},[_vm._v(" "+_vm._s(_vm.$t('tickets.mailbox.treatment'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.whenMailLoaded')}},[_c('b-form-radio-group',{staticClass:"mt-1",attrs:{"name":"configs[tickets_mail_delete]","options":_vm.deleteActions},model:{value:(_vm.localConfig.tickets_mail_delete),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_mail_delete", $$v)},expression:"localConfig.tickets_mail_delete"}})],1),( false)?0:_vm._e(),_c('b-alert',{staticClass:"mt-5",attrs:{"variant":"warning","show":""}},[_c('p',[_vm._v(" "+_vm._s(_vm.$t('tickets.mailbox.explain1'))+" ")]),_vm._v(" "+_vm._s(_vm.$t('tickets.mailbox.explain2'))+" "),_c('ul',{staticClass:"mb-0"},[_c('li',[_c('strong',[_vm._v(_vm._s(_vm.$t('tickets.mailbox.explain3')))]),_c('br'),_vm._v(" "+_vm._s(_vm.$t('tickets.mailbox.explain4'))+" ")]),_c('li',{staticClass:"mt-3"},[_c('strong',[_vm._v(_vm._s(_vm.$t('tickets.mailbox.explain5')))]),_c('br'),_vm._v(" "+_vm._s(_vm.$t('tickets.mailbox.explain6'))+" ")])])]),_c('h2',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('tickets.mailbox.mailReceipt'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverType')}},[_c('k-form-select',{attrs:{"name":"configs[tickets_mail_mode]","options":_vm.receiptTypes,"reduce":opt => opt.value,"required":"","clearable":false},model:{value:(_vm.localConfig.tickets_mail_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_mail_mode", $$v)},expression:"localConfig.tickets_mail_mode"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverAddress')}},[_c('k-form-input',{attrs:{"name":"configs[tickets_mail_server]","validate":"url","required":""},model:{value:(_vm.localConfig.tickets_mail_server),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_mail_server", $$v)},expression:"localConfig.tickets_mail_server"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverSecurity')}},[_c('k-form-select',{attrs:{"name":"configs[tickets_mail_security]","options":_vm.serveurSecurities,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.localConfig.tickets_mail_security),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_mail_security", $$v)},expression:"localConfig.tickets_mail_security"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverPort')}},[_c('k-form-number',{attrs:{"name":"configs[tickets_mail_port]","maxDecimal":0,"min":1,"noDefaultValue":"","required":""},model:{value:(_vm.localConfig.tickets_mail_port),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_mail_port", $$v)},expression:"localConfig.tickets_mail_port"}})],1)],1)],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverLogin')}},[_c('k-form-input',{attrs:{"name":"configs[tickets_mail_login]","required":""},model:{value:(_vm.localConfig.tickets_mail_login),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_mail_login", $$v)},expression:"localConfig.tickets_mail_login"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverPassword')}},[_c('k-form-input',{attrs:{"name":"configs[tickets_mail_password]","type":"password","required":"","automaticRules":false},model:{value:(_vm.localConfig.tickets_mail_password),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_mail_password", $$v)},expression:"localConfig.tickets_mail_password"}})],1)],1)],1),_c('h2',{staticClass:"form-title-alt mt-5"},[_vm._v(" "+_vm._s(_vm.$t('tickets.mailbox.mailSend'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.emailAddress')}},[_c('k-form-input',{attrs:{"name":"configs[tickets_smtp_email]","validate":"email","required":""},model:{value:(_vm.localConfig.tickets_smtp_email),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_smtp_email", $$v)},expression:"localConfig.tickets_smtp_email"}})],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","lg":"8"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.smtpAddress')}},[_c('k-form-input',{attrs:{"name":"configs[tickets_smtp_server]","validate":"url","required":""},model:{value:(_vm.localConfig.tickets_smtp_server),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_smtp_server", $$v)},expression:"localConfig.tickets_smtp_server"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverSecurity')}},[_c('k-form-select',{attrs:{"name":"configs[tickets_smtp_security]","options":_vm.serveurSecurities,"reduce":opt => opt.value,"clearable":false,"required":""},model:{value:(_vm.localConfig.tickets_smtp_security),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_smtp_security", $$v)},expression:"localConfig.tickets_smtp_security"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6","lg":"2"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverPort')}},[_c('k-form-number',{attrs:{"name":"configs[tickets_smtp_port]","maxDecimal":0,"min":1,"noDefaultValue":"","required":""},model:{value:(_vm.localConfig.tickets_smtp_port),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_smtp_port", $$v)},expression:"localConfig.tickets_smtp_port"}})],1)],1)],1),_c('b-row',[_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverLogin')}},[_c('k-form-input',{attrs:{"name":"configs[tickets_smtp_login]","required":""},model:{value:(_vm.localConfig.tickets_smtp_login),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_smtp_login", $$v)},expression:"localConfig.tickets_smtp_login"}})],1)],1),_c('b-col',{attrs:{"cols":"12","md":"6"}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.mailbox.serverPassword')}},[_c('k-form-input',{attrs:{"name":"configs[tickets_smtp_password]","type":"password","required":"","automaticRules":false},model:{value:(_vm.localConfig.tickets_smtp_password),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_smtp_password", $$v)},expression:"localConfig.tickets_smtp_password"}})],1)],1)],1),_c('p',{staticClass:"mt-4 mb-0"}),_c('b-button',{staticClass:"mr-3",attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Mailbox/Mailbox.ts?vue&type=script&lang=ts&external





var Mailbox = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Mailbox, _super);
    function Mailbox() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.receiptTypes = [
            { value: 'pop3', label: 'POP3' },
            { value: 'imap', label: 'IMAP' }
        ];
        _this.serveurSecurities = [
            { value: 'none', label: _this.$t('tickets.mailbox.none') },
            { value: 'ssl', label: 'SSL' },
            { value: 'tls', label: 'TLS' }
        ];
        _this.deleteActions = [
            { value: false, text: _this.$t('tickets.mailbox.markAsRead') },
            { value: true, text: _this.$t('tickets.mailbox.deleteMail') }
        ];
        _this.customerModes = [
            { value: true, text: _this.$t('tickets.mailbox.createTicket') },
            { value: false, text: _this.$t('tickets.mailbox.dontCreateTicket') }
        ];
        return _this;
    }
    Mailbox = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAlert: external_bootstrap_vue_.BAlert, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup,
                KForm: form_vue_.KForm, KFormStickyBar: form_vue_.KFormStickyBar, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormEditor: form_vue_.KFormEditor,
                TeamUserSelect: interface_vue_.TeamUserSelect
            }
        })
    ], Mailbox);
    return Mailbox;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var Mailboxvue_type_script_lang_ts_external = (Mailbox);

;// ./src/components/Mailbox/Mailbox.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Mailbox_Mailboxvue_type_script_lang_ts_external = (Mailboxvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Mailbox/Mailbox.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Mailbox_Mailboxvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Mailbox_Mailbox = (component.exports);

/***/ }),

/***/ 1635:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   C6: function() { return /* binding */ __extends; },
/* harmony export */   Cg: function() { return /* binding */ __decorate; },
/* harmony export */   Cl: function() { return /* binding */ __assign; },
/* harmony export */   YH: function() { return /* binding */ __generator; },
/* harmony export */   aN: function() { return /* binding */ __spreadArrays; },
/* harmony export */   sH: function() { return /* binding */ __awaiter; }
/* harmony export */ });
/* unused harmony exports __rest, __param, __esDecorate, __runInitializers, __propKey, __setFunctionName, __metadata, __createBinding, __exportStar, __values, __read, __spread, __spreadArray, __await, __asyncGenerator, __asyncDelegator, __asyncValues, __makeTemplateObject, __importStar, __importDefault, __classPrivateFieldGet, __classPrivateFieldSet, __classPrivateFieldIn, __addDisposableResource, __disposeResources, __rewriteRelativeImportExtension */
/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */

var extendStatics = function(d, b) {
  extendStatics = Object.setPrototypeOf ||
      ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
      function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
  return extendStatics(d, b);
};

function __extends(d, b) {
  if (typeof b !== "function" && b !== null)
      throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
  extendStatics(d, b);
  function __() { this.constructor = d; }
  d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign = function() {
  __assign = Object.assign || function __assign(t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
          s = arguments[i];
          for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
  }
  return __assign.apply(this, arguments);
}

function __rest(s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
      t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function")
      for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
          if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
              t[p[i]] = s[p[i]];
      }
  return t;
}

function __decorate(decorators, target, key, desc) {
  var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
  else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
}

function __param(paramIndex, decorator) {
  return function (target, key) { decorator(target, key, paramIndex); }
}

function __esDecorate(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
  function accept(f) { if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected"); return f; }
  var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
  var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
  var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
  var _, done = false;
  for (var i = decorators.length - 1; i >= 0; i--) {
      var context = {};
      for (var p in contextIn) context[p] = p === "access" ? {} : contextIn[p];
      for (var p in contextIn.access) context.access[p] = contextIn.access[p];
      context.addInitializer = function (f) { if (done) throw new TypeError("Cannot add initializers after decoration has completed"); extraInitializers.push(accept(f || null)); };
      var result = (0, decorators[i])(kind === "accessor" ? { get: descriptor.get, set: descriptor.set } : descriptor[key], context);
      if (kind === "accessor") {
          if (result === void 0) continue;
          if (result === null || typeof result !== "object") throw new TypeError("Object expected");
          if (_ = accept(result.get)) descriptor.get = _;
          if (_ = accept(result.set)) descriptor.set = _;
          if (_ = accept(result.init)) initializers.unshift(_);
      }
      else if (_ = accept(result)) {
          if (kind === "field") initializers.unshift(_);
          else descriptor[key] = _;
      }
  }
  if (target) Object.defineProperty(target, contextIn.name, descriptor);
  done = true;
};

function __runInitializers(thisArg, initializers, value) {
  var useValue = arguments.length > 2;
  for (var i = 0; i < initializers.length; i++) {
      value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
  }
  return useValue ? value : void 0;
};

function __propKey(x) {
  return typeof x === "symbol" ? x : "".concat(x);
};

function __setFunctionName(f, name, prefix) {
  if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
  return Object.defineProperty(f, "name", { configurable: true, value: prefix ? "".concat(prefix, " ", name) : name });
};

function __metadata(metadataKey, metadataValue) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}

function __awaiter(thisArg, _arguments, P, generator) {
  function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
  return new (P || (P = Promise))(function (resolve, reject) {
      function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
      function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
      function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
      step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
}

function __generator(thisArg, body) {
  var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
  return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
  function verb(n) { return function (v) { return step([n, v]); }; }
  function step(op) {
      if (f) throw new TypeError("Generator is already executing.");
      while (g && (g = 0, op[0] && (_ = 0)), _) try {
          if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
          if (y = 0, t) op = [op[0] & 2, t.value];
          switch (op[0]) {
              case 0: case 1: t = op; break;
              case 4: _.label++; return { value: op[1], done: false };
              case 5: _.label++; y = op[1]; op = [0]; continue;
              case 7: op = _.ops.pop(); _.trys.pop(); continue;
              default:
                  if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                  if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                  if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                  if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                  if (t[2]) _.ops.pop();
                  _.trys.pop(); continue;
          }
          op = body.call(thisArg, _);
      } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
      if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
  }
}

var __createBinding = Object.create ? (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  var desc = Object.getOwnPropertyDescriptor(m, k);
  if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
  }
  Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
  if (k2 === undefined) k2 = k;
  o[k2] = m[k];
});

function __exportStar(m, o) {
  for (var p in m) if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) __createBinding(o, m, p);
}

function __values(o) {
  var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
  if (m) return m.call(o);
  if (o && typeof o.length === "number") return {
      next: function () {
          if (o && i >= o.length) o = void 0;
          return { value: o && o[i++], done: !o };
      }
  };
  throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read(o, n) {
  var m = typeof Symbol === "function" && o[Symbol.iterator];
  if (!m) return o;
  var i = m.call(o), r, ar = [], e;
  try {
      while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
  }
  catch (error) { e = { error: error }; }
  finally {
      try {
          if (r && !r.done && (m = i["return"])) m.call(i);
      }
      finally { if (e) throw e.error; }
  }
  return ar;
}

/** @deprecated */
function __spread() {
  for (var ar = [], i = 0; i < arguments.length; i++)
      ar = ar.concat(__read(arguments[i]));
  return ar;
}

/** @deprecated */
function __spreadArrays() {
  for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
  for (var r = Array(s), k = 0, i = 0; i < il; i++)
      for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
          r[k] = a[j];
  return r;
}

function __spreadArray(to, from, pack) {
  if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
      if (ar || !(i in from)) {
          if (!ar) ar = Array.prototype.slice.call(from, 0, i);
          ar[i] = from[i];
      }
  }
  return to.concat(ar || Array.prototype.slice.call(from));
}

function __await(v) {
  return this instanceof __await ? (this.v = v, this) : new __await(v);
}

function __asyncGenerator(thisArg, _arguments, generator) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var g = generator.apply(thisArg, _arguments || []), i, q = [];
  return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function () { return this; }, i;
  function awaitReturn(f) { return function (v) { return Promise.resolve(v).then(f, reject); }; }
  function verb(n, f) { if (g[n]) { i[n] = function (v) { return new Promise(function (a, b) { q.push([n, v, a, b]) > 1 || resume(n, v); }); }; if (f) i[n] = f(i[n]); } }
  function resume(n, v) { try { step(g[n](v)); } catch (e) { settle(q[0][3], e); } }
  function step(r) { r.value instanceof __await ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r); }
  function fulfill(value) { resume("next", value); }
  function reject(value) { resume("throw", value); }
  function settle(f, v) { if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]); }
}

function __asyncDelegator(o) {
  var i, p;
  return i = {}, verb("next"), verb("throw", function (e) { throw e; }), verb("return"), i[Symbol.iterator] = function () { return this; }, i;
  function verb(n, f) { i[n] = o[n] ? function (v) { return (p = !p) ? { value: __await(o[n](v)), done: false } : f ? f(v) : v; } : f; }
}

function __asyncValues(o) {
  if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
  var m = o[Symbol.asyncIterator], i;
  return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
  function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
  function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
}

function __makeTemplateObject(cooked, raw) {
  if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
  return cooked;
};

var __setModuleDefault = Object.create ? (function(o, v) {
  Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
  o["default"] = v;
};

var ownKeys = function(o) {
  ownKeys = Object.getOwnPropertyNames || function (o) {
    var ar = [];
    for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
    return ar;
  };
  return ownKeys(o);
};

function __importStar(mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
  __setModuleDefault(result, mod);
  return result;
}

function __importDefault(mod) {
  return (mod && mod.__esModule) ? mod : { default: mod };
}

function __classPrivateFieldGet(receiver, state, kind, f) {
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}

function __classPrivateFieldSet(receiver, state, value, kind, f) {
  if (kind === "m") throw new TypeError("Private method is not writable");
  if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
  if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
}

function __classPrivateFieldIn(state, receiver) {
  if (receiver === null || (typeof receiver !== "object" && typeof receiver !== "function")) throw new TypeError("Cannot use 'in' operator on non-object");
  return typeof state === "function" ? receiver === state : state.has(receiver);
}

function __addDisposableResource(env, value, async) {
  if (value !== null && value !== void 0) {
    if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
    var dispose, inner;
    if (async) {
      if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
      dispose = value[Symbol.asyncDispose];
    }
    if (dispose === void 0) {
      if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
      dispose = value[Symbol.dispose];
      if (async) inner = dispose;
    }
    if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
    if (inner) dispose = function() { try { inner.call(this); } catch (e) { return Promise.reject(e); } };
    env.stack.push({ value: value, dispose: dispose, async: async });
  }
  else if (async) {
    env.stack.push({ async: true });
  }
  return value;
}

var _SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
  var e = new Error(message);
  return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

function __disposeResources(env) {
  function fail(e) {
    env.error = env.hasError ? new _SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
    env.hasError = true;
  }
  var r, s = 0;
  function next() {
    while (r = env.stack.pop()) {
      try {
        if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
        if (r.dispose) {
          var result = r.dispose.call(r.value);
          if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) { fail(e); return next(); });
        }
        else s |= 1;
      }
      catch (e) {
        fail(e);
      }
    }
    if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
    if (env.hasError) throw env.error;
  }
  return next();
}

function __rewriteRelativeImportExtension(path, preserveJsx) {
  if (typeof path === "string" && /^\.\.?\//.test(path)) {
      return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function (m, tsx, d, ext, cm) {
          return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : (d + ext + "." + cm.toLowerCase() + "js");
      });
  }
  return path;
}

/* unused harmony default export */ var __WEBPACK_DEFAULT_EXPORT__ = ({
  __extends,
  __assign,
  __rest,
  __decorate,
  __param,
  __esDecorate,
  __runInitializers,
  __propKey,
  __setFunctionName,
  __metadata,
  __awaiter,
  __generator,
  __createBinding,
  __exportStar,
  __values,
  __read,
  __spread,
  __spreadArrays,
  __spreadArray,
  __await,
  __asyncGenerator,
  __asyncDelegator,
  __asyncValues,
  __makeTemplateObject,
  __importStar,
  __importDefault,
  __classPrivateFieldGet,
  __classPrivateFieldSet,
  __classPrivateFieldIn,
  __addDisposableResource,
  __disposeResources,
  __rewriteRelativeImportExtension,
});


/***/ }),

/***/ 1656:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   A: function() { return /* binding */ normalizeComponent; }
/* harmony export */ });
/* globals __VUE_SSR_CONTEXT__ */

// IMPORTANT: Do NOT use ES2015 features in this file (except for modules).
// This module is a runtime utility for cleaner component module output and will
// be included in the final webpack user bundle.

function normalizeComponent(
  scriptExports,
  render,
  staticRenderFns,
  functionalTemplate,
  injectStyles,
  scopeId,
  moduleIdentifier /* server only */,
  shadowMode /* vue-cli only */
) {
  // Vue.extend constructor export interop
  var options =
    typeof scriptExports === 'function' ? scriptExports.options : scriptExports

  // render functions
  if (render) {
    options.render = render
    options.staticRenderFns = staticRenderFns
    options._compiled = true
  }

  // functional template
  if (functionalTemplate) {
    options.functional = true
  }

  // scopedId
  if (scopeId) {
    options._scopeId = 'data-v-' + scopeId
  }

  var hook
  if (moduleIdentifier) {
    // server build
    hook = function (context) {
      // 2.3 injection
      context =
        context || // cached call
        (this.$vnode && this.$vnode.ssrContext) || // stateful
        (this.parent && this.parent.$vnode && this.parent.$vnode.ssrContext) // functional
      // 2.2 with runInNewContext: true
      if (!context && typeof __VUE_SSR_CONTEXT__ !== 'undefined') {
        context = __VUE_SSR_CONTEXT__
      }
      // inject component styles
      if (injectStyles) {
        injectStyles.call(this, context)
      }
      // register component module identifier for async chunk inferrence
      if (context && context._registeredComponents) {
        context._registeredComponents.add(moduleIdentifier)
      }
    }
    // used by ssr in case component is cached and beforeCreate
    // never gets called
    options._ssrRegister = hook
  } else if (injectStyles) {
    hook = shadowMode
      ? function () {
          injectStyles.call(
            this,
            (options.functional ? this.parent : this).$root.$options.shadowRoot
          )
        }
      : injectStyles
  }

  if (hook) {
    if (options.functional) {
      // for template-only hot-reload because in that case the render fn doesn't
      // go through the normalizer
      options._injectStyles = hook
      // register for functional component in vue file
      var originalRender = options.render
      options.render = function renderWithStyleInjection(h, context) {
        hook.call(context)
        return originalRender(h, context)
      }
    } else {
      // inject component registration as beforeCreate hook
      var existing = options.beforeCreate
      options.beforeCreate = existing ? [].concat(existing, hook) : [hook]
    }
  }

  return {
    exports: scriptExports,
    options: options
  }
}


/***/ }),

/***/ 1848:
/***/ (function(__unused_webpack_module, __unused_webpack___webpack_exports__, __webpack_require__) {

"use strict";

;// external "@fortawesome/fontawesome-svg-core"
var fontawesome_svg_core_namespaceObject = require("@fortawesome/fontawesome-svg-core");
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faTicketAlt.js
var faTicketAlt = __webpack_require__(7959);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faCommentsAlt.js
var faCommentsAlt = __webpack_require__(1377);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlus.js
var faPlus = __webpack_require__(906);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faSync.js
var faSync = __webpack_require__(9137);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faArrowAltLeft.js
var faArrowAltLeft = __webpack_require__(6059);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faPlusCircle.js
var faPlusCircle = __webpack_require__(6598);
// EXTERNAL MODULE: ./node_modules/@fortawesome/pro-solid-svg-icons/faUser.js
var faUser = __webpack_require__(2249);
;// ./src/fontawesome.ts








fontawesome_svg_core_namespaceObject.library.add(faTicketAlt/* faTicketAlt */.Fn, faCommentsAlt/* faCommentsAlt */.$P, faPlus/* faPlus */.QL, faSync/* faSync */.VN, faArrowAltLeft/* faArrowAltLeft */.XZ, faPlusCircle/* faPlusCircle */.OQ, faUser/* faUser */.X4);


/***/ }),

/***/ 1873:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var root = __webpack_require__(9325);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),

/***/ 1882:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObject = __webpack_require__(3805);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),

/***/ 2022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketsList_TicketsList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketsList/TicketsList.vue?vue&type=template&id=2211daf8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):_c('k-table',{attrs:{"url":"/ticket","ajaxDatas":_vm.ajaxDatas,"columns":_vm.columns,"filters":_vm.filters,"rowLink":_vm.rowLink,"stateKey":_vm.stateKey}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/components/TicketForm/TicketForm.vue + 3 modules
var TicketForm = __webpack_require__(161);
// EXTERNAL MODULE: ./src/components/TicketsList/Category.vue + 3 modules
var Category = __webpack_require__(4585);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketsList/TicketsList.ts?vue&type=script&lang=ts&external








var TicketsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketsList, _super);
    function TicketsList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ticketForm = false;
        _this.loading = false;
        return _this;
    }
    TicketsList.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTags()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadCategories()];
                    case 2:
                        _a.sent();
                        return [4 /*yield*/, this.loadTeamUsers()];
                    case 3:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(TicketsList.prototype, "stateKey", {
        get: function () {
            var prefix = '';
            if (this.customer) {
                prefix = 'customer-';
            }
            else if (this.contact) {
                prefix = 'contact-';
            }
            return prefix + 'tickets-list';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketsList.prototype, "ajaxDatas", {
        get: function () {
            var include = ['team_user', 'category', 'tags', 'custom_fields'];
            if (!this.customer) {
                include.push('customer');
            }
            if (!this.contact) {
                include.push('contact');
            }
            var datas = {
                include: include
            };
            if (this.customer || this.contact) {
                var filter = {};
                if (this.customer) {
                    filter.customer = this.customer.id;
                }
                if (this.contact) {
                    filter.contact = this.contact.id;
                }
                datas.filter = filter;
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketsList.prototype, "columns", {
        get: function () {
            var columns = [
                {
                    data: 'reference',
                    name: this.$t('tickets.ticket.reference')
                }
            ];
            if (!this.customer) {
                columns.push({
                    data: 'customer.name',
                    name: this.$t('tickets.ticket.customer')
                });
            }
            if (!this.contact) {
                columns.push({
                    data: 'contact.fullname',
                    name: this.$t('tickets.ticket.contact')
                });
            }
            columns.push.apply(columns, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    data: 'subject',
                    name: this.$t('tickets.ticket.subject')
                },
                {
                    data: 'category',
                    name: this.$t('tickets.ticket.category'),
                    component: Category/* default */.A
                },
                {
                    data: 'tags',
                    name: this.$t('tickets.ticket.tags'),
                    render: function (tags) {
                        return tags ? tags.map(function (tag) { return tag.label; }).join(', ') : null;
                    },
                    sortable: false
                },
                {
                    data: 'team_user.fullname',
                    name: this.$t('tickets.ticket.attributedTo')
                },
                {
                    data: 'status_label',
                    name: this.$t('tickets.ticket.status')
                },
                {
                    data: 'created_at',
                    name: this.$t('tickets.ticket.createdAt'),
                    render: 'datetime'
                },
                {
                    data: 'updated_at',
                    name: this.$t('tickets.ticket.lastAction'),
                    render: 'datetime'
                }
            ], this.customFieldTableColumns('ticket')));
            return columns;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketsList.prototype, "filters", {
        get: function () {
            var filters = [
                {
                    type: 'text',
                    label: this.$t('tickets.ticket.status'),
                    name: 'subject'
                },
                {
                    type: 'text',
                    label: this.$t('tickets.ticket.contentFilter'),
                    name: 'comments'
                }
            ];
            if (!this.customer) {
                filters.push({
                    type: 'select',
                    label: this.$t('tickets.ticket.customer'),
                    name: 'customer',
                    multiple: true,
                    ajax: '/customer?sort=name&filter[is_prospect_or_customer]=1',
                    optionLabel: 'name',
                    value: 'id'
                });
            }
            if (!this.contact) {
                filters.push({
                    type: 'select',
                    label: this.$t('tickets.ticket.contact'),
                    name: 'contact',
                    multiple: true,
                    ajax: '/customer/contact?sort=fullname',
                    optionLabel: 'fullname',
                    value: 'id'
                });
            }
            filters.push.apply(filters, (0,tslib_es6/* __spreadArrays */.aN)([
                {
                    type: 'select',
                    label: this.$t('tickets.ticket.status'),
                    name: 'status',
                    options: [
                        { id: 1, label: this.$t('tickets.ticket.status1') },
                        { id: 2, label: this.$t('tickets.ticket.status2') },
                        { id: 3, label: this.$t('tickets.ticket.status3') },
                        { id: 4, label: this.$t('tickets.ticket.status4') }
                    ],
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('tickets.ticket.attributedTo'),
                    name: 'team_user',
                    options: this.teamUsersFilter,
                    optionLabel: 'fullname',
                    value: 'id',
                    multiple: true
                },
                {
                    type: 'select',
                    label: this.$t('tickets.ticket.category'),
                    name: 'category',
                    options: this.categories,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('tickets.ticket.allTags'),
                    name: 'all_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'select',
                    label: this.$t('tickets.ticket.tags'),
                    name: 'any_tags',
                    options: this.tags,
                    multiple: true,
                    optionLabel: 'label',
                    value: 'id'
                },
                {
                    type: 'period',
                    label: this.$t('interface.list.createdAt'),
                    name: 'created_since',
                    name2: 'created_until'
                },
                {
                    type: 'period',
                    label: this.$t('tickets.ticket.lastAction'),
                    name: 'edited_since',
                    name2: 'edited_until'
                }
            ], this.customFieldTableFilters('ticket')));
            return filters;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketsList.prototype, "teamUsersFilter", {
        get: function () {
            var users = this.teamUsersRole('tickets');
            users.unshift({ id: null, fullname: this.$t('tickets.ticket.notAttributed') });
            return users;
        },
        enumerable: false,
        configurable: true
    });
    TicketsList.prototype.rowLink = function (row) {
        return {
            name: 'tickets-item',
            params: {
                id: String(row.id)
            }
        };
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketsList.prototype, "customer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketsList.prototype, "contact", void 0);
    TicketsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Spinner: interface_vue_.Spinner,
                KTable: table_vue_.KTable,
                TicketForm: TicketForm/* default */.A
            },
            methods: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('tickets', ['loadTags', 'loadCategories'])), (0,external_vuex_.mapActions)('globalDatas', ['loadTeamUsers'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('tickets', ['tags', 'categories'])), (0,external_vuex_.mapGetters)('globalDatas', ['teamUsersRole']))
        })
    ], TicketsList);
    return TicketsList;
}((0,lib/* Mixins */.Xe)(custom_fields_vue_.CustomFieldsTableMixin)));
/* harmony default export */ var TicketsListvue_type_script_lang_ts_external = (TicketsList);

;// ./src/components/TicketsList/TicketsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketsList_TicketsListvue_type_script_lang_ts_external = (TicketsListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketsList/TicketsList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketsList_TicketsListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketsList_TicketsList = (component.exports);

/***/ }),

/***/ 2120:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AutomationList_AutomationList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutomationList/AutomationList.vue?vue&type=template&id=f642e710
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('tickets.automation.explain'))+" ")]),_c('DynamicList',{attrs:{"url":"/ticket/automation","createTitle":_vm.$t('tickets.automation.addTitle'),"updateTitle":_vm.$t('tickets.automation.editTitle'),"deleteMsg":_vm.$t('tickets.automation.deleteMsg'),"datas":{ include: ['team_user', 'category', 'tags'] },"columns":_vm.columns,"customForm":_vm.customForm,"searchable":false,"deleteColumnIndex":false,"modalSize":"xl"}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/AutomationForm/AutomationForm.vue + 3 modules
var AutomationForm = __webpack_require__(4016);
// EXTERNAL MODULE: ./src/components/AutomationList/ConditionsDisplay.vue + 3 modules
var ConditionsDisplay = __webpack_require__(5786);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AutomationList/AutomationList.ts?vue&type=script&lang=ts&external





var AutomationList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AutomationList, _super);
    function AutomationList() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.customForm = AutomationForm/* default */.A;
        return _this;
    }
    Object.defineProperty(AutomationList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('tickets.automation.list.conditions'),
                    key: 'conditions',
                    component: ConditionsDisplay/* default */.A
                },
                {
                    label: this.$t('tickets.automation.list.users'),
                    key: 'team_user.fullname',
                    class: 'd-none d-md-table-cell'
                },
                {
                    label: this.$t('tickets.automation.list.priority'),
                    key: 'priority_label',
                    class: 'd-none d-lg-table-cell'
                },
                {
                    label: this.$t('tickets.automation.list.category'),
                    key: 'category.label',
                    class: 'd-none d-lg-table-cell'
                },
                {
                    label: this.$t('tickets.automation.list.tags'),
                    key: 'tags',
                    show: function (tags) { return tags === null || tags === void 0 ? void 0 : tags.map(function (tag) { return tag.label; }).join(', '); },
                    class: 'd-none d-lg-table-cell'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    AutomationList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], AutomationList);
    return AutomationList;
}(lib/* Vue */.lD));
/* harmony default export */ var AutomationListvue_type_script_lang_ts_external = (AutomationList);

;// ./src/components/AutomationList/AutomationList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AutomationList_AutomationListvue_type_script_lang_ts_external = (AutomationListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AutomationList/AutomationList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AutomationList_AutomationListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AutomationList_AutomationList = (component.exports);

/***/ }),

/***/ 2249:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'user';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f007';
var svgPathData = 'M224 256c70.7 0 128-57.3 128-128S294.7 0 224 0 96 57.3 96 128s57.3 128 128 128zm89.6 32h-16.7c-22.2 10.2-46.9 16-72.9 16s-50.6-5.8-72.9-16h-16.7C60.2 288 0 348.2 0 422.4V464c0 26.5 21.5 48 48 48h352c26.5 0 48-21.5 48-48v-41.6c0-74.2-60.2-134.4-134.4-134.4z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.X4 = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 2428:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(7534),
    isObjectLike = __webpack_require__(346);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),

/***/ 2551:
/***/ (function(module) {

"use strict";
module.exports = require("lodash");

/***/ }),

/***/ 2552:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var Symbol = __webpack_require__(1873),
    getRawTag = __webpack_require__(659),
    objectToString = __webpack_require__(9350);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),

/***/ 2652:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/interface-vue");

/***/ }),

/***/ 2667:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ MyTicketsNew_MyTicketsNew; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MyTicketsNew/MyTicketsNew.vue?vue&type=template&id=07127920
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"ok-title":"Envoyer","size":"lg","title":_vm.$t('tickets.ticket.createTitle')},on:{"hidden":function($event){return _vm.$emit('hidden')}},model:{value:(_vm.formModal),callback:function ($$v) {_vm.formModal=$$v},expression:"formModal"}},[_c('k-form',{attrs:{"action":"/app-support","value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.subject')}},[_c('k-form-input',{attrs:{"required":""},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.message')}},[_c('b-alert',{staticClass:"font-weight-bold mb-2",attrs:{"show":"","variant":"warning"}},[_vm._v(" Si votre demande de support concerne plusieurs éléments spécifiques, merci d'indiquer les références de ces éléments afin de nous permettre de mieux vous assister. ")]),_c('k-form-editor',{attrs:{"size":"sm","required":""},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.addFiles'),"lass":"mb-0"}},[_c('k-form-file',{attrs:{"url":"/app-support/file","removeUploadedFile":"","btnMode":"","btnSize":"sm","multiple":""},on:{"onUpload":_vm.fileUploaded}}),_c('b-row',_vm._l((_vm.temporaryFiles),function(file,i){return _c('b-col',{key:file.id,staticClass:"tickets-file-form mt-2"},[_c('FileItem',{attrs:{"value":file,"baseUrl":"/app-support/file"},on:{"deleted":function($event){return _vm.fileDeleted(i)}}})],1)}),1)],1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MyTicketsNew/MyTicketsNew.ts?vue&type=script&lang=ts&external





var MyTicketsNew = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MyTicketsNew, _super);
    function MyTicketsNew() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.formModal = false;
        _this.subject = null;
        _this.message = null;
        _this.temporaryFiles = [];
        return _this;
    }
    Object.defineProperty(MyTicketsNew.prototype, "formDatas", {
        get: function () {
            return {
                subject: this.subject,
                message: this.message,
                files: this.temporaryFiles.map(function (file) { return file.id; })
            };
        },
        enumerable: false,
        configurable: true
    });
    MyTicketsNew.prototype.watchModal = function () {
        this.formModal = this.modal;
    };
    MyTicketsNew.prototype.fileUploaded = function (file) {
        this.temporaryFiles.push(file);
    };
    MyTicketsNew.prototype.fileDeleted = function (index) {
        lib/* Vue */.lD.delete(this.temporaryFiles, index);
    };
    MyTicketsNew.prototype.submitComplete = function (response) {
        this.$emit('created', response.data);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], MyTicketsNew.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], MyTicketsNew.prototype, "watchModal", null);
    MyTicketsNew = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BAlert: external_bootstrap_vue_.BAlert, BFormGroup: external_bootstrap_vue_.BFormGroup,
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormEditor: form_vue_.KFormEditor, KFormFile: form_vue_.KFormFile,
                FormModal: interface_vue_.FormModal, FileItem: interface_vue_.FileItem
            }
        })
    ], MyTicketsNew);
    return MyTicketsNew;
}(lib/* Vue */.lD));
/* harmony default export */ var MyTicketsNewvue_type_script_lang_ts_external = (MyTicketsNew);

;// ./src/components/MyTicketsNew/MyTicketsNew.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MyTicketsNew_MyTicketsNewvue_type_script_lang_ts_external = (MyTicketsNewvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/MyTicketsNew/MyTicketsNew.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  MyTicketsNew_MyTicketsNewvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MyTicketsNew_MyTicketsNew = (component.exports);

/***/ }),

/***/ 3221:
/***/ (function(module) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),

/***/ 3295:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_MyTicketsView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/MyTicketsView.vue?vue&type=template&id=6ef33a60
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('MyTickets')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/MyTickets/MyTickets.vue + 3 modules
var MyTickets = __webpack_require__(5296);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/MyTicketsView.vue?vue&type=script&lang=ts



var MyTicketsView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MyTicketsView, _super);
    function MyTicketsView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    MyTicketsView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                MyTickets: MyTickets/* default */.A
            }
        })
    ], MyTicketsView);
    return MyTicketsView;
}(lib/* Vue */.lD));
/* harmony default export */ var MyTicketsViewvue_type_script_lang_ts = (MyTicketsView);

;// ./src/views/MyTicketsView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_MyTicketsViewvue_type_script_lang_ts = (MyTicketsViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/MyTicketsView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_MyTicketsViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_MyTicketsView = (component.exports);

/***/ }),

/***/ 3335:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommentItem_CommentItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentItem/CommentItem.vue?vue&type=template&id=76df417f
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'ticket-comment': true,
    'user-message': _vm.value.team_user_id && !_vm.value.is_historic,
    'is-note': _vm.value.is_note,
    'is-historic': _vm.value.is_historic
  }},[(!_vm.value.is_historic)?_c('b-row',{staticClass:"comment-infos"},[_c('b-col',[(_vm.value.team_user)?[_c('Avatar',{staticClass:"comment-avatar",attrs:{"teamUser":_vm.value.team_user,"size":"2rem"}}),_vm._v(" "+_vm._s(_vm.value.team_user.fullname)+" ")]:[(_vm.value.from_name)?_c('Avatar',{staticClass:"comment-avatar",attrs:{"name":_vm.value.from_name,"size":"2rem"}}):_vm._e(),_c('span',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.value.from_name)+" ")])],_vm._v("  -  "),_c('span',{staticClass:"datetime"},[_vm._v(" "+_vm._s(_vm.datetime(_vm.value.datetime))+" ")])],2),(_vm.value.is_note && _vm.can('tickets', 3))?[_c('b-col',{staticClass:"comments-actions",attrs:{"cols":"auto"}},[_c('b-button',{staticClass:"mr-2",attrs:{"size":"sm"},on:{"click":function($event){_vm.edit = true}}},[_vm._v(" "+_vm._s(_vm.$t('interface.edit'))+" ")]),_c('CommentForm',{attrs:{"modal":_vm.edit,"ticket-id":_vm.ticketId,"ticket":_vm.ticket,"is-note":_vm.value.is_note},on:{"submitted":_vm.commentUpdated,"hidden":function($event){_vm.edit = false}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}}),_c('CommentDelete',{staticClass:"d-inline-block",attrs:{"ticket-id":_vm.ticketId,"size":"sm"},on:{"deleted":function($event){return _vm.$emit('deleted')}},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1),_c('b-col',{attrs:{"cols":"auto"}},[_c('div',{staticClass:"private-note-indicator"},[_vm._v(" "+_vm._s(_vm.$t('tickets.comments.private'))+" ")])])]:_vm._e()],2):_vm._e(),_c('FroalaView',{class:{ 'from-user': _vm.value.team_user, 'comment-content': true },model:{value:(_vm.value.message),callback:function ($$v) {_vm.$set(_vm.value, "message", $$v)},expression:"value.message"}}),(_vm.value.files?.length > 0)?_c('div',{staticClass:"ticket-comment-attachments"},[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('tickets.comments.linkedFiles'))+" ")]),_c('b-row',_vm._l((_vm.value.files),function(file,i){return _c('b-col',{key:i,staticClass:"ticket-comment-attachment",attrs:{"cols":"auto"}},[_c('FileItem',{attrs:{"value":file,"cantDelete":""}})],1)}),1)],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: ./src/components/CommentForm/CommentForm.vue + 5 modules
var CommentForm = __webpack_require__(6090);
// EXTERNAL MODULE: ./src/components/CommentDelete/CommentDelete.vue + 3 modules
var CommentDelete = __webpack_require__(4640);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentItem/CommentItem.ts?vue&type=script&lang=ts&external








var CommentItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentItem, _super);
    function CommentItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.edit = false;
        return _this;
    }
    CommentItem.prototype.commentUpdated = function (comment) {
        this.$emit('input', comment);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentItem.prototype, "ticketId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentItem.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentItem.prototype, "ticket", void 0);
    CommentItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BCol: external_bootstrap_vue_.BCol, BRow: external_bootstrap_vue_.BRow, BBadge: external_bootstrap_vue_.BBadge, BButton: external_bootstrap_vue_.BButton,
                Avatar: interface_vue_.Avatar, FileItem: interface_vue_.FileItem,
                FroalaView: form_vue_.FroalaView,
                CommentForm: CommentForm/* default */.A,
                CommentDelete: CommentDelete/* default */.A
            },
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can']))
        })
    ], CommentItem);
    return CommentItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var CommentItemvue_type_script_lang_ts_external = (CommentItem);

;// ./src/components/CommentItem/CommentItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentItem_CommentItemvue_type_script_lang_ts_external = (CommentItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommentItem/CommentItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommentItem_CommentItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentItem_CommentItem = (component.exports);

/***/ }),

/***/ 3488:
/***/ (function(module) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),

/***/ 3650:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var overArg = __webpack_require__(4335);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),

/***/ 3656:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var root = __webpack_require__(9325),
    stubFalse = __webpack_require__(9935);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;


/***/ }),

/***/ 3729:
/***/ (function(module) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),

/***/ 3805:
/***/ (function(module) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),

/***/ 4016:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AutomationForm_AutomationForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutomationForm/AutomationForm.vue?vue&type=template&id=76d26a20
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":response => _vm.$emit('submitComplete', response)}},[_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v(" "+_vm._s(_vm.$t('tickets.automation.conditions'))+" ")]),_vm._l((_vm.automation.conditions),function(condition,i){return _c('b-row',{key:i,class:{
          'mb-2': true,
          'ml-4': _vm.automation.conditions[i].and && _vm.hasOrConditions && i > 0
        },attrs:{"align-v":"center"}},[(i > 0)?_c('b-col',{staticClass:"pr-0 mb-2 mb-lg-0",staticStyle:{"width":"100px"},attrs:{"cols":"12","lg":"auto"}},[(i > 0)?_c('k-form-select',{attrs:{"size":"sm","reduce":opt => opt.id,"options":_vm.conditionsAnd,"clearable":false},model:{value:(_vm.automation.conditions[i].and),callback:function ($$v) {_vm.$set(_vm.automation.conditions[i], "and", $$v)},expression:"automation.conditions[i].and"}}):_vm._e()],1):_vm._e(),_c('b-col',{staticClass:"d-flex align-items-center",attrs:{"cols":"12","md":"auto"}},[_vm._v(" "+_vm._s(_vm.$t('tickets.automation.if'))+" "),_c('k-form-select',{staticClass:"mx-2",attrs:{"size":"sm","reduce":opt => opt.id,"options":_vm.elements,"clearable":false},model:{value:(_vm.automation.conditions[i].element),callback:function ($$v) {_vm.$set(_vm.automation.conditions[i], "element", $$v)},expression:"automation.conditions[i].element"}}),_c('k-form-select',{attrs:{"size":"sm","reduce":opt => opt.id,"options":_vm.contains,"clearable":false},model:{value:(_vm.automation.conditions[i].contains),callback:function ($$v) {_vm.$set(_vm.automation.conditions[i], "contains", $$v)},expression:"automation.conditions[i].contains"}})],1),_c('b-col',{staticClass:"py-2 py-md-0",attrs:{"cols":"12","md":""}},[_c('k-form-input',{attrs:{"size":"sm","required":""},model:{value:(_vm.automation.conditions[i].value),callback:function ($$v) {_vm.$set(_vm.automation.conditions[i], "value", $$v)},expression:"automation.conditions[i].value"}})],1),(_vm.automation.conditions.length > 1)?_c('b-col',{attrs:{"cols":"auto"}},[_c('b-button',{attrs:{"variant":"secondary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.removeCondition(i)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.delete'))+" ")])],1):_vm._e()],1)}),_c('b-button',{attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.addCondition.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.automation.addCondition'))+" ")]),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('tickets.automation.actions'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.automation.assignToUser'),"label-cols-md":"5"}},[_c('TeamUserSelect',{attrs:{"clearable":""},model:{value:(_vm.automation.team_user),callback:function ($$v) {_vm.$set(_vm.automation, "team_user", $$v)},expression:"automation.team_user"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.automation.priority'),"label-cols-md":"5"}},[_c('k-form-select',{attrs:{"reduce":opt => opt.id,"options":_vm.ticketPriorities},model:{value:(_vm.automation.priority),callback:function ($$v) {_vm.$set(_vm.automation, "priority", $$v)},expression:"automation.priority"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.automation.category'),"label-cols-md":"5"}},[_c('k-form-select',{attrs:{"options":_vm.categories},model:{value:(_vm.automation.category),callback:function ($$v) {_vm.$set(_vm.automation, "category", $$v)},expression:"automation.category"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.automation.tags'),"label-cols-md":"5"}},[_c('k-form-select',{attrs:{"options":_vm.tags,"multiple":""},model:{value:(_vm.automation.tags),callback:function ($$v) {_vm.$set(_vm.automation, "tags", $$v)},expression:"automation.tags"}})],1)],2)]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: ./src/mixins/TicketPriorities.ts
var TicketPriorities = __webpack_require__(515);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AutomationForm/AutomationForm.ts?vue&type=script&lang=ts&external







var AutomationForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(AutomationForm, _super);
    function AutomationForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.automation = {
            conditions: [
                {
                    element: 'subject',
                    contains: true,
                    value: ''
                }
            ]
        };
        _this.contains = [
            { label: _this.$t('tickets.automation.contains'), id: true },
            { label: _this.$t('tickets.automation.dontContains'), id: false }
        ];
        _this.elements = [
            { label: _this.$t('tickets.automation.subject'), id: 'subject' },
            { label: _this.$t('tickets.automation.message'), id: 'message' }
        ];
        _this.conditionsAnd = [
            { label: _this.$t('tickets.automation.and'), id: true },
            { label: _this.$t('tickets.automation.or'), id: false }
        ];
        return _this;
    }
    AutomationForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTags()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadCategories()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AutomationForm.prototype, "hasOrConditions", {
        get: function () {
            return this.automation.conditions.filter(function (condition) { return condition.and === false; }).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutomationForm.prototype, "formAction", {
        get: function () {
            var _a;
            var url = '/ticket/automation';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutomationForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AutomationForm.prototype, "formDatas", {
        get: function () {
            var _a, _b, _c, _d, _e, _f, _g;
            var automation = this.automation;
            return {
                conditions: automation.conditions.map(function (condition) { return ({
                    and: condition.and !== undefined ? condition.and : true,
                    element: condition.element,
                    contains: condition.contains,
                    value: condition.value
                }); }),
                team_user: (_b = (_a = automation.team_user) === null || _a === void 0 ? void 0 : _a.id) !== null && _b !== void 0 ? _b : null,
                category: (_d = (_c = automation.category) === null || _c === void 0 ? void 0 : _c.id) !== null && _d !== void 0 ? _d : null,
                priority: (_e = automation.priority) !== null && _e !== void 0 ? _e : null,
                tags: (_g = (_f = automation.tags) === null || _f === void 0 ? void 0 : _f.map(function (tag) { return tag.id; })) !== null && _g !== void 0 ? _g : null
            };
        },
        enumerable: false,
        configurable: true
    });
    AutomationForm.prototype.watchValue = function () {
        this.automation = this.value ? JSON.parse(JSON.stringify(this.value)) : {
            conditions: [
                {
                    element: 'subject',
                    contains: true,
                    value: ''
                }
            ]
        };
    };
    AutomationForm.prototype.addCondition = function () {
        this.automation.conditions.push({
            element: 'subject',
            and: true,
            contains: true,
            value: ''
        });
    };
    AutomationForm.prototype.removeCondition = function (index) {
        this.automation.conditions.splice(index, 1);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], AutomationForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], AutomationForm.prototype, "watchValue", null);
    AutomationForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormSelect: form_vue_.KFormSelect, KFormInput: form_vue_.KFormInput,
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BFormGroup: external_bootstrap_vue_.BFormGroup,
                TeamUserSelect: interface_vue_.TeamUserSelect, Spinner: interface_vue_.Spinner
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('tickets', ['loadTags', 'loadCategories'])),
            computed: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('tickets', ['tags', 'categories']))
        })
    ], AutomationForm);
    return AutomationForm;
}((0,lib/* Mixins */.Xe)(TicketPriorities/* default */.A)));
/* harmony default export */ var AutomationFormvue_type_script_lang_ts_external = (AutomationForm);

;// ./src/components/AutomationForm/AutomationForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AutomationForm_AutomationFormvue_type_script_lang_ts_external = (AutomationFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AutomationForm/AutomationForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AutomationForm_AutomationFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AutomationForm_AutomationForm = (component.exports);

/***/ }),

/***/ 4066:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var identity = __webpack_require__(3488);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),

/***/ 4335:
/***/ (function(module) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),

/***/ 4501:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ MyTicketItem_MyTicketItem; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MyTicketItem/MyTicketItem.vue?vue&type=template&id=38b9676b
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"titleColsXl":_vm.buttons.length === 0 ? '' : '*',"buttonsCols":12,"buttonsColsLg":12,"buttonsColsMd":12,"buttonsColsSm":12,"buttonsColsXl":12,"page-title":_vm.value.subject,"buttons":_vm.buttons,"buttonsOrder":3,"buttonsClass":{ 'text-center': false, 'text-sm-center': false, 'pl-3': true, 'pt-2': true }}},[_c('b-col'),_c('b-col',{staticClass:"mt-2 mt-lg-0",attrs:{"cols":"12","md":"auto"}},[_c('ul',{staticClass:"status-bar w-auto d-inline-block"},_vm._l((_vm.ticketStatus),function(status){return _c('li',{key:status.id,class:{
            selected: status.id === _vm.value?.status || (status.id === 2 && _vm.value?.status === 3)
          }},[_c('div',[_vm._v(_vm._s(status.label))])])}),0)])],1),_c('AppMessages'),_c('b-button',{staticClass:"mb-2",attrs:{"variant":"primary","size":"sm"},on:{"click":function($event){$event.preventDefault();_vm.addMessage = true}}},[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.reply'))+" ")]),_c('div',{staticClass:"ticket-item-card"},[_c('b-card',[_c('div',{staticClass:"ticket-comments"},[_vm._l((_vm.value.comments),function(comment,i){return [(comment.is_historic)?_c('div',{key:'date' + i,staticClass:"historic-date"},[(comment.team_user)?_c('Avatar',{attrs:{"size":"2rem","team-user":comment.team_user}}):_vm._e(),_vm._v(" "+_vm._s(_vm.datetime(comment.created_at))+" ")],1):_vm._e(),_c('MyTicketComment',{key:i,attrs:{"ticketId":_vm.value.id,"value":comment}})]})],2)])],1),_c('CommentForm',{attrs:{"ticketId":_vm.value.id,"modal":_vm.addMessage,"ticket":_vm.value,"forCustomer":""},on:{"hidden":function($event){_vm.addMessage = false},"submitted":_vm.addComment}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/MyTicketComment/MyTicketComment.vue + 3 modules
var MyTicketComment = __webpack_require__(6014);
// EXTERNAL MODULE: ./src/components/TicketClose/TicketClose.vue + 3 modules
var TicketClose = __webpack_require__(8223);
// EXTERNAL MODULE: ./src/components/CommentForm/CommentForm.vue + 5 modules
var CommentForm = __webpack_require__(6090);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MyTicketItem/MyTicketItem.ts?vue&type=script&lang=ts&external







var MyTicketItem = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MyTicketItem, _super);
    function MyTicketItem() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addMessage = false;
        _this.ticketStatus = [
            { id: 1, label: 'En attente d\'attribution' },
            { id: 2, label: 'En cours' },
            { id: 4, label: 'Clôturé' }
        ];
        return _this;
    }
    Object.defineProperty(MyTicketItem.prototype, "buttons", {
        get: function () {
            return [
                {
                    icon: ['fas', 'arrow-alt-left'],
                    label: this.$t('tickets.ticket.back'),
                    to: { name: 'app-support' },
                    variant: 'secondary'
                },
                {
                    component: TicketClose/* default */.A,
                    attributes: {
                        value: this.value,
                        url: '/app-support/' + this.value.id + '/close'
                    },
                    events: {
                        input: this.input
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    MyTicketItem.prototype.addComment = function (comment) {
        var _a;
        var ticket = JSON.parse(JSON.stringify(this.value));
        (_a = ticket.comments) === null || _a === void 0 ? void 0 : _a.unshift(comment);
        if (ticket.status === 3) {
            ticket.status = 2;
        }
        this.input(ticket);
    };
    MyTicketItem.prototype.input = function (ticket) {
        this.$emit('input', ticket);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], MyTicketItem.prototype, "value", void 0);
    MyTicketItem = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                Avatar: interface_vue_.Avatar, PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                BCard: external_bootstrap_vue_.BCard, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton,
                MyTicketComment: MyTicketComment/* default */.A,
                CommentForm: CommentForm/* default */.A
            }
        })
    ], MyTicketItem);
    return MyTicketItem;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var MyTicketItemvue_type_script_lang_ts_external = (MyTicketItem);

;// ./src/components/MyTicketItem/MyTicketItem.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MyTicketItem_MyTicketItemvue_type_script_lang_ts_external = (MyTicketItemvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/MyTicketItem/MyTicketItem.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  MyTicketItem_MyTicketItemvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MyTicketItem_MyTicketItem = (component.exports);

/***/ }),

/***/ 4585:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketsList_Category; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketsList/Category.vue?vue&type=template&id=3463ef31
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('router-link',{staticClass:"kw-table-cell-value btn btn-link",attrs:{"to":{ name: 'tickets-item', params: { id: String(_vm.row.id) }}}},[(_vm.value)?_c('span',{staticClass:"d-flex align-items-center"},[(_vm.value.color)?_c('span',{staticClass:"tickets-list-category-color mr-2",style:({ backgroundColor: _vm.value.color })}):_vm._e(),_c('span',[_vm._v(" "+_vm._s(_vm.value.label)+" ")])]):_vm._e()])
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketsList/Category.ts?vue&type=script&lang=ts&external



var Category = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Category, _super);
    function Category() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Category.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Category.prototype, "row", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Category.prototype, "rowIndex", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], Category.prototype, "cellIndex", void 0);
    Category = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], Category);
    return Category;
}((external_vue_default())));
/* harmony default export */ var Categoryvue_type_script_lang_ts_external = (Category);

;// ./src/components/TicketsList/Category.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketsList_Categoryvue_type_script_lang_ts_external = (Categoryvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketsList/Category.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketsList_Categoryvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketsList_Category = (component.exports);

/***/ }),

/***/ 4640:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommentDelete_CommentDelete; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentDelete/CommentDelete.vue?vue&type=template&id=732b4a12
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" ")]):_vm._e(),_c('b-modal',{attrs:{"ok-title":_vm.$t('interface.delete'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal,"cancel":_vm.canceled},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_vm._v(" Êtes-vous sûr de vouloir supprimer cette note ? ")]],2)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentDelete/CommentDelete.ts?vue&type=script&lang=ts&external




var CommentDelete = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentDelete, _super);
    function CommentDelete() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(CommentDelete.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentDelete.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('interface.delete');
        },
        enumerable: false,
        configurable: true
    });
    CommentDelete.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    CommentDelete.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    CommentDelete.prototype.process = function (event) {
        var _a;
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwTickets.axios.delete('/ticket/' + this.ticketId + '/comment/' + ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id))
                                .then(function () {
                                _this.deleted();
                                _this.closeModal();
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    CommentDelete.prototype.closeModal = function () {
        this.$emit('closed');
    };
    CommentDelete.prototype.canceled = function () {
        this.$emit('canceled');
    };
    CommentDelete.prototype.deleted = function () {
        this.$emit('deleted');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentDelete.prototype, "ticketId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentDelete.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], CommentDelete.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommentDelete.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommentDelete.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommentDelete.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommentDelete.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommentDelete.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], CommentDelete.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], CommentDelete.prototype, "watchModalState", null);
    CommentDelete = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], CommentDelete);
    return CommentDelete;
}(lib/* Vue */.lD));
/* harmony default export */ var CommentDeletevue_type_script_lang_ts_external = (CommentDelete);

;// ./src/components/CommentDelete/CommentDelete.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentDelete_CommentDeletevue_type_script_lang_ts_external = (CommentDeletevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommentDelete/CommentDelete.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommentDelete_CommentDeletevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentDelete_CommentDelete = (component.exports);

/***/ }),

/***/ 4696:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/custom-fields-vue");

/***/ }),

/***/ 4840:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof __webpack_require__.g == 'object' && __webpack_require__.g && __webpack_require__.g.Object === Object && __webpack_require__.g;

module.exports = freeGlobal;


/***/ }),

/***/ 4894:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isFunction = __webpack_require__(1882),
    isLength = __webpack_require__(294);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),

/***/ 4901:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isLength = __webpack_require__(294),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),

/***/ 5296:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ MyTickets_MyTickets; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MyTickets/MyTickets.vue?vue&type=template&id=5cd8b263
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('PageHeader',{attrs:{"pageTitle":_vm.$t('tickets.ticket.pageTitle'),"buttons":_vm.buttons}}),_c('AppMessages'),_c('k-table',{attrs:{"url":"/app-support","columns":_vm.columns,"filters":_vm.filters,"state-key":"app-support","onlyTopFilters":"","rowLink":row => ({ name: 'app-support-item', params: { id: row.id }})}}),_c('MyTicketsNew',{attrs:{"modal":_vm.addModal},on:{"created":ticket => _vm.$router.push({ name: 'app-support-item', params: { id: ticket.id }}),"hidden":function($event){_vm.addModal = false}}})],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/MyTicketsNew/MyTicketsNew.vue + 3 modules
var MyTicketsNew = __webpack_require__(2667);
// EXTERNAL MODULE: external "@kwixeo/table-vue"
var table_vue_ = __webpack_require__(8399);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MyTickets/MyTickets.ts?vue&type=script&lang=ts&external





var MyTickets = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MyTickets, _super);
    function MyTickets() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.addModal = false;
        return _this;
    }
    Object.defineProperty(MyTickets.prototype, "buttons", {
        get: function () {
            var _this = this;
            return [
                {
                    label: this.$t('tickets.ticket.new'),
                    click: function () {
                        _this.addModal = true;
                    }
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MyTickets.prototype, "columns", {
        get: function () {
            var _this = this;
            return [
                {
                    data: 'created_at',
                    name: this.$t('interface.list.createdAt'),
                    render: 'datetime'
                },
                {
                    data: 'subject',
                    name: this.$t('tickets.ticket.subject'),
                },
                {
                    data: 'status',
                    name: this.$t('tickets.ticket.status'),
                    render: function (status) {
                        if (status === 3) {
                            status = 2;
                        }
                        return _this.$t('tickets.ticket.status' + status);
                    }
                },
                {
                    data: 'updated_at',
                    name: this.$t('tickets.ticket.lastUpdate'),
                    render: 'datetime',
                    visible: false
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(MyTickets.prototype, "filters", {
        get: function () {
            return [
                {
                    label: 'Statut',
                    type: 'select',
                    name: 'public_status',
                    optionLabel: 'label',
                    value: 'value',
                    options: [
                        { label: this.$t('tickets.ticket.status1'), value: 1 },
                        { label: this.$t('tickets.ticket.status2'), value: 2 },
                        { label: this.$t('tickets.ticket.status4'), value: 4 }
                    ]
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    MyTickets = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                PageHeader: interface_vue_.PageHeader, AppMessages: interface_vue_.AppMessages,
                MyTicketsNew: MyTicketsNew/* default */.A,
                KTable: table_vue_.KTable
            }
        })
    ], MyTickets);
    return MyTickets;
}(lib/* Vue */.lD));
/* harmony default export */ var MyTicketsvue_type_script_lang_ts_external = (MyTickets);

;// ./src/components/MyTickets/MyTickets.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MyTickets_MyTicketsvue_type_script_lang_ts_external = (MyTicketsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/MyTickets/MyTickets.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  MyTickets_MyTicketsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MyTickets_MyTickets = (component.exports);

/***/ }),

/***/ 5480:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_1__);



var TicketStatusMixin = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__extends */ .C6)(TicketStatusMixin, _super);
    function TicketStatusMixin() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ticketStatus = [
            { id: 1, label: 'En attente d\'attribution' },
            { id: 2, label: 'En cours' },
            { id: 3, label: 'Répondu' },
            { id: 4, label: 'Clôturé' }
        ];
        return _this;
    }
    TicketStatusMixin = (0,tslib__WEBPACK_IMPORTED_MODULE_2__/* .__decorate */ .Cg)([
        vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA
    ], TicketStatusMixin);
    return TicketStatusMixin;
}((vue__WEBPACK_IMPORTED_MODULE_1___default())));
/* harmony default export */ __webpack_exports__.A = (TicketStatusMixin);


/***/ }),

/***/ 5527:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),

/***/ 5561:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_TicketsListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TicketsListView.vue?vue&type=template&id=05205ffe
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TicketsList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/TicketsList/TicketsList.vue + 3 modules
var TicketsList = __webpack_require__(2022);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TicketsListView.vue?vue&type=script&lang=ts



var TicketsListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketsListView, _super);
    function TicketsListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TicketsListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TicketsList: TicketsList/* default */.A
            }
        })
    ], TicketsListView);
    return TicketsListView;
}(lib/* Vue */.lD));
/* harmony default export */ var TicketsListViewvue_type_script_lang_ts = (TicketsListView);

;// ./src/views/TicketsListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TicketsListViewvue_type_script_lang_ts = (TicketsListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TicketsListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_TicketsListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TicketsListView = (component.exports);

/***/ }),

/***/ 5786:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ AutomationList_ConditionsDisplay; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/AutomationList/ConditionsDisplay.vue?vue&type=template&id=30a4aaca
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.value),function(condition,i){return _c('p',{key:i,staticClass:"mb-0"},[(i > 0)?_c('span',{class:{ 'ml-4': condition.and && _vm.hasOrConditions && i > 0 }},[_vm._v(" "+_vm._s(condition.and ? 'ET' : 'OU')+" ")]):_vm._e(),_vm._v(" "+_vm._s(_vm.$t('tickets.automation.if'))+" "+_vm._s(condition.element === 'subject' ? _vm.$t('tickets.automation.subject') : _vm.$t('tickets.automation.message'))+" "+_vm._s(condition.contains ? _vm.$t('tickets.automation.contains') : _vm.$t('tickets.automation.dontContains'))+" \""+_vm._s(condition.value)+"\" ")])}),0)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/AutomationList/ConditionsDisplay.ts?vue&type=script&lang=ts&external


var ConditionsDisplay = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConditionsDisplay, _super);
    function ConditionsDisplay() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(ConditionsDisplay.prototype, "hasOrConditions", {
        get: function () {
            return this.value.filter(function (condition) { return condition.and === false; }).length > 0;
        },
        enumerable: false,
        configurable: true
    });
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], ConditionsDisplay.prototype, "value", void 0);
    ConditionsDisplay = (0,tslib_es6/* __decorate */.Cg)([
        lib/* Component */.uA
    ], ConditionsDisplay);
    return ConditionsDisplay;
}(lib/* Vue */.lD));
/* harmony default export */ var ConditionsDisplayvue_type_script_lang_ts_external = (ConditionsDisplay);

;// ./src/components/AutomationList/ConditionsDisplay.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var AutomationList_ConditionsDisplayvue_type_script_lang_ts_external = (ConditionsDisplayvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/AutomationList/ConditionsDisplay.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  AutomationList_ConditionsDisplayvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var AutomationList_ConditionsDisplay = (component.exports);

/***/ }),

/***/ 5858:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/customers-vue");

/***/ }),

/***/ 5950:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(695),
    baseKeys = __webpack_require__(8984),
    isArrayLike = __webpack_require__(4894);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),

/***/ 6009:
/***/ (function(module, exports, __webpack_require__) {

/* module decorator */ module = __webpack_require__.nmd(module);
var freeGlobal = __webpack_require__(4840);

/** Detect free variable `exports`. */
var freeExports =  true && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && "object" == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;


/***/ }),

/***/ 6014:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ MyTicketComment_MyTicketComment; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/MyTicketComment/MyTicketComment.vue?vue&type=template&id=4dbc59e8
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{class:{
    'ticket-comment': true,
    'user-message': _vm.value.team_user_id && !_vm.value.is_historic,
    'is-note': _vm.value.is_note,
    'is-historic': _vm.value.is_historic
  }},[(!_vm.value.is_historic)?_c('b-row',{staticClass:"comment-infos"},[_c('b-col',[(_vm.value.team_user)?[_c('Avatar',{staticClass:"comment-avatar",attrs:{"teamUser":_vm.value.team_user,"size":"2rem"}}),_vm._v(" "+_vm._s(_vm.value.team_user.fullname)+" ")]:[(_vm.value.from_name)?_c('Avatar',{staticClass:"comment-avatar",attrs:{"name":_vm.value.from_name,"size":"2rem"}}):_vm._e(),_c('span',{staticClass:"name"},[_vm._v(" "+_vm._s(_vm.value.from_name)+" ")])],_vm._v("  -  "),_c('span',{staticClass:"datetime"},[_vm._v(" "+_vm._s(_vm.datetime(_vm.value.datetime))+" ")])],2)],1):_vm._e(),_c('FroalaView',{class:{ 'from-user': _vm.value.team_user, 'comment-content': true },model:{value:(_vm.value.message),callback:function ($$v) {_vm.$set(_vm.value, "message", $$v)},expression:"value.message"}}),(_vm.value.files?.length > 0)?_c('div',{staticClass:"ticket-comment-attachments"},[_c('p',{staticClass:"font-weight-bold small mb-0"},[_vm._v(" "+_vm._s(_vm.$t('tickets.comments.linkedFiles'))+" ")]),_c('b-row',_vm._l((_vm.value.files),function(file,i){return _c('b-col',{key:i,staticClass:"ticket-comment-attachment",attrs:{"cols":"auto"}},[_c('FileItem',{attrs:{"value":file,"cantDelete":"","baseUrl":"/app-support/file"}})],1)}),1)],1):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/MyTicketComment/MyTicketComment.ts?vue&type=script&lang=ts&external




var MyTicketComment = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(MyTicketComment, _super);
    function MyTicketComment() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], MyTicketComment.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], MyTicketComment.prototype, "ticketId", void 0);
    MyTicketComment = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol,
                FileItem: interface_vue_.FileItem, Avatar: interface_vue_.Avatar
            }
        })
    ], MyTicketComment);
    return MyTicketComment;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin)));
/* harmony default export */ var MyTicketCommentvue_type_script_lang_ts_external = (MyTicketComment);

;// ./src/components/MyTicketComment/MyTicketComment.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var MyTicketComment_MyTicketCommentvue_type_script_lang_ts_external = (MyTicketCommentvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/MyTicketComment/MyTicketComment.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  MyTicketComment_MyTicketCommentvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var MyTicketComment_MyTicketComment = (component.exports);

/***/ }),

/***/ 6059:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'arrow-alt-left';
var width = 448;
var height = 512;
var ligatures = [];
var unicode = 'f355';
var svgPathData = 'M448 208v96c0 13.3-10.7 24-24 24H224v103.8c0 21.4-25.8 32.1-41 17L7 273c-9.4-9.4-9.4-24.6 0-34L183 63.3c15.1-15.1 41-4.4 41 17V184h200c13.3 0 24 10.7 24 24z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.XZ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6090:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CommentForm_CommentForm; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CommentForm/CommentForm.vue?vue&type=template&id=cdfc3c4c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('FormModal',{attrs:{"title":_vm.modalTitle,"visible":_vm.modal,"size":"xl","body-class":{ 'pt-1': !_vm.isNote && _vm.forCustomer === false }},on:{"hidden":function($event){return _vm.$emit('hidden')}}},[(_vm.team.is_root && _vm.ticket.team_id_admin)?_c('b-alert',{staticClass:"font-weight-bold mt-2",attrs:{"show":"","variant":"danger"}},[_c('p',{staticClass:"h5 mb-0"},[_vm._v("Attention, client d'un revendeur !!!")])]):_vm._e(),(_vm.loading)?_c('Spinner'):_c('k-form',{attrs:{"action":_vm.formAction,"method":_vm.formMethod,"value":_vm.formDatas},on:{"submitComplete":_vm.submitComplete}},[_c('b-row',{attrs:{"align-v":"end"}},[_c('b-col',[_c('strong',[_vm._v("Message ")])]),(!_vm.isNote && _vm.forCustomer === false)?_c('b-col',{staticStyle:{"width":"250px"},attrs:{"cols":"auto"}},[_c('b-form-group',{staticClass:"small mb-0",attrs:{"label":_vm.$t('tickets.templates.menuLabel')}},[_c('b-input-group',[_c('k-form-select',{attrs:{"size":"sm","options":_vm.templates},model:{value:(_vm.template),callback:function ($$v) {_vm.template=$$v},expression:"template"}}),_c('b-input-group-append',[_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"variant":"primary","size":"sm","title":_vm.$t('tickets.templates.insert')},on:{"click":function($event){$event.preventDefault();return _vm.insertTemplate.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'plus']}})],1),_c('b-button',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip"}],attrs:{"variant":"secondary","size":"sm","title":_vm.$t('tickets.templates.replace')},on:{"click":function($event){$event.preventDefault();return _vm.replaceTemplate.apply(null, arguments)}}},[_c('font-awesome-icon',{attrs:{"icon":['fas', 'sync']}})],1)],1)],1)],1)],1):_vm._e()],1),_c('k-form-editor',{ref:"editor",staticClass:"mt-2",attrs:{"required":"","size":"sm","config":_vm.editorConfig,"validate":_vm.team.is_root && _vm.ticket.team_id_admin ? 'whiteMarkNoKwixeo' : null},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),(!_vm.isNote)?_c('k-form-file',{staticClass:"mt-2",attrs:{"url":_vm.fileUrl,"datas":{ temporary: 1 },"removeUploadedFile":"","multiple":"","btnMode":"","btnSize":"sm","btnTheme":"secondary"},on:{"onUpload":_vm.fileUploaded}}):_vm._e(),_c('b-row',_vm._l((_vm.temporaryFiles),function(file,i){return _c('b-col',{key:file.id,staticClass:"ticket-file-form mt-2",attrs:{"cols":"auto"}},[_c('FileItem',{attrs:{"value":file,"baseUrl":_vm.fileUrl},on:{"deleted":function($event){return _vm.fileDeleted(i)}}})],1)}),1)],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "@fortawesome/vue-fontawesome"
var vue_fontawesome_ = __webpack_require__(9356);
;// external "froala-editor"
var external_froala_editor_namespaceObject = require("froala-editor");
var external_froala_editor_default = /*#__PURE__*/__webpack_require__.n(external_froala_editor_namespaceObject);
;// ./src/components/CommentForm/editorConfig.ts

var config = {
    enter: (external_froala_editor_default()).ENTER_BR,
    listAdvancedTypes: false,
    quickInsertEnabled: false,
    wordCounterCount: false,
    toolbarButtons: {
        moreText: {
            buttons: [
                'bold',
                'italic',
                'underline',
                '|',
                'alignLeft',
                'alignCenter',
                'alignRight',
                'alignJustify',
                '|',
                'textColor',
                'backgroundColor',
                '|',
                'formatUL',
                'formatOL',
                '|',
                'insertLink',
                'quote',
                '|',
                'strikeThrough',
                'outdent',
                'indent',
                'insertTable',
                '|',
                'insertHR'
            ],
            buttonsVisible: 13
        },
        moreText2: {
            buttons: [],
            buttonsVisible: 11
        },
        moreMisc: {
            buttons: ['undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 3
        }
    }
};
/* harmony default export */ var editorConfig = (config);

;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CommentForm/CommentForm.ts?vue&type=script&lang=ts&external









var CommentForm = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CommentForm, _super);
    function CommentForm() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.message = null;
        _this.temporaryFiles = [];
        _this.template = null;
        _this.editorConfig = editorConfig;
        return _this;
    }
    CommentForm.prototype.mounted = function () {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (this.isNote) {
                            return [2 /*return*/];
                        }
                        if (!(this.forCustomer === false)) return [3 /*break*/, 2];
                        this.loading = true;
                        return [4 /*yield*/, this.loadTemplates()];
                    case 1:
                        _a.sent();
                        _a.label = 2;
                    case 2:
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(CommentForm.prototype, "modalTitle", {
        get: function () {
            var _a;
            if (!this.isNote) {
                return this.$t('tickets.comments.addResponse');
            }
            return this.$t('tickets.comments.' + (((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'edit' : 'add'));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentForm.prototype, "formAction", {
        get: function () {
            var _a;
            if (this.forCustomer !== false) {
                return '/app-support/' + this.ticketId + '/comment';
            }
            var url = '/ticket/' + this.ticketId + '/comment';
            if ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) {
                url += '/' + this.value.id;
            }
            return url;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentForm.prototype, "formMethod", {
        get: function () {
            var _a;
            return ((_a = this.value) === null || _a === void 0 ? void 0 : _a.id) ? 'PUT' : 'POST';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentForm.prototype, "fileUrl", {
        get: function () {
            if (this.forCustomer !== false) {
                return '/app-support/file';
            }
            return '/file';
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(CommentForm.prototype, "formDatas", {
        get: function () {
            var datas = {
                message: this.message,
                with_file: true
            };
            if (this.isNote) {
                datas.is_note = true;
            }
            else {
                datas.files = this.temporaryFiles.map(function (file) { return file.id; });
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    CommentForm.prototype.watchValue = function () {
        var _a;
        this.message = (_a = this.value) === null || _a === void 0 ? void 0 : _a.message;
    };
    CommentForm.prototype.submitComplete = function (response) {
        if (!this.value) {
            this.message = null;
        }
        this.temporaryFiles = [];
        this.$emit('submitted', response.data);
    };
    CommentForm.prototype.fileUploaded = function (file) {
        this.temporaryFiles.push(file);
    };
    CommentForm.prototype.fileDeleted = function (index) {
        external_vue_default()["delete"](this.temporaryFiles, index);
    };
    CommentForm.prototype.insertTemplate = function () {
        var _a;
        if (!((_a = this.template) === null || _a === void 0 ? void 0 : _a.message)) {
            return;
        }
        var editor = this.$refs.editor.$refs.editor;
        // eslint-disable-next-line @typescript-eslint/ban-ts-comment
        // @ts-ignore
        var froala = editor.getEditor();
        froala.html.insert(this.template.message);
        this.cleanTemplate();
    };
    CommentForm.prototype.replaceTemplate = function () {
        var _a;
        if (!((_a = this.template) === null || _a === void 0 ? void 0 : _a.message)) {
            return;
        }
        this.message = this.template.message;
        this.cleanTemplate();
    };
    CommentForm.prototype.cleanTemplate = function () {
        var _this = this;
        this.$nextTick(function () {
            _this.template = null;
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentForm.prototype, "ticketId", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], CommentForm.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentForm.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommentForm.prototype, "isNote", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], CommentForm.prototype, "forCustomer", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], CommentForm.prototype, "ticket", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], CommentForm.prototype, "watchValue", null);
    CommentForm = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup, BCol: external_bootstrap_vue_.BCol, BRow: external_bootstrap_vue_.BRow, BButton: external_bootstrap_vue_.BButton, BInputGroup: external_bootstrap_vue_.BInputGroup, BInputGroupAppend: external_bootstrap_vue_.BInputGroupAppend, BAlert: external_bootstrap_vue_.BAlert,
                KForm: form_vue_.KForm, KFormFile: form_vue_.KFormFile, KFormEditor: form_vue_.KFormEditor, KFormSelect: form_vue_.KFormSelect,
                FormModal: interface_vue_.FormModal, FileItem: interface_vue_.FileItem,
                Spinner: interface_vue_.Spinner,
                FontAwesomeIcon: vue_fontawesome_.FontAwesomeIcon
            },
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapState)('tickets', ['templates'])), (0,external_vuex_.mapGetters)('user', ['team'])),
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('tickets', ['loadTemplates'])),
            directives: {
                'b-tooltip': external_bootstrap_vue_.VBTooltip
            }
        })
    ], CommentForm);
    return CommentForm;
}((external_vue_default())));
/* harmony default export */ var CommentFormvue_type_script_lang_ts_external = (CommentForm);

;// ./src/components/CommentForm/CommentForm.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CommentForm_CommentFormvue_type_script_lang_ts_external = (CommentFormvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CommentForm/CommentForm.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CommentForm_CommentFormvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CommentForm_CommentForm = (component.exports);

/***/ }),

/***/ 6449:
/***/ (function(module) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),

/***/ 6553:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TagsList_TagsList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TagsList/TagsList.vue?vue&type=template&id=3369942c
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":"/ticket/tag","createTitle":_vm.$t('tickets.tags.createTitle'),"updateTitle":_vm.$t('tickets.tags.editTitle'),"deleteMsg":_vm.$t('tickets.tags.deleteMsg'),"columns":_vm.columns,"sort":"label"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TagsList/TagsList.ts?vue&type=script&lang=ts&external



var TagsList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TagsList, _super);
    function TagsList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TagsList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('tickets.tags.label'),
                    key: 'label',
                    required: true
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    TagsList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], TagsList);
    return TagsList;
}(lib/* Vue */.lD));
/* harmony default export */ var TagsListvue_type_script_lang_ts_external = (TagsList);

;// ./src/components/TagsList/TagsList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TagsList_TagsListvue_type_script_lang_ts_external = (TagsListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TagsList/TagsList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TagsList_TagsListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TagsList_TagsList = (component.exports);

/***/ }),

/***/ 6598:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'plus-circle';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f055';
var svgPathData = 'M256 8C119 8 8 119 8 256s111 248 248 248 248-111 248-248S393 8 256 8zm144 276c0 6.6-5.4 12-12 12h-92v92c0 6.6-5.4 12-12 12h-56c-6.6 0-12-5.4-12-12v-92h-92c-6.6 0-12-5.4-12-12v-56c0-6.6 5.4-12 12-12h92v-92c0-6.6 5.4-12 12-12h56c6.6 0 12 5.4 12 12v92h92c6.6 0 12 5.4 12 12v56z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.OQ = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 6649:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var createBaseFor = __webpack_require__(3221);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),

/***/ 6886:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   un: function() { return /* binding */ ticketRelations; },
/* harmony export */   vA: function() { return /* binding */ fetchTicket; },
/* harmony export */   vE: function() { return /* binding */ needFetchTicket; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var ticketRelations = [
    'customer', 'contact', 'category', 'tags', 'teamUser', 'customFields'
];
var needFetchTicket = function (ticket) {
    return !ticketRelations.every(function (relation) { return relation in ticket; });
};
var fetchTicket = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwTickets.axios.get('/ticket/' + id + '?with_file=1', {
                    params: {
                        include: ticketRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 7112:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var config = {
    zIndex: 9999999,
    heightMin: 40,
    multiLine: false,
    toolbarButtons: {
        moreText: {
            buttons: [
                'insertDynamicVariables'
            ],
            buttonsVisible: 2
        },
        moreParagraph: {
            buttons: [],
            buttonsVisible: 1
        },
        moreRich: {
            buttons: [],
            buttonsVisible: 1
        },
        moreMisc: {
            buttons: ['clearFormatting', 'undo', 'redo', 'html'],
            align: 'right',
            buttonsVisible: 0
        }
    },
    pastePlain: true,
    imagePaste: false,
    pasteDeniedTags: ['div', 'span', 'p'],
    htmlAllowComments: false,
    htmlAllowedTags: [],
    htmlAllowedAttrs: ['class', 'contenteditable', 'data-.*', 'data'],
    tableEditButtons: []
};
/* harmony default export */ __webpack_exports__.A = (config);


/***/ }),

/***/ 7124:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   By: function() { return /* binding */ needFetchMyTicket; },
/* harmony export */   HR: function() { return /* binding */ fetchMyTicket; },
/* harmony export */   eY: function() { return /* binding */ myTicketRelations; }
/* harmony export */ });
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(1635);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(622);
/* harmony import */ var vue__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(vue__WEBPACK_IMPORTED_MODULE_0__);


var myTicketRelations = [
    'comments'
];
var needFetchMyTicket = function (ticket) {
    return !myTicketRelations.every(function (relation) { return relation in ticket; });
};
var fetchMyTicket = function (id) { return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__awaiter */ .sH)(void 0, void 0, Promise, function () {
    return (0,tslib__WEBPACK_IMPORTED_MODULE_1__/* .__generator */ .YH)(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, vue__WEBPACK_IMPORTED_MODULE_0___default().prototype.$kwTickets.axios.get('/app-support/' + id + '?with_file=1', {
                    params: {
                        include: myTicketRelations.join(',')
                    }
                })
                    .then(function (response) {
                    return response.data;
                })
                    .catch(function (error) {
                    var _a;
                    throw new Error((_a = error.response) === null || _a === void 0 ? void 0 : _a.data);
                })];
            case 1: return [2 /*return*/, _a.sent()];
        }
    });
}); };



/***/ }),

/***/ 7167:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(4901),
    baseUnary = __webpack_require__(7301),
    nodeUtil = __webpack_require__(6009);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),

/***/ 7301:
/***/ (function(module) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),

/***/ 7534:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var baseGetTag = __webpack_require__(2552),
    isObjectLike = __webpack_require__(346);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),

/***/ 7943:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_CategoriesListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CategoriesListView.vue?vue&type=template&id=4b6aed57
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('CategoriesList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/CategoriesList/CategoriesList.vue + 3 modules
var CategoriesList = __webpack_require__(8084);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/CategoriesListView.vue?vue&type=script&lang=ts



var CategoriesListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CategoriesListView, _super);
    function CategoriesListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CategoriesListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                CategoriesList: CategoriesList/* default */.A
            }
        })
    ], CategoriesListView);
    return CategoriesListView;
}(lib/* Vue */.lD));
/* harmony default export */ var CategoriesListViewvue_type_script_lang_ts = (CategoriesListView);

;// ./src/views/CategoriesListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_CategoriesListViewvue_type_script_lang_ts = (CategoriesListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/CategoriesListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_CategoriesListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_CategoriesListView = (component.exports);

/***/ }),

/***/ 7959:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'ticket-alt';
var width = 576;
var height = 512;
var ligatures = [];
var unicode = 'f3ff';
var svgPathData = 'M128 160h320v192H128V160zm400 96c0 26.51 21.49 48 48 48v96c0 26.51-21.49 48-48 48H48c-26.51 0-48-21.49-48-48v-96c26.51 0 48-21.49 48-48s-21.49-48-48-48v-96c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v96c-26.51 0-48 21.49-48 48zm-48-104c0-13.255-10.745-24-24-24H120c-13.255 0-24 10.745-24 24v208c0 13.255 10.745 24 24 24h336c13.255 0 24-10.745 24-24V152z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.Fn = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 8057:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/form-vue");

/***/ }),

/***/ 8084:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ CategoriesList_CategoriesList; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/CategoriesList/CategoriesList.vue?vue&type=template&id=7f9a9322
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('DynamicList',{attrs:{"url":"/ticket/category","createTitle":_vm.$t('tickets.categories.createTitle'),"updateTitle":_vm.$t('tickets.categories.editTitle'),"deleteMsg":_vm.$t('tickets.categories.deleteMsg'),"columns":_vm.columns,"sort":"label"}})
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/CategoriesList/CategoriesList.ts?vue&type=script&lang=ts&external



var CategoriesList = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(CategoriesList, _super);
    function CategoriesList() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(CategoriesList.prototype, "columns", {
        get: function () {
            return [
                {
                    label: this.$t('tickets.categories.label'),
                    key: 'label',
                    required: true
                },
                {
                    label: this.$t('tickets.categories.color'),
                    key: 'color',
                    type: 'color',
                    class: 'd-none d-md-table-cell'
                }
            ];
        },
        enumerable: false,
        configurable: true
    });
    CategoriesList = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                DynamicList: interface_vue_.DynamicList
            }
        })
    ], CategoriesList);
    return CategoriesList;
}(lib/* Vue */.lD));
/* harmony default export */ var CategoriesListvue_type_script_lang_ts_external = (CategoriesList);

;// ./src/components/CategoriesList/CategoriesList.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var CategoriesList_CategoriesListvue_type_script_lang_ts_external = (CategoriesListvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/CategoriesList/CategoriesList.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  CategoriesList_CategoriesListvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var CategoriesList_CategoriesList = (component.exports);

/***/ }),

/***/ 8086:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var tslib__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(1635);
/* harmony import */ var vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9603);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(9998);
/* harmony import */ var vuex__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(vuex__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2652);
/* harmony import */ var _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(_kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__);




var LoadTicketElements = /** @class */ (function (_super) {
    (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__extends */ .C6)(LoadTicketElements, _super);
    function LoadTicketElements() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        return _this;
    }
    LoadTicketElements.prototype.mounted = function () {
        return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__awaiter */ .sH)(this, void 0, Promise, function () {
            return (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__generator */ .YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.loading = true;
                        return [4 /*yield*/, this.loadTags()];
                    case 1:
                        _a.sent();
                        return [4 /*yield*/, this.loadCategories()];
                    case 2:
                        _a.sent();
                        this.loading = false;
                        return [2 /*return*/];
                }
            });
        });
    };
    LoadTicketElements = (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__decorate */ .Cg)([
        (0,vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Component */ .uA)({
            methods: (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapActions)('tickets', ['loadTags', 'loadCategories'])),
            computed: (0,tslib__WEBPACK_IMPORTED_MODULE_3__/* .__assign */ .Cl)({}, (0,vuex__WEBPACK_IMPORTED_MODULE_1__.mapState)('tickets', ['tags', 'categories'])),
            components: {
                Spinner: _kwixeo_interface_vue__WEBPACK_IMPORTED_MODULE_2__.Spinner
            }
        })
    ], LoadTicketElements);
    return LoadTicketElements;
}(vue_property_decorator__WEBPACK_IMPORTED_MODULE_0__/* .Vue */ .lD));
/* harmony default export */ __webpack_exports__.A = (LoadTicketElements);


/***/ }),

/***/ 8096:
/***/ (function(module) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),

/***/ 8223:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketClose_TicketClose; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketClose/TicketClose.vue?vue&type=template&id=6d7e6a53
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.element !== 'modal')?_c(_vm.component,{tag:"component",attrs:{"disabled":_vm.disabled,"variant":_vm.variant,"size":_vm.size},on:{"click":function($event){$event.preventDefault();_vm.modalState = true}}},[_vm._v(" "+_vm._s(_vm.buttonLabel)+" "),_c('b-modal',{attrs:{"ok-title":_vm.$t('tickets.ticket.closed'),"cancel-title":_vm.$t('interface.cancel'),"busy":_vm.loading,"no-close-on-backdrop":_vm.loading,"no-close-on-esc":_vm.loading,"hide-header-close":_vm.loading},on:{"ok":_vm.process,"hidden":_vm.closeModal},model:{value:(_vm.modalState),callback:function ($$v) {_vm.modalState=$$v},expression:"modalState"}},[(_vm.loading)?_c('Spinner'):[_vm._v(" "+_vm._s(_vm.$t('tickets.ticket.closeMessage'))+" ")]],2)],1):_vm._e()
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketClose/TicketClose.ts?vue&type=script&lang=ts&external




var TicketClose = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketClose, _super);
    function TicketClose() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading = false;
        _this.modalState = false;
        return _this;
    }
    Object.defineProperty(TicketClose.prototype, "component", {
        get: function () {
            switch (this.element) {
                case 'button':
                    return external_bootstrap_vue_.BButton;
                case 'dropdown':
                    return external_bootstrap_vue_.BDropdownItem;
                default:
                    return null;
            }
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketClose.prototype, "buttonLabel", {
        get: function () {
            var _a;
            return (_a = this.label) !== null && _a !== void 0 ? _a : this.$t('tickets.ticket.closed');
        },
        enumerable: false,
        configurable: true
    });
    TicketClose.prototype.watchModal = function (state) {
        this.modalState = state;
    };
    TicketClose.prototype.watchModalState = function (state) {
        if (!state) {
            this.loading = false;
        }
    };
    TicketClose.prototype.process = function (event) {
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var _this = this;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        event.preventDefault();
                        this.loading = true;
                        return [4 /*yield*/, this.$kwTickets.axios.put(this.url)
                                .then(function (response) {
                                _this.$emit('input', response.data);
                                _this.modalState = false;
                            })
                                .catch(function (error) {
                                throw new Error(error);
                            })
                                .finally(function () {
                                _this.loading = false;
                            })];
                    case 1:
                        _a.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    TicketClose.prototype.closeModal = function () {
        this.$emit('closed');
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketClose.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: 'button' })
    ], TicketClose.prototype, "element", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketClose.prototype, "label", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketClose.prototype, "variant", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: null })
    ], TicketClose.prototype, "size", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketClose.prototype, "disabled", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: false })
    ], TicketClose.prototype, "modal", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ default: function () { return '/ticket/' + this.value.id + '/close'; } })
    ], TicketClose.prototype, "url", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modal', { immediate: true })
    ], TicketClose.prototype, "watchModal", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('modalState')
    ], TicketClose.prototype, "watchModalState", null);
    TicketClose = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BModal: external_bootstrap_vue_.BModal,
                BOverlay: external_bootstrap_vue_.BOverlay,
                Spinner: interface_vue_.Spinner
            }
        })
    ], TicketClose);
    return TicketClose;
}(lib/* Vue */.lD));
/* harmony default export */ var TicketClosevue_type_script_lang_ts_external = (TicketClose);

;// ./src/components/TicketClose/TicketClose.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketClose_TicketClosevue_type_script_lang_ts_external = (TicketClosevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketClose/TicketClose.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketClose_TicketClosevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketClose_TicketClose = (component.exports);

/***/ }),

/***/ 8329:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isArrayLike = __webpack_require__(4894);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),

/***/ 8399:
/***/ (function(module) {

"use strict";
module.exports = require("@kwixeo/table-vue");

/***/ }),

/***/ 8618:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_ConfigurationView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConfigurationView.vue?vue&type=template&id=35198680
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('b-tabs',{staticClass:"tabs-card"},[_c('b-tab',{attrs:{"title":_vm.$t('tickets.configuration.menuLabel')}},[_c('Mailbox')],1),_c('b-tab',{attrs:{"title":_vm.$t('tickets.configuration.references')}},[_c('TicketReferences')],1),_c('b-tab',{attrs:{"title":_vm.$t('tickets.configuration.automationMenu'),"lazy":""}},[_c('AutomationList')],1),_c('b-tab',{attrs:{"title":_vm.$t('tickets.configuration.notificationMenu')}},[_c('Notifications')],1),_c('b-tab',{attrs:{"title":_vm.$t('tickets.configuration.closeMenu')}},[_c('TicketAutoClose')],1)],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/Mailbox/Mailbox.vue + 3 modules
var Mailbox = __webpack_require__(1416);
// EXTERNAL MODULE: ./src/components/Notifications/Notifications.vue + 3 modules
var Notifications = __webpack_require__(9613);
// EXTERNAL MODULE: ./src/components/TicketAutoClose/TicketAutoClose.vue + 3 modules
var TicketAutoClose = __webpack_require__(9168);
// EXTERNAL MODULE: ./src/components/AutomationList/AutomationList.vue + 3 modules
var AutomationList = __webpack_require__(2120);
;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketReferences/TicketReferences.vue?vue&type=template&id=5ec9f1f6
var TicketReferencesvue_type_template_id_5ec9f1f6_render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('k-form',{attrs:{"action":_vm.formAction,"method":"put"},on:{"submitComplete":_vm.formSubmitted}},[_c('p',{staticClass:"font-weight-bold"},[_vm._v(" "+_vm._s(_vm.$t('catalog.references.referenceExplain'))+" ")]),_c('table',{staticClass:"table table-sm table-bordered w-auto"},[_c('tr',[_c('td',{staticClass:"pr-4"},[_vm._v("{YY}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceYear4')))])]),_c('tr',[_c('td',[_vm._v("{Y}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceYear2')))])]),_c('tr',[_c('td',[_vm._v("{m}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceMonth')))])]),_c('tr',[_c('td',[_vm._v("{d}")]),_c('td',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceDay')))])])]),_c('b-table-simple',{staticClass:"w-auto table-references text-nowrap",attrs:{"responsive":""}},[_c('thead',[_c('tr',{staticClass:"small-text"},[_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referencePrefix')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceTypeNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceNextNumber')))]),_c('th',[_vm._v(_vm._s(_vm.$t('catalog.references.referenceLength')))]),_c('th',[_vm._v(_vm._s(_vm.$t('interface.example')))])])]),_c('tbody',[_c('tr',[_c('td',[_c('k-form-input',{attrs:{"name":"configs[tickets_reference_prefix]","required":"","max":"10","size":"sm"},model:{value:(_vm.localConfig.tickets_reference_prefix),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_reference_prefix", $$v)},expression:"localConfig.tickets_reference_prefix"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[tickets_reference_mode]","options":_vm.numberTypes,"reduce":opt => opt.id,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.tickets_reference_mode),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_reference_mode", $$v)},expression:"localConfig.tickets_reference_mode"}})],1),_c('td',[_c('k-form-number',{attrs:{"name":"configs[tickets_reference_number]","min":1,"maxDecimal":0,"size":"sm","disabled":_vm.localConfig.tickets_reference_mode !== 1},model:{value:(_vm.localConfig.tickets_reference_number),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_reference_number", $$v)},expression:"localConfig.tickets_reference_number"}})],1),_c('td',[_c('k-form-select',{attrs:{"name":"configs[tickets_reference_length]","options":_vm.lengthOptions,"clearable":false,"size":"sm"},model:{value:(_vm.localConfig.tickets_reference_length),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_reference_length", $$v)},expression:"localConfig.tickets_reference_length"}})],1),_c('td',[_vm._v(_vm._s(_vm.referenceExample))])])])]),_c('KFormStickyBar',{attrs:{"parent":"#page"}},[_c('b-button',{staticClass:"mr-4",attrs:{"type":"button","size":"sm"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(_vm._s(_vm.$t('interface.cancel')))]),_c('b-button',{attrs:{"type":"submit","variant":"primary","size":"sm"}},[_vm._v(_vm._s(_vm.$t('interface.save')))])],1)],1)],1)
}
var TicketReferencesvue_type_template_id_5ec9f1f6_staticRenderFns = []


// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketReferences/TicketReferences.ts?vue&type=script&lang=ts&external





var TicketReferences = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketReferences, _super);
    function TicketReferences() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.lengthOptions = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
        _this.numberTypes = [
            { id: 1, label: _this.$t('catalog.stock.params.referenceNormal') },
            { id: 2, label: _this.$t('catalog.stock.params.referenceMonth') },
            { id: 3, label: _this.$t('catalog.stock.params.referenceYear') }
        ];
        return _this;
    }
    Object.defineProperty(TicketReferences.prototype, "referenceExample", {
        get: function () {
            return this.generateReferenceExample(this.localConfig.tickets_reference_prefix, this.localConfig.tickets_reference_number, this.localConfig.tickets_reference_length);
        },
        enumerable: false,
        configurable: true
    });
    TicketReferences.prototype.pad = function (number, length) {
        if (!length) {
            return;
        }
        length = length - String(number).length + 1;
        return new Array(length).join('0').slice((length || 2) * -1) + number;
    };
    TicketReferences.prototype.generateReferenceExample = function (prefix, number, length) {
        if (!prefix) {
            return;
        }
        var example = this.pad(number, length);
        var date = new Date();
        prefix = prefix.replace('{YY}', String(date.getFullYear()))
            .replace('{Y}', String(date.getFullYear()).substr(2, 2))
            .replace('{m}', String(('0' + (date.getMonth() + 1)).slice(-2)))
            .replace('{d}', String(('0' + date.getDate()).slice(-2)));
        return prefix + example;
    };
    TicketReferences = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormInput: form_vue_.KFormInput, KFormSelect: form_vue_.KFormSelect, KFormNumber: form_vue_.KFormNumber, KFormStickyBar: form_vue_.KFormStickyBar,
                BTableSimple: external_bootstrap_vue_.BTableSimple, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], TicketReferences);
    return TicketReferences;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var TicketReferencesvue_type_script_lang_ts_external = (TicketReferences);

;// ./src/components/TicketReferences/TicketReferences.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketReferences_TicketReferencesvue_type_script_lang_ts_external = (TicketReferencesvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketReferences/TicketReferences.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketReferences_TicketReferencesvue_type_script_lang_ts_external,
  TicketReferencesvue_type_template_id_5ec9f1f6_render,
  TicketReferencesvue_type_template_id_5ec9f1f6_staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketReferences_TicketReferences = (component.exports);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/ConfigurationView.vue?vue&type=script&lang=ts








var ConfigurationView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(ConfigurationView, _super);
    function ConfigurationView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ConfigurationView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BTabs: external_bootstrap_vue_.BTabs, BTab: external_bootstrap_vue_.BTab,
                Mailbox: Mailbox/* default */.A,
                Notifications: Notifications/* default */.A,
                TicketAutoClose: TicketAutoClose/* default */.A,
                AutomationList: AutomationList/* default */.A,
                TicketReferences: TicketReferences_TicketReferences
            }
        })
    ], ConfigurationView);
    return ConfigurationView;
}(lib/* Vue */.lD));
/* harmony default export */ var ConfigurationViewvue_type_script_lang_ts = (ConfigurationView);

;// ./src/views/ConfigurationView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_ConfigurationViewvue_type_script_lang_ts = (ConfigurationViewvue_type_script_lang_ts); 
;// ./src/views/ConfigurationView.vue





/* normalize component */
;
var ConfigurationView_component = (0,componentNormalizer/* default */.A)(
  views_ConfigurationViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_ConfigurationView = (ConfigurationView_component.exports);

/***/ }),

/***/ 8887:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ views_TemplatesListView; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TemplatesListView.vue?vue&type=template&id=579746f4
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('TemplatesList')
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: ./src/components/TemplatesList/TemplatesList.vue + 3 modules
var TemplatesList = __webpack_require__(735);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/views/TemplatesListView.vue?vue&type=script&lang=ts



var TemplatesListView = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TemplatesListView, _super);
    function TemplatesListView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    TemplatesListView = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                TemplatesList: TemplatesList/* default */.A
            }
        })
    ], TemplatesListView);
    return TemplatesListView;
}(lib/* Vue */.lD));
/* harmony default export */ var TemplatesListViewvue_type_script_lang_ts = (TemplatesListView);

;// ./src/views/TemplatesListView.vue?vue&type=script&lang=ts
 /* harmony default export */ var views_TemplatesListViewvue_type_script_lang_ts = (TemplatesListViewvue_type_script_lang_ts); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/views/TemplatesListView.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  views_TemplatesListViewvue_type_script_lang_ts,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var views_TemplatesListView = (component.exports);

/***/ }),

/***/ 8984:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var isPrototype = __webpack_require__(5527),
    nativeKeys = __webpack_require__(3650);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),

/***/ 9137:
/***/ (function(__unused_webpack_module, exports) {

"use strict";
var __webpack_unused_export__;

__webpack_unused_export__ = ({ value: true });
var prefix = 'fas';
var iconName = 'sync';
var width = 512;
var height = 512;
var ligatures = [];
var unicode = 'f021';
var svgPathData = 'M440.65 12.57l4 82.77A247.16 247.16 0 0 0 255.83 8C134.73 8 33.91 94.92 12.29 209.82A12 12 0 0 0 24.09 224h49.05a12 12 0 0 0 11.67-9.26 175.91 175.91 0 0 1 317-56.94l-101.46-4.86a12 12 0 0 0-12.57 12v47.41a12 12 0 0 0 12 12H500a12 12 0 0 0 12-12V12a12 12 0 0 0-12-12h-47.37a12 12 0 0 0-11.98 12.57zM255.83 432a175.61 175.61 0 0 1-146-77.8l101.8 4.87a12 12 0 0 0 12.57-12v-47.4a12 12 0 0 0-12-12H12a12 12 0 0 0-12 12V500a12 12 0 0 0 12 12h47.35a12 12 0 0 0 12-12.6l-4.15-82.57A247.17 247.17 0 0 0 255.83 504c121.11 0 221.93-86.92 243.55-201.82a12 12 0 0 0-11.8-14.18h-49.05a12 12 0 0 0-11.67 9.26A175.86 175.86 0 0 1 255.83 432z';

exports.mw = {
  prefix: prefix,
  iconName: iconName,
  icon: [
    width,
    height,
    ligatures,
    unicode,
    svgPathData
  ]};

exports.VN = exports.mw;
__webpack_unused_export__ = prefix;
__webpack_unused_export__ = iconName;
__webpack_unused_export__ = width;
__webpack_unused_export__ = height;
__webpack_unused_export__ = ligatures;
__webpack_unused_export__ = unicode;
__webpack_unused_export__ = svgPathData;

/***/ }),

/***/ 9168:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketAutoClose_TicketAutoClose; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketAutoClose/TicketAutoClose.vue?vue&type=template&id=990873ae
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT"},on:{"submitComplete":_vm.formSubmitted}},[_c('h3',{staticClass:"form-title-alt mt-0"},[_vm._v(" "+_vm._s(_vm.$t('tickets.autoclose.title'))+" ")]),_c('b-row',{attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[tickets_auto_close_active]"},domProps:{"value":_vm.localConfig.tickets_auto_close_active ?? false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.tickets_auto_close_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_auto_close_active", $$v)},expression:"localConfig.tickets_auto_close_active"}},[_vm._v(" "+_vm._s(_vm.$t('tickets.autoclose.closeAfter'))+" ")])],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-spinner',{attrs:{"disabled":!_vm.localConfig.tickets_auto_close_active,"name":"configs[tickets_auto_close_active_delay]","size":"sm","min":2},model:{value:(_vm.localConfig.tickets_auto_close_active_delay),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_auto_close_active_delay", $$v)},expression:"localConfig.tickets_auto_close_active_delay"}})],1),_c('b-col',[_vm._v(" "+_vm._s(_vm.$t('tickets.autoclose.closeAfterDay'))+" ")])],1),(_vm.localConfig.tickets_auto_close_active)?[_c('b-row',{staticClass:"mt-3",attrs:{"align-v":"center"}},[_c('b-col',{attrs:{"cols":"auto"}},[_c('input',{attrs:{"type":"hidden","name":"configs[tickets_auto_close_notify_active]"},domProps:{"value":_vm.localConfig.tickets_auto_close_notify_active ?? false}}),_c('k-form-checkbox',{model:{value:(_vm.localConfig.tickets_auto_close_notify_active),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_auto_close_notify_active", $$v)},expression:"localConfig.tickets_auto_close_notify_active"}},[_vm._v(" "+_vm._s(_vm.$t('tickets.autoclose.sendNotification'))+" ")])],1),_c('b-col',{staticClass:"px-0",attrs:{"cols":"auto"}},[_c('k-form-spinner',{attrs:{"disabled":!_vm.localConfig.tickets_auto_close_notify_active,"name":"configs[tickets_auto_close_notify_delay]","size":"sm","min":1,"max":_vm.localConfig.tickets_auto_close_active_delay - 1},model:{value:(_vm.localConfig.tickets_auto_close_notify_delay),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_auto_close_notify_delay", $$v)},expression:"localConfig.tickets_auto_close_notify_delay"}})],1),_c('b-col',[_vm._v(" "+_vm._s(_vm.$t('tickets.autoclose.notifyClose'))+" ")])],1),(_vm.localConfig.tickets_auto_close_notify_active)?[_c('b-form-group',{staticClass:"mt-4",attrs:{"label":_vm.$t('tickets.notifications.message')}},[_c('k-form-editor',{attrs:{"size":"sm","config":_vm.editorConfig,"name":"configs[tickets_auto_close_message]"},model:{value:(_vm.localConfig.tickets_auto_close_message),callback:function ($$v) {_vm.$set(_vm.localConfig, "tickets_auto_close_message", $$v)},expression:"localConfig.tickets_auto_close_message"}})],1)]:_vm._e()]:_vm._e(),_c('p'),_c('b-button',{staticClass:"mr-3",attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.cancel.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: ./src/components/Notifications/editorConfig.ts
var editorConfig = __webpack_require__(339);
// EXTERNAL MODULE: ./src/components/Notifications/subjectConfig.ts
var subjectConfig = __webpack_require__(7112);
// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(2551);
// EXTERNAL MODULE: ./src/components/Notifications/variables.ts
var variables = __webpack_require__(9519);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketAutoClose/TicketAutoClose.ts?vue&type=script&lang=ts&external









var TicketAutoClose = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketAutoClose, _super);
    function TicketAutoClose() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Object.defineProperty(TicketAutoClose.prototype, "editorConfig", {
        get: function () {
            return (0,external_lodash_.merge)(editorConfig/* default */.A, {
                dynamicVariables: this.variables
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketAutoClose.prototype, "subjectConfig", {
        get: function () {
            return (0,external_lodash_.merge)(subjectConfig/* default */.A, {
                dynamicVariables: this.variables
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketAutoClose.prototype, "variables", {
        get: function () {
            return (0,variables/* default */.A)(this.$i18n);
        },
        enumerable: false,
        configurable: true
    });
    TicketAutoClose = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KFormSpinner: form_vue_.KFormSpinner, KFormCheckbox: form_vue_.KFormCheckbox, KForm: form_vue_.KForm, KFormEditor: form_vue_.KFormEditor,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BCol: external_bootstrap_vue_.BCol, BRow: external_bootstrap_vue_.BRow, BButton: external_bootstrap_vue_.BButton
            }
        })
    ], TicketAutoClose);
    return TicketAutoClose;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var TicketAutoClosevue_type_script_lang_ts_external = (TicketAutoClose);

;// ./src/components/TicketAutoClose/TicketAutoClose.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketAutoClose_TicketAutoClosevue_type_script_lang_ts_external = (TicketAutoClosevue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketAutoClose/TicketAutoClose.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketAutoClose_TicketAutoClosevue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketAutoClose_TicketAutoClose = (component.exports);

/***/ }),

/***/ 9325:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var freeGlobal = __webpack_require__(4840);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),

/***/ 9350:
/***/ (function(module) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),

/***/ 9356:
/***/ (function(module) {

"use strict";
module.exports = require("@fortawesome/vue-fontawesome");

/***/ }),

/***/ 9505:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ TicketItemInfos_TicketItemInfos; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/TicketItemInfos/TicketItemInfos.vue?vue&type=template&id=62864b87
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[(_vm.loading)?_c('Spinner'):[(_vm.ticket.reference)?_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.reference')}},[_vm._v(" "+_vm._s(_vm.ticket.reference)+" ")]):_vm._e(),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.attributedTo')}},[_c('TeamUserSelect',{attrs:{"role":"tickets","disabled":!_vm.can('tickets', 3)},model:{value:(_vm.ticket.team_user),callback:function ($$v) {_vm.$set(_vm.ticket, "team_user", $$v)},expression:"ticket.team_user"}})],1),_c('CustomerSelect',{attrs:{"withForm":false,"contactId":_vm.ticket.contact?.id,"withLink":"","disabled":!_vm.can('tickets', 3)},model:{value:(_vm.ticket.customer),callback:function ($$v) {_vm.$set(_vm.ticket, "customer", $$v)},expression:"ticket.customer"}}),_c('ContactSelect',{attrs:{"withForm":false,"customer":_vm.ticket.customer,"withLink":"","disabled":!_vm.can('tickets', 3)},model:{value:(_vm.ticket.contact),callback:function ($$v) {_vm.$set(_vm.ticket, "contact", $$v)},expression:"ticket.contact"}}),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.priority')}},[_c('k-form-select',{staticClass:"ticket-priorities-select",class:_vm.ticketPriorityClass,attrs:{"options":_vm.ticketPriorities,"clearable":false,"reduce":opt => opt.id,"disabled":!_vm.can('tickets', 3)},model:{value:(_vm.ticket.priority),callback:function ($$v) {_vm.$set(_vm.ticket, "priority", $$v)},expression:"ticket.priority"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.category')}},[_c('k-form-select',{attrs:{"options":_vm.categories,"disabled":!_vm.can('tickets', 3)},scopedSlots:_vm._u([{key:"selected-option",fn:function(category){return [_c('div',{staticClass:"ticket-select-option-category"},[(category.color)?_c('div',{staticClass:"ticket-color-indicator",style:({ 'background-color': category.color })}):_vm._e(),_vm._v(" "+_vm._s(category.label)+" ")])]}},{key:"option",fn:function(category){return [_c('div',{staticClass:"ticket-select-option-category"},[(category.color)?_c('div',{staticClass:"ticket-color-indicator",style:({ 'background-color': category.color })}):_vm._e(),_vm._v(" "+_vm._s(category.label)+" ")])]}}]),model:{value:(_vm.ticket.category),callback:function ($$v) {_vm.$set(_vm.ticket, "category", $$v)},expression:"ticket.category"}})],1),(_vm.tags.length > 0)?_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.tags')}},[_c('k-form-select',{attrs:{"options":_vm.tags,"multiple":"","disabled":!_vm.can('tickets', 3)},model:{value:(_vm.ticket.tags),callback:function ($$v) {_vm.$set(_vm.ticket, "tags", $$v)},expression:"ticket.tags"}})],1):_vm._e(),(_vm.ticket.from_name)?_c('b-form-group',{staticClass:"form-text",attrs:{"label":_vm.$t('tickets.ticket.createdBy')}},[_c('div',{staticClass:"d-flex"},[_c('Avatar',{staticClass:"mr-2",attrs:{"name":_vm.ticket.from_name}}),_c('div',{staticClass:"d-inline-block"},[_vm._v(" "+_vm._s(_vm.ticket.from_name)),_c('br'),_c('span',{staticClass:"small text-muted"},[_vm._v(" "+_vm._s(_vm.ticket.from_address)+" ")])])],1)]):_vm._e(),_c('b-form-group',{staticClass:"form-text",attrs:{"label":_vm.$t('tickets.ticket.createdAt')}},[_vm._v(" "+_vm._s(_vm.datetime(_vm.ticket.created_at))+" ")]),_c('CustomFieldsForm',{attrs:{"type":"ticket"},model:{value:(_vm.ticket.custom_fields),callback:function ($$v) {_vm.$set(_vm.ticket, "custom_fields", $$v)},expression:"ticket.custom_fields"}}),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.ticket.status')}},[_c('k-form-select',{attrs:{"options":_vm.ticketStatus,"clearable":false,"reduce":opt => opt.id,"disabled":!_vm.can('tickets', 3)},model:{value:(_vm.ticket.status),callback:function ($$v) {_vm.$set(_vm.ticket, "status", $$v)},expression:"ticket.status"}})],1)]],2)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "vuex"
var external_vuex_ = __webpack_require__(9998);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "@kwixeo/customers-vue"
var customers_vue_ = __webpack_require__(5858);
// EXTERNAL MODULE: external "@kwixeo/custom-fields-vue"
var custom_fields_vue_ = __webpack_require__(4696);
// EXTERNAL MODULE: ./src/mixins/LoadTicketElements.ts
var LoadTicketElements = __webpack_require__(8086);
// EXTERNAL MODULE: ./src/mixins/TicketPriorities.ts
var TicketPriorities = __webpack_require__(515);
// EXTERNAL MODULE: ./src/mixins/TicketStatusMixin.ts
var TicketStatusMixin = __webpack_require__(5480);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/TicketItemInfos/TicketItemInfos.ts?vue&type=script&lang=ts&external











var TicketItemInfos = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(TicketItemInfos, _super);
    function TicketItemInfos() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.ticket = {};
        _this.timeout = null;
        return _this;
    }
    TicketItemInfos.prototype.watchValue = function () {
        var _this = this;
        this.loading = true;
        this.ticket = JSON.parse(JSON.stringify(this.value));
        this.$nextTick(function () {
            _this.loading = false;
        });
    };
    Object.defineProperty(TicketItemInfos.prototype, "ticketPriorityClass", {
        get: function () {
            var cssClass = {
                'ticket-priority': true
            };
            if (this.ticket.priority) {
                cssClass['ticket-priority-' + this.ticket.priority] = true;
            }
            return cssClass;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TicketItemInfos.prototype, "formDatas", {
        get: function () {
            var ticket = this.ticket;
            var datas = {
                customer: ticket.customer ? ticket.customer.id : null,
                contact: ticket.contact ? ticket.contact.id : null,
                priority: ticket.priority,
                category: ticket.category ? ticket.category.id : null,
                tags: ticket.tags ? ticket.tags.map(function (tag) { return tag.id; }) : null,
                status: ticket.status
            };
            if (ticket.team_user) {
                datas.team_user = ticket.team_user.id;
            }
            return datas;
        },
        enumerable: false,
        configurable: true
    });
    TicketItemInfos.prototype.watchTicket = function () {
        if (this.loading) {
            return;
        }
        if (this.timeout) {
            clearTimeout(this.timeout);
        }
        this.timeout = setTimeout(this.submitForm, 1000);
    };
    TicketItemInfos.prototype.submitForm = function () {
        var _this = this;
        this.timeout = null;
        this.$kwTickets.axios.put('/ticket/' + this.ticket.id, this.formDatas)
            .then(function (response) {
            _this.$emit('input', response.data);
        });
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Prop */.kv)({ required: true })
    ], TicketItemInfos.prototype, "value", void 0);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('value', { immediate: true })
    ], TicketItemInfos.prototype, "watchValue", null);
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('ticket', { deep: true })
    ], TicketItemInfos.prototype, "watchTicket", null);
    TicketItemInfos = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                BFormGroup: external_bootstrap_vue_.BFormGroup,
                KFormSelect: form_vue_.KFormSelect, BCard: external_bootstrap_vue_.BCard,
                CustomerSelect: customers_vue_.CustomerSelect, ContactSelect: customers_vue_.ContactSelect,
                CustomFieldsForm: custom_fields_vue_.CustomFieldsForm,
                Spinner: interface_vue_.Spinner, Avatar: interface_vue_.Avatar, TeamUserSelect: interface_vue_.TeamUserSelect
            },
            methods: (0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapActions)('tickets', ['loadTags', 'loadCategories'])),
            computed: (0,tslib_es6/* __assign */.Cl)((0,tslib_es6/* __assign */.Cl)({}, (0,external_vuex_.mapGetters)('user', ['can'])), (0,external_vuex_.mapState)('tickets', ['tags', 'categories']))
        })
    ], TicketItemInfos);
    return TicketItemInfos;
}((0,lib/* Mixins */.Xe)(interface_vue_.DateMixin, TicketPriorities/* default */.A, LoadTicketElements/* default */.A, TicketStatusMixin/* default */.A)));
/* harmony default export */ var TicketItemInfosvue_type_script_lang_ts_external = (TicketItemInfos);

;// ./src/components/TicketItemInfos/TicketItemInfos.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var TicketItemInfos_TicketItemInfosvue_type_script_lang_ts_external = (TicketItemInfosvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/TicketItemInfos/TicketItemInfos.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  TicketItemInfos_TicketItemInfosvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var TicketItemInfos_TicketItemInfos = (component.exports);

/***/ }),

/***/ 9519:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
var variables = function (i18n) {
    return {
        company: {
            label: i18n.t('tickets.notifications.variables.ticketTitle'),
            variables: [
                { value: 'TICKET-SUBJECT', label: i18n.t('tickets.notifications.variables.subject') },
                { value: 'TICKET-MESSAGE', label: i18n.t('tickets.notifications.variables.message') },
                { value: 'TICKET-CUSTOMER', label: i18n.t('tickets.notifications.variables.customer') },
                { value: 'TICKET-CONTACT', label: i18n.t('tickets.notifications.variables.contact') },
                { value: 'TICKET-PRIORITY', label: i18n.t('tickets.notifications.variables.priority') },
                { value: 'TICKET-CATEGORY', label: i18n.t('tickets.notifications.variables.category') },
                { value: 'TICKET-TAGS', label: i18n.t('tickets.notifications.variables.tags') },
                { value: 'TICKET-USER', label: i18n.t('tickets.notifications.variables.user') },
            ]
        },
        tiers: {
            label: i18n.t('tickets.notifications.variables.userTitle'),
            variables: [
                { value: 'USER-FIRSTNAME', label: i18n.t('tickets.notifications.variables.firstname') },
                { value: 'USER-LASTNAME', label: i18n.t('tickets.notifications.variables.lastname') }
            ]
        }
    };
};
/* harmony default export */ __webpack_exports__.A = (variables);


/***/ }),

/***/ 9529:
/***/ (function(module) {

"use strict";
module.exports = require("bootstrap-vue");

/***/ }),

/***/ 9603:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  uA: function() { return /* reexport */ vue_class_component_esm; },
  O5: function() { return /* reexport */ Emit; },
  Xe: function() { return /* reexport */ mixins; },
  kv: function() { return /* reexport */ Prop; },
  lD: function() { return /* reexport */ (external_vue_default()); },
  ox: function() { return /* reexport */ Watch; }
});

// UNUSED EXPORTS: Inject, InjectReactive, Model, ModelSync, PropSync, Provide, ProvideReactive, Ref, VModel

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./node_modules/vue-class-component/dist/vue-class-component.esm.js
/**
  * vue-class-component v7.2.6
  * (c) 2015-present Evan You
  * @license MIT
  */


function _typeof(obj) {
  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
    _typeof = function (obj) {
      return typeof obj;
    };
  } else {
    _typeof = function (obj) {
      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    };
  }

  return _typeof(obj);
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _toConsumableArray(arr) {
  return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread();
}

function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) arr2[i] = arr[i];

    return arr2;
  }
}

function _iterableToArray(iter) {
  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance");
}

// The rational behind the verbose Reflect-feature check below is the fact that there are polyfills
// which add an implementation for Reflect.defineMetadata but not for Reflect.getOwnMetadataKeys.
// Without this check consumers will encounter hard to track down runtime errors.
function reflectionIsSupported() {
  return typeof Reflect !== 'undefined' && Reflect.defineMetadata && Reflect.getOwnMetadataKeys;
}
function copyReflectionMetadata(to, from) {
  forwardMetadata(to, from);
  Object.getOwnPropertyNames(from.prototype).forEach(function (key) {
    forwardMetadata(to.prototype, from.prototype, key);
  });
  Object.getOwnPropertyNames(from).forEach(function (key) {
    forwardMetadata(to, from, key);
  });
}

function forwardMetadata(to, from, propertyKey) {
  var metaKeys = propertyKey ? Reflect.getOwnMetadataKeys(from, propertyKey) : Reflect.getOwnMetadataKeys(from);
  metaKeys.forEach(function (metaKey) {
    var metadata = propertyKey ? Reflect.getOwnMetadata(metaKey, from, propertyKey) : Reflect.getOwnMetadata(metaKey, from);

    if (propertyKey) {
      Reflect.defineMetadata(metaKey, metadata, to, propertyKey);
    } else {
      Reflect.defineMetadata(metaKey, metadata, to);
    }
  });
}

var fakeArray = {
  __proto__: []
};
var hasProto = fakeArray instanceof Array;
function vue_class_component_esm_createDecorator(factory) {
  return function (target, key, index) {
    var Ctor = typeof target === 'function' ? target : target.constructor;

    if (!Ctor.__decorators__) {
      Ctor.__decorators__ = [];
    }

    if (typeof index !== 'number') {
      index = undefined;
    }

    Ctor.__decorators__.push(function (options) {
      return factory(options, key, index);
    });
  };
}
function mixins() {
  for (var _len = arguments.length, Ctors = new Array(_len), _key = 0; _key < _len; _key++) {
    Ctors[_key] = arguments[_key];
  }

  return external_vue_default().extend({
    mixins: Ctors
  });
}
function isPrimitive(value) {
  var type = _typeof(value);

  return value == null || type !== 'object' && type !== 'function';
}
function warn(message) {
  if (typeof console !== 'undefined') {
    console.warn('[vue-class-component] ' + message);
  }
}

function collectDataFromConstructor(vm, Component) {
  // override _init to prevent to init as Vue instance
  var originalInit = Component.prototype._init;

  Component.prototype._init = function () {
    var _this = this;

    // proxy to actual vm
    var keys = Object.getOwnPropertyNames(vm); // 2.2.0 compat (props are no longer exposed as self properties)

    if (vm.$options.props) {
      for (var key in vm.$options.props) {
        if (!vm.hasOwnProperty(key)) {
          keys.push(key);
        }
      }
    }

    keys.forEach(function (key) {
      Object.defineProperty(_this, key, {
        get: function get() {
          return vm[key];
        },
        set: function set(value) {
          vm[key] = value;
        },
        configurable: true
      });
    });
  }; // should be acquired class property values


  var data = new Component(); // restore original _init to avoid memory leak (#209)

  Component.prototype._init = originalInit; // create plain data object

  var plainData = {};
  Object.keys(data).forEach(function (key) {
    if (data[key] !== undefined) {
      plainData[key] = data[key];
    }
  });

  if (false) {}

  return plainData;
}

var $internalHooks = ['data', 'beforeCreate', 'created', 'beforeMount', 'mounted', 'beforeDestroy', 'destroyed', 'beforeUpdate', 'updated', 'activated', 'deactivated', 'render', 'errorCaptured', 'serverPrefetch' // 2.6
];
function componentFactory(Component) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  options.name = options.name || Component._componentTag || Component.name; // prototype props.

  var proto = Component.prototype;
  Object.getOwnPropertyNames(proto).forEach(function (key) {
    if (key === 'constructor') {
      return;
    } // hooks


    if ($internalHooks.indexOf(key) > -1) {
      options[key] = proto[key];
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(proto, key);

    if (descriptor.value !== void 0) {
      // methods
      if (typeof descriptor.value === 'function') {
        (options.methods || (options.methods = {}))[key] = descriptor.value;
      } else {
        // typescript decorated data
        (options.mixins || (options.mixins = [])).push({
          data: function data() {
            return _defineProperty({}, key, descriptor.value);
          }
        });
      }
    } else if (descriptor.get || descriptor.set) {
      // computed properties
      (options.computed || (options.computed = {}))[key] = {
        get: descriptor.get,
        set: descriptor.set
      };
    }
  });
  (options.mixins || (options.mixins = [])).push({
    data: function data() {
      return collectDataFromConstructor(this, Component);
    }
  }); // decorate options

  var decorators = Component.__decorators__;

  if (decorators) {
    decorators.forEach(function (fn) {
      return fn(options);
    });
    delete Component.__decorators__;
  } // find super


  var superProto = Object.getPrototypeOf(Component.prototype);
  var Super = superProto instanceof (external_vue_default()) ? superProto.constructor : (external_vue_default());
  var Extended = Super.extend(options);
  forwardStaticMembers(Extended, Component, Super);

  if (reflectionIsSupported()) {
    copyReflectionMetadata(Extended, Component);
  }

  return Extended;
}
var reservedPropertyNames = (/* unused pure expression or super */ null && ([// Unique id
'cid', // Super Vue constructor
'super', // Component options that will be used by the component
'options', 'superOptions', 'extendOptions', 'sealedOptions', // Private assets
'component', 'directive', 'filter']));
var shouldIgnore = {
  prototype: true,
  arguments: true,
  callee: true,
  caller: true
};

function forwardStaticMembers(Extended, Original, Super) {
  // We have to use getOwnPropertyNames since Babel registers methods as non-enumerable
  Object.getOwnPropertyNames(Original).forEach(function (key) {
    // Skip the properties that should not be overwritten
    if (shouldIgnore[key]) {
      return;
    } // Some browsers does not allow reconfigure built-in properties


    var extendedDescriptor = Object.getOwnPropertyDescriptor(Extended, key);

    if (extendedDescriptor && !extendedDescriptor.configurable) {
      return;
    }

    var descriptor = Object.getOwnPropertyDescriptor(Original, key); // If the user agent does not support `__proto__` or its family (IE <= 10),
    // the sub class properties may be inherited properties from the super class in TypeScript.
    // We need to exclude such properties to prevent to overwrite
    // the component options object which stored on the extended constructor (See #192).
    // If the value is a referenced value (object or function),
    // we can check equality of them and exclude it if they have the same reference.
    // If it is a primitive value, it will be forwarded for safety.

    if (!hasProto) {
      // Only `cid` is explicitly exluded from property forwarding
      // because we cannot detect whether it is a inherited property or not
      // on the no `__proto__` environment even though the property is reserved.
      if (key === 'cid') {
        return;
      }

      var superDescriptor = Object.getOwnPropertyDescriptor(Super, key);

      if (!isPrimitive(descriptor.value) && superDescriptor && superDescriptor.value === descriptor.value) {
        return;
      }
    } // Warn if the users manually declare reserved properties


    if (false) {}

    Object.defineProperty(Extended, key, descriptor);
  });
}

function Component(options) {
  if (typeof options === 'function') {
    return componentFactory(options);
  }

  return function (Component) {
    return componentFactory(Component, options);
  };
}

Component.registerHooks = function registerHooks(keys) {
  $internalHooks.push.apply($internalHooks, _toConsumableArray(keys));
};

/* harmony default export */ var vue_class_component_esm = (Component);


;// ./node_modules/vue-property-decorator/lib/decorators/Emit.js
var __spreadArrays = (undefined && undefined.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
// Code copied from Vue/src/shared/util.js
var hyphenateRE = /\B([A-Z])/g;
var hyphenate = function (str) { return str.replace(hyphenateRE, '-$1').toLowerCase(); };
/**
 * decorator of an event-emitter function
 * @param  event The name of the event
 * @return MethodDecorator
 */
function Emit(event) {
    return function (_target, propertyKey, descriptor) {
        var key = hyphenate(propertyKey);
        var original = descriptor.value;
        descriptor.value = function emitter() {
            var _this = this;
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var emit = function (returnValue) {
                var emitName = event || key;
                if (returnValue === undefined) {
                    if (args.length === 0) {
                        _this.$emit(emitName);
                    }
                    else if (args.length === 1) {
                        _this.$emit(emitName, args[0]);
                    }
                    else {
                        _this.$emit.apply(_this, __spreadArrays([emitName], args));
                    }
                }
                else {
                    args.unshift(returnValue);
                    _this.$emit.apply(_this, __spreadArrays([emitName], args));
                }
            };
            var returnValue = original.apply(this, args);
            if (isPromise(returnValue)) {
                returnValue.then(emit);
            }
            else {
                emit(returnValue);
            }
            return returnValue;
        };
    };
}
function isPromise(obj) {
    return obj instanceof Promise || (obj && typeof obj.then === 'function');
}

;// ./node_modules/vue-property-decorator/lib/helpers/metadata.js
/** @see {@link https://github.com/vuejs/vue-class-component/blob/master/src/reflect.ts} */
var reflectMetadataIsSupported = typeof Reflect !== 'undefined' && typeof Reflect.getMetadata !== 'undefined';
function metadata_applyMetadata(options, target, key) {
    if (reflectMetadataIsSupported) {
        if (!Array.isArray(options) &&
            typeof options !== 'function' &&
            !options.hasOwnProperty('type') &&
            typeof options.type === 'undefined') {
            var type = Reflect.getMetadata('design:type', target, key);
            if (type !== Object) {
                options.type = type;
            }
        }
    }
}

;// ./node_modules/vue-property-decorator/lib/decorators/Model.js


/**
 * decorator of model
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function Model(event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
            componentOptions.model = { prop: k, event: event || k };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/ModelSync.js


/**
 * decorator of synced model and prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param  event event name
 * @param options options
 * @return PropertyDecorator
 */
function ModelSync(propName, event, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            componentOptions.model = { prop: propName, event: event || k };
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    // @ts-ignore
                    this.$emit(event, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Prop.js


/**
 * decorator of a prop
 * @param  options the options for the prop
 * @return PropertyDecorator | void
 */
function Prop(options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        metadata_applyMetadata(options, target, key);
        vue_class_component_esm_createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[k] = options;
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/PropSync.js


/**
 * decorator of a synced prop
 * @param propName the name to interface with from outside, must be different from decorated property
 * @param options the options for the synced prop
 * @return PropertyDecorator | void
 */
function PropSync(propName, options) {
    if (options === void 0) { options = {}; }
    return function (target, key) {
        applyMetadata(options, target, key);
        createDecorator(function (componentOptions, k) {
            ;
            (componentOptions.props || (componentOptions.props = {}))[propName] = options;
            (componentOptions.computed || (componentOptions.computed = {}))[k] = {
                get: function () {
                    return this[propName];
                },
                set: function (value) {
                    this.$emit("update:" + propName, value);
                },
            };
        })(target, key);
    };
}

;// ./node_modules/vue-property-decorator/lib/decorators/Watch.js

/**
 * decorator of a watch function
 * @param  path the path or the expression to observe
 * @param  WatchOption
 * @return MethodDecorator
 */
function Watch(path, options) {
    if (options === void 0) { options = {}; }
    var _a = options.deep, deep = _a === void 0 ? false : _a, _b = options.immediate, immediate = _b === void 0 ? false : _b;
    return vue_class_component_esm_createDecorator(function (componentOptions, handler) {
        if (typeof componentOptions.watch !== 'object') {
            componentOptions.watch = Object.create(null);
        }
        var watch = componentOptions.watch;
        if (typeof watch[path] === 'object' && !Array.isArray(watch[path])) {
            watch[path] = [watch[path]];
        }
        else if (typeof watch[path] === 'undefined') {
            watch[path] = [];
        }
        watch[path].push({ handler: handler, deep: deep, immediate: immediate });
    });
}

;// ./node_modules/vue-property-decorator/lib/index.js
/** vue-property-decorator verson 9.1.2 MIT LICENSE copyright 2020 kaorun343 */
/// <reference types='reflect-metadata'/>

















/***/ }),

/***/ 9613:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  A: function() { return /* binding */ Notifications_Notifications; }
});

;// ./node_modules/@vue/vue-loader-v15/lib/loaders/templateLoader.js??ruleSet[1].rules[3]!./node_modules/@vue/vue-loader-v15/lib/index.js??vue-loader-options!./src/components/Notifications/Notifications.vue?vue&type=template&id=5505a8a2
var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',[_c('p',[_vm._v(" "+_vm._s(_vm.$t('tickets.notifications.explain'))+" ")]),_c('b-form-group',{staticClass:"mb-4 position-relative",staticStyle:{"z-index":"9999999999"},attrs:{"label":_vm.$t('tickets.notifications.toCustom')}},[_c('k-form-select',{attrs:{"reduce":opt => opt.id,"placeholder":_vm.$t('tickets.notifications.choose'),"options":_vm.notifications,"clearable":false,"getOptionLabel":_vm.notificationLabel},model:{value:(_vm.selectedNotification),callback:function ($$v) {_vm.selectedNotification=$$v},expression:"selectedNotification"}})],1),(_vm.selectedNotification)?_c('k-form',{attrs:{"action":_vm.formAction,"method":"PUT","value":_vm.formValues},on:{"submitComplete":_vm.formSubmitted}},[_c('k-form-checkbox',{staticClass:"text-danger mb-4",model:{value:(_vm.disabled),callback:function ($$v) {_vm.disabled=$$v},expression:"disabled"}},[_c('strong',[_vm._v(_vm._s(_vm.$t('tickets.notifications.disabled')))])]),(!_vm.disabled)?[_c('b-form-group',{attrs:{"label":"Destinataires"}},[_c('p',{staticClass:"text-danger mb-2"},[_vm._v(" "+_vm._s(_vm.$t('tickets.notifications.linkedUser'))+" ")]),_c('b-form-radio-group',{attrs:{"options":_vm.recipientsOptions},model:{value:(_vm.allRecipients),callback:function ($$v) {_vm.allRecipients=$$v},expression:"allRecipients"}}),(!_vm.allRecipients)?_c('TeamUserSelect',{staticClass:"mt-2",attrs:{"multiple":"","role":"tickets","placeholder":_vm.$t('tickets.notifications.noUser')},model:{value:(_vm.recipients),callback:function ($$v) {_vm.recipients=$$v},expression:"recipients"}}):_vm._e()],1),_c('h3',{staticClass:"form-title-alt"},[_vm._v(" "+_vm._s(_vm.$t('tickets.notifications.customizeMessage'))+" ")]),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.notifications.subject')}},[_c('k-form-editor',{attrs:{"size":"sm","config":_vm.subjectConfig},model:{value:(_vm.subject),callback:function ($$v) {_vm.subject=$$v},expression:"subject"}})],1),_c('b-form-group',{attrs:{"label":_vm.$t('tickets.notifications.message')}},[_c('k-form-editor',{attrs:{"size":"sm","config":_vm.editorConfig},model:{value:(_vm.message),callback:function ($$v) {_vm.message=$$v},expression:"message"}}),_c('p',{staticClass:"mt-2 text-danger"},[_vm._v(" "+_vm._s(_vm.$t('tickets.notifications.linkExplain'))+" ")])],1)]:_vm._e(),_c('b-button',{staticClass:"mr-3",attrs:{"variant":"secondary"},on:{"click":function($event){$event.preventDefault();return _vm.clearNotification.apply(null, arguments)}}},[_vm._v(" "+_vm._s(_vm.$t('interface.cancel'))+" ")]),_c('b-button',{attrs:{"type":"submit","variant":"primary"}},[_vm._v(" "+_vm._s(_vm.$t('interface.save'))+" ")])],2):_vm._e()],1)
}
var staticRenderFns = []


// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
// EXTERNAL MODULE: ./node_modules/vue-property-decorator/lib/index.js + 8 modules
var lib = __webpack_require__(9603);
// EXTERNAL MODULE: external "@kwixeo/form-vue"
var form_vue_ = __webpack_require__(8057);
// EXTERNAL MODULE: external "bootstrap-vue"
var external_bootstrap_vue_ = __webpack_require__(9529);
// EXTERNAL MODULE: ./src/components/Notifications/editorConfig.ts
var editorConfig = __webpack_require__(339);
// EXTERNAL MODULE: ./src/components/Notifications/subjectConfig.ts
var subjectConfig = __webpack_require__(7112);
// EXTERNAL MODULE: ./src/components/Notifications/variables.ts
var variables = __webpack_require__(9519);
// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
// EXTERNAL MODULE: external "lodash"
var external_lodash_ = __webpack_require__(2551);
;// ./node_modules/thread-loader/dist/cjs.js!./node_modules/ts-loader/index.js??clonedRuleSet-40.use[1]!./src/components/Notifications/Notifications.ts?vue&type=script&lang=ts&external









var Notifications = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(Notifications, _super);
    function Notifications() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.notifications = [
            { label: _this.$t('tickets.notifications.create'), id: 'new_ticket' },
            { label: _this.$t('tickets.notifications.assign'), id: 'ticket_assigned' },
            { label: _this.$t('tickets.notifications.newMessage'), id: 'new_comment' },
            { label: _this.$t('tickets.notifications.newComment'), id: 'new_private_note' },
            { label: _this.$t('tickets.notifications.close'), id: 'ticket_closed' }
        ];
        _this.recipientsOptions = [
            { text: _this.$t('tickets.notifications.allUser'), value: true },
            { text: _this.$t('tickets.notifications.onlyUser'), value: false }
        ];
        _this.selectedNotification = null;
        _this.allRecipients = true;
        _this.recipients = null;
        _this.disabled = false;
        _this.subject = null;
        _this.message = null;
        return _this;
    }
    Object.defineProperty(Notifications.prototype, "notificationLabel", {
        get: function () {
            var _this = this;
            return function (notification) {
                var label = '';
                if (_this.localConfig['tickets_' + notification.id + '_disabled']) {
                    label += '[Désactivé] ';
                }
                return label + notification.label;
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notifications.prototype, "editorConfig", {
        get: function () {
            return (0,external_lodash_.merge)(editorConfig/* default */.A, {
                dynamicVariables: this.variables
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notifications.prototype, "subjectConfig", {
        get: function () {
            return (0,external_lodash_.merge)(subjectConfig/* default */.A, {
                dynamicVariables: this.variables
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notifications.prototype, "variables", {
        get: function () {
            return (0,variables/* default */.A)(this.$i18n);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Notifications.prototype, "formValues", {
        get: function () {
            var _a, _b;
            var selected = this.selectedNotification;
            var values = {};
            values['tickets_' + selected + '_disabled'] = this.disabled;
            values['tickets_' + selected + '_all_recipients'] = this.allRecipients;
            values['tickets_' + selected + '_recipients'] = (_b = (_a = this.recipients) === null || _a === void 0 ? void 0 : _a.map(function (teamUser) { return teamUser.id; })) !== null && _b !== void 0 ? _b : [];
            values['tickets_' + selected + '_subject'] = this.subject;
            values['tickets_' + selected + '_message'] = this.message;
            return {
                configs: values
            };
        },
        enumerable: false,
        configurable: true
    });
    Notifications.prototype.watchSelectedNotification = function () {
        var selected = this.selectedNotification;
        if (!selected) {
            return;
        }
        this.allRecipients = this.localConfig['tickets_' + selected + '_all_recipients'];
        this.recipients = this.localConfig['tickets_' + selected + '_recipients'];
        this.disabled = this.localConfig['tickets_' + selected + '_disabled'];
        this.subject = this.localConfig['tickets_' + selected + '_subject'];
        this.message = this.localConfig['tickets_' + selected + '_message'];
    };
    Notifications.prototype.clearNotification = function () {
        this.selectedNotification = null;
        this.subject = null;
        this.message = null;
    };
    Notifications.prototype.formSubmitted = function (response) {
        this.applyNewTeam(response.data);
        this.clearNotification();
    };
    (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Watch */.ox)('selectedNotification')
    ], Notifications.prototype, "watchSelectedNotification", null);
    Notifications = (0,tslib_es6/* __decorate */.Cg)([
        (0,lib/* Component */.uA)({
            components: {
                KForm: form_vue_.KForm, KFormCheckbox: form_vue_.KFormCheckbox, KFormSpinner: form_vue_.KFormSpinner, KFormSelect: form_vue_.KFormSelect, KFormEditor: form_vue_.KFormEditor, KFormInput: form_vue_.KFormInput,
                BFormGroup: external_bootstrap_vue_.BFormGroup, BRow: external_bootstrap_vue_.BRow, BCol: external_bootstrap_vue_.BCol, BButton: external_bootstrap_vue_.BButton, BFormRadioGroup: external_bootstrap_vue_.BFormRadioGroup,
                TeamUserSelect: interface_vue_.TeamUserSelect
            }
        })
    ], Notifications);
    return Notifications;
}((0,lib/* Mixins */.Xe)(interface_vue_.TeamConfigMixin)));
/* harmony default export */ var Notificationsvue_type_script_lang_ts_external = (Notifications);

;// ./src/components/Notifications/Notifications.ts?vue&type=script&lang=ts&external
 /* harmony default export */ var Notifications_Notificationsvue_type_script_lang_ts_external = (Notificationsvue_type_script_lang_ts_external); 
// EXTERNAL MODULE: ./node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js
var componentNormalizer = __webpack_require__(1656);
;// ./src/components/Notifications/Notifications.vue





/* normalize component */
;
var component = (0,componentNormalizer/* default */.A)(
  Notifications_Notificationsvue_type_script_lang_ts_external,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* harmony default export */ var Notifications_Notifications = (component.exports);

/***/ }),

/***/ 9754:
/***/ (function(module, __unused_webpack_exports, __webpack_require__) {

var arrayEach = __webpack_require__(3729),
    baseEach = __webpack_require__(909),
    castFunction = __webpack_require__(4066),
    isArray = __webpack_require__(6449);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),

/***/ 9935:
/***/ (function(module) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),

/***/ 9998:
/***/ (function(module) {

"use strict";
module.exports = require("vuex");

/***/ })

/******/ 	});
/************************************************************************/
/******/ 	// The module cache
/******/ 	var __webpack_module_cache__ = {};
/******/ 	
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/ 		// Check if module is in cache
/******/ 		var cachedModule = __webpack_module_cache__[moduleId];
/******/ 		if (cachedModule !== undefined) {
/******/ 			return cachedModule.exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = __webpack_module_cache__[moduleId] = {
/******/ 			id: moduleId,
/******/ 			loaded: false,
/******/ 			exports: {}
/******/ 		};
/******/ 	
/******/ 		// Execute the module function
/******/ 		__webpack_modules__[moduleId](module, module.exports, __webpack_require__);
/******/ 	
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/ 	
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/ 	
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = __webpack_modules__;
/******/ 	
/************************************************************************/
/******/ 	/* webpack/runtime/compat get default export */
/******/ 	!function() {
/******/ 		// getDefaultExport function for compatibility with non-harmony modules
/******/ 		__webpack_require__.n = function(module) {
/******/ 			var getter = module && module.__esModule ?
/******/ 				function() { return module['default']; } :
/******/ 				function() { return module; };
/******/ 			__webpack_require__.d(getter, { a: getter });
/******/ 			return getter;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/define property getters */
/******/ 	!function() {
/******/ 		// define getter functions for harmony exports
/******/ 		__webpack_require__.d = function(exports, definition) {
/******/ 			for(var key in definition) {
/******/ 				if(__webpack_require__.o(definition, key) && !__webpack_require__.o(exports, key)) {
/******/ 					Object.defineProperty(exports, key, { enumerable: true, get: definition[key] });
/******/ 				}
/******/ 			}
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/ensure chunk */
/******/ 	!function() {
/******/ 		__webpack_require__.f = {};
/******/ 		// This file contains only the entry chunk.
/******/ 		// The chunk loading function for additional chunks
/******/ 		__webpack_require__.e = function(chunkId) {
/******/ 			return Promise.all(Object.keys(__webpack_require__.f).reduce(function(promises, key) {
/******/ 				__webpack_require__.f[key](chunkId, promises);
/******/ 				return promises;
/******/ 			}, []));
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get javascript chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.u = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return "tickets.common." + "tickets" + ".js";
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/get mini-css chunk filename */
/******/ 	!function() {
/******/ 		// This function allow to reference async chunks
/******/ 		__webpack_require__.miniCssF = function(chunkId) {
/******/ 			// return url for filenames based on template
/******/ 			return undefined;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/global */
/******/ 	!function() {
/******/ 		__webpack_require__.g = (function() {
/******/ 			if (typeof globalThis === 'object') return globalThis;
/******/ 			try {
/******/ 				return this || new Function('return this')();
/******/ 			} catch (e) {
/******/ 				if (typeof window === 'object') return window;
/******/ 			}
/******/ 		})();
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/hasOwnProperty shorthand */
/******/ 	!function() {
/******/ 		__webpack_require__.o = function(obj, prop) { return Object.prototype.hasOwnProperty.call(obj, prop); }
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/load script */
/******/ 	!function() {
/******/ 		var inProgress = {};
/******/ 		var dataWebpackPrefix = "@kwixeo/tickets-vue:";
/******/ 		// loadScript function to load a script via script tag
/******/ 		__webpack_require__.l = function(url, done, key, chunkId) {
/******/ 			if(inProgress[url]) { inProgress[url].push(done); return; }
/******/ 			var script, needAttach;
/******/ 			if(key !== undefined) {
/******/ 				var scripts = document.getElementsByTagName("script");
/******/ 				for(var i = 0; i < scripts.length; i++) {
/******/ 					var s = scripts[i];
/******/ 					if(s.getAttribute("src") == url || s.getAttribute("data-webpack") == dataWebpackPrefix + key) { script = s; break; }
/******/ 				}
/******/ 			}
/******/ 			if(!script) {
/******/ 				needAttach = true;
/******/ 				script = document.createElement('script');
/******/ 		
/******/ 				script.charset = 'utf-8';
/******/ 				script.timeout = 120;
/******/ 				if (__webpack_require__.nc) {
/******/ 					script.setAttribute("nonce", __webpack_require__.nc);
/******/ 				}
/******/ 				script.setAttribute("data-webpack", dataWebpackPrefix + key);
/******/ 		
/******/ 				script.src = url;
/******/ 			}
/******/ 			inProgress[url] = [done];
/******/ 			var onScriptComplete = function(prev, event) {
/******/ 				// avoid mem leaks in IE.
/******/ 				script.onerror = script.onload = null;
/******/ 				clearTimeout(timeout);
/******/ 				var doneFns = inProgress[url];
/******/ 				delete inProgress[url];
/******/ 				script.parentNode && script.parentNode.removeChild(script);
/******/ 				doneFns && doneFns.forEach(function(fn) { return fn(event); });
/******/ 				if(prev) return prev(event);
/******/ 			}
/******/ 			var timeout = setTimeout(onScriptComplete.bind(null, undefined, { type: 'timeout', target: script }), 120000);
/******/ 			script.onerror = onScriptComplete.bind(null, script.onerror);
/******/ 			script.onload = onScriptComplete.bind(null, script.onload);
/******/ 			needAttach && document.head.appendChild(script);
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/make namespace object */
/******/ 	!function() {
/******/ 		// define __esModule on exports
/******/ 		__webpack_require__.r = function(exports) {
/******/ 			if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
/******/ 				Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
/******/ 			}
/******/ 			Object.defineProperty(exports, '__esModule', { value: true });
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/node module decorator */
/******/ 	!function() {
/******/ 		__webpack_require__.nmd = function(module) {
/******/ 			module.paths = [];
/******/ 			if (!module.children) module.children = [];
/******/ 			return module;
/******/ 		};
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/publicPath */
/******/ 	!function() {
/******/ 		__webpack_require__.p = "";
/******/ 	}();
/******/ 	
/******/ 	/* webpack/runtime/jsonp chunk loading */
/******/ 	!function() {
/******/ 		// no baseURI
/******/ 		
/******/ 		// object to store loaded and loading chunks
/******/ 		// undefined = chunk not loaded, null = chunk preloaded/prefetched
/******/ 		// [resolve, reject, Promise] = chunk loading, 0 = chunk loaded
/******/ 		var installedChunks = {
/******/ 			135: 0
/******/ 		};
/******/ 		
/******/ 		__webpack_require__.f.j = function(chunkId, promises) {
/******/ 				// JSONP chunk loading for javascript
/******/ 				var installedChunkData = __webpack_require__.o(installedChunks, chunkId) ? installedChunks[chunkId] : undefined;
/******/ 				if(installedChunkData !== 0) { // 0 means "already installed".
/******/ 		
/******/ 					// a Promise means "currently loading".
/******/ 					if(installedChunkData) {
/******/ 						promises.push(installedChunkData[2]);
/******/ 					} else {
/******/ 						if(true) { // all chunks have JS
/******/ 							// setup Promise in chunk cache
/******/ 							var promise = new Promise(function(resolve, reject) { installedChunkData = installedChunks[chunkId] = [resolve, reject]; });
/******/ 							promises.push(installedChunkData[2] = promise);
/******/ 		
/******/ 							// start chunk loading
/******/ 							var url = __webpack_require__.p + __webpack_require__.u(chunkId);
/******/ 							// create error before stack unwound to get useful stacktrace later
/******/ 							var error = new Error();
/******/ 							var loadingEnded = function(event) {
/******/ 								if(__webpack_require__.o(installedChunks, chunkId)) {
/******/ 									installedChunkData = installedChunks[chunkId];
/******/ 									if(installedChunkData !== 0) installedChunks[chunkId] = undefined;
/******/ 									if(installedChunkData) {
/******/ 										var errorType = event && (event.type === 'load' ? 'missing' : event.type);
/******/ 										var realSrc = event && event.target && event.target.src;
/******/ 										error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
/******/ 										error.name = 'ChunkLoadError';
/******/ 										error.type = errorType;
/******/ 										error.request = realSrc;
/******/ 										installedChunkData[1](error);
/******/ 									}
/******/ 								}
/******/ 							};
/******/ 							__webpack_require__.l(url, loadingEnded, "chunk-" + chunkId, chunkId);
/******/ 						}
/******/ 					}
/******/ 				}
/******/ 		};
/******/ 		
/******/ 		// no prefetching
/******/ 		
/******/ 		// no preloaded
/******/ 		
/******/ 		// no HMR
/******/ 		
/******/ 		// no HMR manifest
/******/ 		
/******/ 		// no on chunks loaded
/******/ 		
/******/ 		// install a JSONP callback for chunk loading
/******/ 		var webpackJsonpCallback = function(parentChunkLoadingFunction, data) {
/******/ 			var chunkIds = data[0];
/******/ 			var moreModules = data[1];
/******/ 			var runtime = data[2];
/******/ 			// add "moreModules" to the modules object,
/******/ 			// then flag all "chunkIds" as loaded and fire callback
/******/ 			var moduleId, chunkId, i = 0;
/******/ 			if(chunkIds.some(function(id) { return installedChunks[id] !== 0; })) {
/******/ 				for(moduleId in moreModules) {
/******/ 					if(__webpack_require__.o(moreModules, moduleId)) {
/******/ 						__webpack_require__.m[moduleId] = moreModules[moduleId];
/******/ 					}
/******/ 				}
/******/ 				if(runtime) var result = runtime(__webpack_require__);
/******/ 			}
/******/ 			if(parentChunkLoadingFunction) parentChunkLoadingFunction(data);
/******/ 			for(;i < chunkIds.length; i++) {
/******/ 				chunkId = chunkIds[i];
/******/ 				if(__webpack_require__.o(installedChunks, chunkId) && installedChunks[chunkId]) {
/******/ 					installedChunks[chunkId][0]();
/******/ 				}
/******/ 				installedChunks[chunkId] = 0;
/******/ 			}
/******/ 		
/******/ 		}
/******/ 		
/******/ 		var chunkLoadingGlobal = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_tickets_vue"] = (typeof self !== 'undefined' ? self : this)["webpackChunk_kwixeo_tickets_vue"] || [];
/******/ 		chunkLoadingGlobal.forEach(webpackJsonpCallback.bind(null, 0));
/******/ 		chunkLoadingGlobal.push = webpackJsonpCallback.bind(null, chunkLoadingGlobal.push.bind(chunkLoadingGlobal));
/******/ 	}();
/******/ 	
/************************************************************************/
var __webpack_exports__ = {};
// This entry needs to be wrapped in an IIFE because it needs to be in strict mode.
!function() {
"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  AutomationForm: function() { return /* reexport */ AutomationForm/* default */.A; },
  AutomationList: function() { return /* reexport */ AutomationList/* default */.A; },
  CategoriesList: function() { return /* reexport */ CategoriesList/* default */.A; },
  CategoriesListView: function() { return /* reexport */ CategoriesListView["default"]; },
  CommentDelete: function() { return /* reexport */ CommentDelete/* default */.A; },
  CommentForm: function() { return /* reexport */ CommentForm/* default */.A; },
  CommentItem: function() { return /* reexport */ CommentItem/* default */.A; },
  ConditionsDisplay: function() { return /* reexport */ ConditionsDisplay/* default */.A; },
  ConfigurationView: function() { return /* reexport */ ConfigurationView["default"]; },
  KwixeoTickets: function() { return /* reexport */ install; },
  Lang: function() { return /* reexport */ lang; },
  Mailbox: function() { return /* reexport */ Mailbox/* default */.A; },
  MyTicketComment: function() { return /* reexport */ MyTicketComment/* default */.A; },
  MyTicketItem: function() { return /* reexport */ MyTicketItem/* default */.A; },
  MyTicketItemView: function() { return /* reexport */ MyTicketItemView["default"]; },
  MyTickets: function() { return /* reexport */ MyTickets/* default */.A; },
  MyTicketsNew: function() { return /* reexport */ MyTicketsNew/* default */.A; },
  MyTicketsView: function() { return /* reexport */ MyTicketsView["default"]; },
  Notifications: function() { return /* reexport */ Notifications/* default */.A; },
  TagsList: function() { return /* reexport */ TagsList/* default */.A; },
  TagsListView: function() { return /* reexport */ TagsListView["default"]; },
  TemplatesList: function() { return /* reexport */ TemplatesList/* default */.A; },
  TemplatesListView: function() { return /* reexport */ TemplatesListView["default"]; },
  TicketAutoClose: function() { return /* reexport */ TicketAutoClose/* default */.A; },
  TicketClose: function() { return /* reexport */ TicketClose/* default */.A; },
  TicketDelete: function() { return /* reexport */ TicketDelete/* default */.A; },
  TicketForm: function() { return /* reexport */ TicketForm/* default */.A; },
  TicketItem: function() { return /* reexport */ TicketItem/* default */.A; },
  TicketItemInfos: function() { return /* reexport */ TicketItemInfos/* default */.A; },
  TicketItemView: function() { return /* reexport */ TicketItemView["default"]; },
  TicketsList: function() { return /* reexport */ TicketsList/* default */.A; },
  TicketsListView: function() { return /* reexport */ TicketsListView["default"]; },
  TicketsStore: function() { return /* reexport */ modules_KwixeoTicketsStore; },
  configRoutes: function() { return /* reexport */ config; },
  fetchMyTicket: function() { return /* reexport */ myTicket/* fetchMyTicket */.HR; },
  fetchTicket: function() { return /* reexport */ ticket/* fetchTicket */.vA; },
  myTicketRelations: function() { return /* reexport */ myTicket/* myTicketRelations */.eY; },
  needFetchMyTicket: function() { return /* reexport */ myTicket/* needFetchMyTicket */.By; },
  needFetchTicket: function() { return /* reexport */ ticket/* needFetchTicket */.vE; },
  routes: function() { return /* reexport */ router_routes; },
  ticketRelations: function() { return /* reexport */ ticket/* ticketRelations */.un; },
  validationRules: function() { return /* reexport */ src_validate; }
});

;// ./node_modules/@vue/cli-service/lib/commands/build/setPublicPath.js
/* eslint-disable no-var */
// This file is imported into lib/wc client bundles.

if (typeof window !== 'undefined') {
  var currentScript = window.document.currentScript
  if (false) { var getCurrentScript; }

  var src = currentScript && currentScript.src.match(/(.+\/)[^/]+\.js(\?.*)?$/)
  if (src) {
    __webpack_require__.p = src[1] // eslint-disable-line
  }
}

// Indicate to webpack that this file can be concatenated
/* harmony default export */ var setPublicPath = (null);

// EXTERNAL MODULE: ./src/components/AutomationForm/AutomationForm.vue + 3 modules
var AutomationForm = __webpack_require__(4016);
// EXTERNAL MODULE: ./src/components/AutomationList/AutomationList.vue + 3 modules
var AutomationList = __webpack_require__(2120);
// EXTERNAL MODULE: ./src/components/AutomationList/ConditionsDisplay.vue + 3 modules
var ConditionsDisplay = __webpack_require__(5786);
// EXTERNAL MODULE: ./src/components/CategoriesList/CategoriesList.vue + 3 modules
var CategoriesList = __webpack_require__(8084);
// EXTERNAL MODULE: ./src/components/CommentDelete/CommentDelete.vue + 3 modules
var CommentDelete = __webpack_require__(4640);
// EXTERNAL MODULE: ./src/components/CommentForm/CommentForm.vue + 5 modules
var CommentForm = __webpack_require__(6090);
// EXTERNAL MODULE: ./src/components/CommentItem/CommentItem.vue + 3 modules
var CommentItem = __webpack_require__(3335);
// EXTERNAL MODULE: ./src/components/Mailbox/Mailbox.vue + 3 modules
var Mailbox = __webpack_require__(1416);
// EXTERNAL MODULE: ./src/components/MyTicketComment/MyTicketComment.vue + 3 modules
var MyTicketComment = __webpack_require__(6014);
// EXTERNAL MODULE: ./src/components/MyTicketItem/MyTicketItem.vue + 3 modules
var MyTicketItem = __webpack_require__(4501);
// EXTERNAL MODULE: ./src/components/MyTickets/MyTickets.vue + 3 modules
var MyTickets = __webpack_require__(5296);
// EXTERNAL MODULE: ./src/components/MyTicketsNew/MyTicketsNew.vue + 3 modules
var MyTicketsNew = __webpack_require__(2667);
// EXTERNAL MODULE: ./src/components/Notifications/Notifications.vue + 3 modules
var Notifications = __webpack_require__(9613);
// EXTERNAL MODULE: ./src/components/TagsList/TagsList.vue + 3 modules
var TagsList = __webpack_require__(6553);
// EXTERNAL MODULE: ./src/components/TemplatesList/TemplatesList.vue + 3 modules
var TemplatesList = __webpack_require__(735);
// EXTERNAL MODULE: ./src/components/TicketAutoClose/TicketAutoClose.vue + 3 modules
var TicketAutoClose = __webpack_require__(9168);
// EXTERNAL MODULE: ./src/components/TicketClose/TicketClose.vue + 3 modules
var TicketClose = __webpack_require__(8223);
// EXTERNAL MODULE: ./src/components/TicketDelete/TicketDelete.vue + 3 modules
var TicketDelete = __webpack_require__(729);
// EXTERNAL MODULE: ./src/components/TicketForm/TicketForm.vue + 3 modules
var TicketForm = __webpack_require__(161);
// EXTERNAL MODULE: ./src/components/TicketItem/TicketItem.vue + 16 modules
var TicketItem = __webpack_require__(564);
// EXTERNAL MODULE: ./src/components/TicketItemInfos/TicketItemInfos.vue + 3 modules
var TicketItemInfos = __webpack_require__(9505);
// EXTERNAL MODULE: ./src/components/TicketsList/TicketsList.vue + 3 modules
var TicketsList = __webpack_require__(2022);
// EXTERNAL MODULE: ./src/views/MyTicketItemView/MyTicketItemView.vue + 3 modules
var MyTicketItemView = __webpack_require__(1017);
// EXTERNAL MODULE: ./src/views/TicketItemView/TicketItemView.vue + 3 modules
var TicketItemView = __webpack_require__(650);
// EXTERNAL MODULE: ./src/views/CategoriesListView.vue + 3 modules
var CategoriesListView = __webpack_require__(7943);
// EXTERNAL MODULE: ./src/views/ConfigurationView.vue + 7 modules
var ConfigurationView = __webpack_require__(8618);
// EXTERNAL MODULE: ./src/views/MyTicketsView.vue + 3 modules
var MyTicketsView = __webpack_require__(3295);
// EXTERNAL MODULE: ./src/views/TagsListView.vue + 3 modules
var TagsListView = __webpack_require__(1229);
// EXTERNAL MODULE: ./src/views/TemplatesListView.vue + 3 modules
var TemplatesListView = __webpack_require__(8887);
// EXTERNAL MODULE: ./src/views/TicketsListView.vue + 3 modules
var TicketsListView = __webpack_require__(5561);
;// ./src/lang/en.ts
var ticketsLang = {};
/* harmony default export */ var en = ({
    tickets: ticketsLang
});

;// ./src/lang/fr.ts
var fr_ticketsLang = {
    menuLabel: 'Tickets',
    configuration: {
        pageTitle: 'Paramétrage des tickets',
        menuLabel: 'Configuration',
        automationMenu: 'Automation',
        references: 'Numérotation',
        notificationMenu: 'Notifications',
        closeMenu: 'Clôture automatique'
    },
    tags: {
        pageTitle: 'Gestion des mots-clés',
        createTitle: 'Création d\'un mot-clé',
        editTitle: 'Modification d\'un mot-clé',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce mot-clé ?',
        label: 'Mot-clé',
        menuLabel: 'Mot-clés'
    },
    categories: {
        pageTitle: 'Gestion des catégories',
        createTitle: 'Création d\'une catégorie',
        editTitle: 'Modification d\'une catégorie',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette catégorie ?',
        label: 'Nom',
        color: 'Couleur',
        menuLabel: 'Catégories'
    },
    templates: {
        pageTitle: 'Gestion des modèles de réponse',
        createTitle: 'Création d\'un modèle de réponse',
        editTitle: 'Modification d\'un modèle de réponse',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce modèle de réponse ?',
        menuLabel: 'Modèles de réponse',
        label: 'Nom',
        message: 'Message',
        insert: 'Insérer la réponse',
        replace: 'Remplacer le message'
    },
    automation: {
        conditions: 'Conditions',
        addCondition: 'Ajouter une condition',
        if: 'si le',
        and: 'Et',
        or: 'Ou',
        subject: 'sujet',
        message: 'message',
        contains: 'contient',
        dontContains: 'ne contient pas',
        actions: 'Actions',
        assignToUser: 'Attributer le ticket à l\'utilisateur :',
        priority: 'Mettre la priorité à :',
        category: 'Attributer la catégorie :',
        tags: 'Attributer les mots-clés :',
        explain: 'Vous avez la possibilité d\'automatiser l\'attribution d\'une catégorie, des mots-clés et d\'un utilisateur lors de la création d\'un ticket via la réception d\'un email.',
        addTitle: 'Création d\'une automatisation',
        editTitle: 'Modification d\'une automatisation',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer cette automatisation ?',
        list: {
            conditions: 'Conditions',
            users: 'Utilisateur',
            priority: 'Priorité',
            category: 'Catégorie',
            tags: 'Mots-clés'
        }
    },
    comments: {
        add: 'Ajout d\'une note',
        edit: 'Modification d\'une note',
        addResponse: 'Ajout d\'une réponse',
        private: 'Note privée',
        linkedFiles: 'Fichiers joints :'
    },
    mailbox: {
        none: 'Aucune',
        markAsRead: 'Marquer l\'email comme lu',
        deleteMail: 'Supprimer l\'email',
        createTicket: 'Créer une demande de support',
        dontCreateTicket: 'Ne pas traiter la demande',
        treatment: 'Traitement des emails',
        whenMailLoaded: 'Lorsqu\'un email est traité',
        explain1: 'Afin de fonctionner correctement, le système de ticket a besoin d\'une boîte email dédiée.',
        explain2: 'Vous devez ainsi configurer :',
        explain3: 'Le serveur pour réceptionner vos emails :',
        explain4: 'Les emails entrant seront utilisé pour créer des tickets et ajouter des messages aux tickets existants.',
        explain5: 'Le serveur pour envoyer vos emails :',
        explain6: 'Les réponses aux tickets seront envoyées via cette adresse email.',
        mailReceipt: 'Réception des emails',
        serverType: 'Type de serveur',
        serverAddress: 'Adresse du serveur',
        serverSecurity: 'Sécurité',
        serverPort: 'Port',
        serverLogin: 'Login',
        serverPassword: 'Mot de passe',
        mailSend: 'Envoi des emails',
        emailAddress: 'Adresse email',
        smtpAddress: 'Adresse du serveur SMTP'
    },
    ticket: {
        pageTitle: 'Support technique',
        myTicketTitle: 'Support technique',
        listTitle: 'Liste des tickets',
        itemTitle: 'Ticket',
        createTitle: 'Création d\'une demande de support',
        back: 'Retour',
        reply: 'Répondre',
        addComment: 'Ajouter une note',
        new: 'Nouvelle demande de support',
        subject: 'Sujet',
        message: 'Message',
        addFiles: 'Joindre des fichiers',
        status: 'Statut',
        status1: 'En attente d\'attribution',
        status2: 'En cours',
        status3: 'Répondu',
        status4: 'Clôturé',
        lastUpdate: 'Dernière mise à jour',
        closed: 'Clôturer',
        changeStatusMsg: 'Êtes-vous sûr de passer ce ticket au statut',
        all: 'Tout',
        messages: 'Messages',
        comments: 'Notes',
        history: 'Historique',
        noElements: 'Aucun élément',
        deleteMsg: 'Êtes-vous sûr de vouloir supprimer ce ticket ?',
        mergeBtn: 'Fusionner',
        mergeTitle: 'Fusionner avec un autre ticket',
        mergeDestination: 'Ticket de destination',
        mergeExplain1: 'Tous les échanges liés à ce ticket seront rattachés au nouveau ticket et ce ticket sera supprimé.',
        mergeExplain2: 'Attention, cette action est irreversible',
        mergeSameContact: 'Ne rechercher que des tickets du même client ou contact',
        tags: 'Mots-clés',
        allTags: 'Tous les mots-clés',
        category: 'Catégorie',
        attributedTo: 'Attribué à',
        priority: 'Priorité',
        priority1: 'Basse',
        priority2: 'Normale',
        priority3: 'Haute',
        priority4: 'Urgente',
        createdBy: 'Créé par',
        createdAt: 'Date de création',
        reference: 'Référence',
        customer: 'Client',
        contact: 'Contact',
        lastAction: 'Dernière action',
        contentFilter: 'Contenu des échanges',
        notAttributed: 'Non attribuée'
    },
    notifications: {
        create: 'Création d\'un nouveau ticket',
        assign: 'Assignation d\'un ticket à un utilisateur',
        newMessage: 'Nouveau message d\'un client sur un ticket',
        newComment: 'Ajout d\'une note sur un ticket',
        close: 'Clôture d\'un ticket',
        allUser: 'Tous les utilisateurs attribués au support',
        onlyUser: 'Uniquement les utilisateurs suivants',
        explain: 'Vous pouvez personnaliser ici, les différentes notifications qui sont envoyées à vos utilisateurs.',
        toCustom: 'Notification à personnaliser',
        choose: 'Choisissez une notification',
        disabled: 'Désactiver cette notification',
        linkedUser: 'L\'utilisateur attribué à la demande de support recevra obligatoirement une notification.',
        noUser: 'Aucun utilisateur sélectionné',
        customizeMessage: 'Personnalisation du message',
        subject: 'Sujet',
        message: 'Message',
        linkExplain: 'Vous pouvez insérer un lien vers le ticket en utilisant la variable [[TICKET-LINK]]',
        variables: {
            ticketTitle: 'Informations sur le ticket',
            subject: 'Sujet',
            message: 'Message',
            customer: 'Client',
            contact: 'Contact',
            priority: 'Priorité',
            category: 'Catégorie',
            tags: 'Mots-clés',
            user: 'Utilisateur attribué au ticket',
            userTitle: 'Informations sur l\'utilisateur',
            firstname: 'Prénom',
            lastname: 'Nom',
        }
    },
    autoclose: {
        title: 'Clôture des tickets',
        closeAfter: 'Clôturer automatiquement un ticket au bout de',
        closeAfterDay: 'jours sans activité.',
        sendNotification: 'Envoyer une notification au client',
        notifyClose: 'jours avant la côture automatique d\'un ticket.',
        customMessage: 'Personnalisation du message'
    }
};
/* harmony default export */ var fr = ({
    tickets: fr_ticketsLang
});

;// ./src/lang/index.ts


var Lang = {
    en: en,
    fr: fr
};
/* harmony default export */ var lang = (Lang);

;// ./src/router/routes.ts
var routes_TicketsList = function () { return __webpack_require__.e(/* import() | tickets */ 382).then(__webpack_require__.bind(__webpack_require__, 5561)); };
var TicketsKanbanView = function () { return __webpack_require__.e(/* import() | tickets */ 382).then(__webpack_require__.bind(__webpack_require__, 4322)); };
var TicketsItem = function () { return __webpack_require__.e(/* import() | tickets */ 382).then(__webpack_require__.bind(__webpack_require__, 650)); };
var routes_MyTicketsView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 3295)); };
var routes_MyTicketItemView = function () { return Promise.resolve(/* import() */).then(__webpack_require__.bind(__webpack_require__, 1017)); };

var routes = function (i18n) { return ([
    {
        path: '/tickets/list',
        name: 'tickets-list',
        component: routes_TicketsList,
        meta: {
            title: i18n.t('tickets.ticket.listTitle'),
            buttons: [
                {
                    component: TicketForm/* default */.A
                }
            ],
            appModule: 'tickets',
            userPermission: ['tickets', 1]
        }
    },
    {
        path: '/tickets/kanban',
        name: 'tickets-kanban',
        component: TicketsKanbanView,
        meta: {
            title: i18n.t('tickets.ticket.listTitle'),
            pageHeader: false,
            appModule: 'tickets',
            userPermission: ['tickets', 1]
        }
    },
    {
        path: '/tickets/:id',
        name: 'tickets-item',
        component: TicketsItem,
        meta: {
            title: i18n.t('tickets.ticket.itemTitle'),
            pageHeader: false,
            appModule: 'tickets',
            userPermission: ['tickets', 1]
        }
    },
    {
        path: '/app-support',
        name: 'app-support',
        component: routes_MyTicketsView,
        meta: {
            pageHeader: false,
            title: i18n.t('tickets.ticket.pageTitle')
        }
    },
    {
        path: '/app-support/:id',
        name: 'app-support-item',
        component: routes_MyTicketItemView,
        meta: {
            pageHeader: false,
            title: i18n.t('tickets.ticket.pageTitle')
        }
    }
]); };
/* harmony default export */ var router_routes = (routes);

;// ./src/router/config.ts
var config_ConfigurationView = function () { return __webpack_require__.e(/* import() | tickets */ 382).then(__webpack_require__.bind(__webpack_require__, 8618)); };
var config_TagsList = function () { return __webpack_require__.e(/* import() | tickets */ 382).then(__webpack_require__.bind(__webpack_require__, 1229)); };
var config_TemplatesList = function () { return __webpack_require__.e(/* import() | tickets */ 382).then(__webpack_require__.bind(__webpack_require__, 8887)); };
var config_CategoriesList = function () { return __webpack_require__.e(/* import() | tickets */ 382).then(__webpack_require__.bind(__webpack_require__, 7943)); };
var configRoutes = function (i18n) { return ([
    {
        name: 'tickets-configuration',
        path: 'tickets/configuration',
        component: config_ConfigurationView,
        meta: {
            title: i18n.t('tickets.configuration.pageTitle'),
            appModule: 'tickets',
            userPermission: ['tickets', 1]
        }
    },
    {
        name: 'tickets-tags',
        path: 'tickets/tags',
        component: config_TagsList,
        meta: {
            title: i18n.t('tickets.tags.pageTitle'),
            appModule: 'tickets',
            userPermission: ['tickets', 1]
        }
    },
    {
        name: 'tickets-templates',
        path: 'tickets/templates',
        component: config_TemplatesList,
        meta: {
            title: i18n.t('tickets.templates.pageTitle'),
            appModule: 'tickets',
            userPermission: ['tickets', 1]
        }
    },
    {
        name: 'tickets-categories',
        path: 'tickets/categories',
        component: config_CategoriesList,
        meta: {
            title: i18n.t('tickets.categories.pageTitle'),
            appModule: 'tickets',
            userPermission: ['tickets', 1]
        }
    }
]); };
/* harmony default export */ var config = (configRoutes);

// EXTERNAL MODULE: ./node_modules/lodash/forEach.js
var forEach = __webpack_require__(9754);
var forEach_default = /*#__PURE__*/__webpack_require__.n(forEach);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(1635);
;// ./node_modules/vuex-module-decorators/dist/esm/index.js
/**
 * Takes the properties on object from parameter source and adds them to the object
 * parameter target
 * @param {object} target  Object to have properties copied onto from y
 * @param {object} source  Object with properties to be copied to x
 */
function addPropertiesToObject(target, source) {
    var _loop_1 = function (k) {
        Object.defineProperty(target, k, {
            get: function () { return source[k]; }
        });
    };
    for (var _i = 0, _a = Object.keys(source || {}); _i < _a.length; _i++) {
        var k = _a[_i];
        _loop_1(k);
    }
}
/**
 * Returns a namespaced name of the module to be used as a store getter
 * @param module
 */
function getModuleName(module) {
    if (!module._vmdModuleName) {
        throw new Error("ERR_GET_MODULE_NAME : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    return "vuexModuleDecorators/".concat(module._vmdModuleName);
}

var VuexModule = /** @class */ (function () {
    function VuexModule(module) {
        this.actions = module.actions;
        this.mutations = module.mutations;
        this.state = module.state;
        this.getters = module.getters;
        this.namespaced = module.namespaced;
        this.modules = module.modules;
    }
    return VuexModule;
}());
function getModule(moduleClass, store) {
    var moduleName = getModuleName(moduleClass);
    if (store && store.getters[moduleName]) {
        return store.getters[moduleName];
    }
    else if (moduleClass._statics) {
        return moduleClass._statics;
    }
    var genStatic = moduleClass._genStatic;
    if (!genStatic) {
        throw new Error("ERR_GET_MODULE_NO_STATICS : Could not get module accessor.\n      Make sure your module has name, we can't make accessors for unnamed modules\n      i.e. @Module({ name: 'something' })");
    }
    var storeModule = genStatic(store);
    if (store) {
        store.getters[moduleName] = storeModule;
    }
    else {
        moduleClass._statics = storeModule;
    }
    return storeModule;
}

var reservedKeys = ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit'];
function stateFactory(module) {
    var state = new module.prototype.constructor({});
    var s = {};
    Object.keys(state).forEach(function (key) {
        if (reservedKeys.indexOf(key) !== -1) {
            if (typeof state[key] !== 'undefined') {
                throw new Error("ERR_RESERVED_STATE_KEY_USED: You cannot use the following\n        ['actions', 'getters', 'mutations', 'modules', 'state', 'namespaced', 'commit']\n        as fields in your module. These are reserved as they have special purpose in Vuex");
            }
            return;
        }
        if (state.hasOwnProperty(key)) {
            if (typeof state[key] !== 'function') {
                s[key] = state[key];
            }
        }
    });
    return s;
}

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}

function staticStateGenerator(module, modOpt, statics) {
    var state = modOpt.stateFactory ? module.state() : module.state;
    Object.keys(state).forEach(function (key) {
        if (state.hasOwnProperty(key)) {
            // If not undefined or function means it is a state value
            if (['undefined', 'function'].indexOf(typeof state[key]) === -1) {
                Object.defineProperty(statics, key, {
                    get: function () {
                        var path = modOpt.name.split('/');
                        var data = statics.store.state;
                        for (var _i = 0, path_1 = path; _i < path_1.length; _i++) {
                            var segment = path_1[_i];
                            data = data[segment];
                        }
                        return data[key];
                    }
                });
            }
        }
    });
}
function staticGetterGenerator(module, modOpt, statics) {
    Object.keys(module.getters).forEach(function (key) {
        if (module.namespaced) {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters["".concat(modOpt.name, "/").concat(key)];
                }
            });
        }
        else {
            Object.defineProperty(statics, key, {
                get: function () {
                    return statics.store.getters[key];
                }
            });
        }
    });
}
function staticMutationGenerator(module, modOpt, statics) {
    Object.keys(module.mutations).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false));
            };
        }
        else {
            statics[key] = function () {
                var _a;
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                (_a = statics.store).commit.apply(_a, __spreadArray([key], args, false));
            };
        }
    });
}
function staticActionGenerators(module, modOpt, statics) {
    Object.keys(module.actions).forEach(function (key) {
        if (module.namespaced) {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray(["".concat(modOpt.name, "/").concat(key)], args, false))];
                    });
                });
            };
        }
        else {
            statics[key] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                return __awaiter(this, void 0, void 0, function () {
                    var _a;
                    return __generator(this, function (_b) {
                        return [2 /*return*/, (_a = statics.store).dispatch.apply(_a, __spreadArray([key], args, false))];
                    });
                });
            };
        }
    });
}

function registerDynamicModule(module, modOpt) {
    if (!modOpt.name) {
        throw new Error('Name of module not provided in decorator options');
    }
    if (!modOpt.store) {
        throw new Error('Store not provided in decorator options when using dynamic option');
    }
    modOpt.store.registerModule(modOpt.name, // TODO: Handle nested modules too in future
    module, { preserveState: modOpt.preserveState || false });
}
function addGettersToModule(targetModule, srcModule) {
    Object.getOwnPropertyNames(srcModule.prototype).forEach(function (funcName) {
        var descriptor = Object.getOwnPropertyDescriptor(srcModule.prototype, funcName);
        if (descriptor.get && targetModule.getters) {
            targetModule.getters[funcName] = function (state, getters, rootState, rootGetters) {
                var thisObj = { context: { state: state, getters: getters, rootState: rootState, rootGetters: rootGetters } };
                addPropertiesToObject(thisObj, state);
                addPropertiesToObject(thisObj, getters);
                var got = descriptor.get.call(thisObj);
                return got;
            };
        }
    });
}
function moduleDecoratorFactory(moduleOptions) {
    return function (constructor) {
        var module = constructor;
        var stateFactory$1 = function () { return stateFactory(module); };
        if (!module.state) {
            module.state = moduleOptions && moduleOptions.stateFactory ? stateFactory$1 : stateFactory$1();
        }
        if (!module.getters) {
            module.getters = {};
        }
        if (!module.namespaced) {
            module.namespaced = moduleOptions && moduleOptions.namespaced;
        }
        var parentModule = Object.getPrototypeOf(module);
        while (parentModule.name !== 'VuexModule' && parentModule.name !== '') {
            addGettersToModule(module, parentModule);
            parentModule = Object.getPrototypeOf(parentModule);
        }
        addGettersToModule(module, module);
        var modOpt = moduleOptions;
        if (modOpt.name) {
            Object.defineProperty(constructor, '_genStatic', {
                value: function (store) {
                    var statics = { store: store || modOpt.store };
                    if (!statics.store) {
                        throw new Error("ERR_STORE_NOT_PROVIDED: To use getModule(), either the module\n            should be decorated with store in decorator, i.e. @Module({store: store}) or\n            store should be passed when calling getModule(), i.e. getModule(MyModule, this.$store)");
                    }
                    // ===========  For statics ==============
                    // ------ state -------
                    staticStateGenerator(module, modOpt, statics);
                    // ------- getters -------
                    if (module.getters) {
                        staticGetterGenerator(module, modOpt, statics);
                    }
                    // -------- mutations --------
                    if (module.mutations) {
                        staticMutationGenerator(module, modOpt, statics);
                    }
                    // -------- actions ---------
                    if (module.actions) {
                        staticActionGenerators(module, modOpt, statics);
                    }
                    return statics;
                }
            });
            Object.defineProperty(constructor, '_vmdModuleName', {
                value: modOpt.name
            });
        }
        if (modOpt.dynamic) {
            registerDynamicModule(module, modOpt);
        }
        return constructor;
    };
}
function Module(modOrOpt) {
    if (typeof modOrOpt === 'function') {
        /*
         * @Module decorator called without options (directly on the class definition)
         */
        moduleDecoratorFactory({})(modOrOpt);
    }
    else {
        /*
         * @Module({...}) decorator called with options
         */
        return moduleDecoratorFactory(modOrOpt);
    }
}

var esm_config = {};

function actionDecoratorFactory(params) {
    var _a = params || {}, _b = _a.commit, commit = _b === void 0 ? undefined : _b, _c = _a.rawError, rawError = _c === void 0 ? !!esm_config.rawError : _c, _d = _a.root, root = _d === void 0 ? false : _d;
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var actionFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var actionPayload, moduleName, moduleAccessor, thisObj, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 5, , 6]);
                            actionPayload = null;
                            if (!module._genStatic) return [3 /*break*/, 2];
                            moduleName = getModuleName(module);
                            moduleAccessor = context.rootGetters[moduleName]
                                ? context.rootGetters[moduleName]
                                : getModule(module);
                            moduleAccessor.context = context;
                            return [4 /*yield*/, actionFunction.call(moduleAccessor, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            return [3 /*break*/, 4];
                        case 2:
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, actionFunction.call(thisObj, payload)];
                        case 3:
                            actionPayload = _a.sent();
                            _a.label = 4;
                        case 4:
                            if (commit) {
                                context.commit(commit, actionPayload);
                            }
                            return [2 /*return*/, actionPayload];
                        case 5:
                            e_1 = _a.sent();
                            throw rawError
                                ? e_1
                                : new Error('ERR_ACTION_ACCESS_UNDEFINED: Are you trying to access ' +
                                    'this.someMutation() or this.someGetter inside an @Action? \n' +
                                    'That works only in dynamic modules. \n' +
                                    'If not dynamic use this.context.commit("mutationName", payload) ' +
                                    'and this.context.getters["getterName"]' +
                                    '\n' +
                                    new Error("Could not perform action ".concat(key.toString())).stack +
                                    '\n' +
                                    e_1.stack);
                        case 6: return [2 /*return*/];
                    }
                });
            });
        };
        module.actions[key] = root ? { root: root, handler: action } : action;
    };
}
/**
 * The @Action decorator turns an async function into an Vuex action
 *
 * @param targetOrParams the module class
 * @param key name of the action
 * @param descriptor the action function descriptor
 * @constructor
 */
function Action(targetOrParams, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `targetOrParams` is params.
         * i.e. when used as -
         * <pre>
            @Action({commit: 'incrCount'})
            async getCountDelta() {
              return 5
            }
         * </pre>
         */
        return actionDecoratorFactory(targetOrParams);
    }
    else {
        /*
         * This is the case when @Action is called on action function
         * without any params
         * <pre>
         *   @Action
         *   async doSomething() {
         *    ...
         *   }
         * </pre>
         */
        actionDecoratorFactory()(targetOrParams, key, descriptor);
    }
}

function Mutation(target, key, descriptor) {
    var module = target.constructor;
    if (!module.hasOwnProperty('mutations')) {
        module.mutations = Object.assign({}, module.mutations);
    }
    var mutationFunction = descriptor.value;
    var mutation = function (state, payload) {
        mutationFunction.call(state, payload);
    };
    module.mutations[key] = mutation;
}

function mutationActionDecoratorFactory(params) {
    return function (target, key, descriptor) {
        var module = target.constructor;
        if (!module.hasOwnProperty('mutations')) {
            module.mutations = Object.assign({}, module.mutations);
        }
        if (!module.hasOwnProperty('actions')) {
            module.actions = Object.assign({}, module.actions);
        }
        var mutactFunction = descriptor.value;
        var action = function (context, payload) {
            return __awaiter(this, void 0, void 0, function () {
                var thisObj, actionPayload, e_1;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            _a.trys.push([0, 2, , 3]);
                            thisObj = { context: context };
                            addPropertiesToObject(thisObj, context.state);
                            addPropertiesToObject(thisObj, context.getters);
                            return [4 /*yield*/, mutactFunction.call(thisObj, payload)];
                        case 1:
                            actionPayload = _a.sent();
                            if (actionPayload === undefined)
                                return [2 /*return*/];
                            context.commit(key, actionPayload);
                            return [3 /*break*/, 3];
                        case 2:
                            e_1 = _a.sent();
                            if (params.rawError) {
                                throw e_1;
                            }
                            else {
                                console.error('Could not perform action ' + key.toString());
                                console.error(e_1);
                                return [2 /*return*/, Promise.reject(e_1)];
                            }
                        case 3: return [2 /*return*/];
                    }
                });
            });
        };
        var mutation = function (state, payload) {
            if (!params.mutate) {
                params.mutate = Object.keys(payload);
            }
            for (var _i = 0, _a = params.mutate; _i < _a.length; _i++) {
                var stateItem = _a[_i];
                if (state.hasOwnProperty(stateItem) && payload.hasOwnProperty(stateItem)) {
                    state[stateItem] = payload[stateItem];
                }
                else {
                    throw new Error("ERR_MUTATE_PARAMS_NOT_IN_PAYLOAD\n          In @MutationAction, mutate: ['a', 'b', ...] array keys must\n          match with return type = {a: {}, b: {}, ...} and must\n          also be in state.");
                }
            }
        };
        module.actions[key] = params.root ? { root: true, handler: action } : action;
        module.mutations[key] = mutation;
    };
}
/**
 * The @MutationAction decorator turns this into an action that further calls a mutation
 * Both the action and the mutation are generated for you
 *
 * @param paramsOrTarget the params or the target class
 * @param key the name of the function
 * @param descriptor the function body
 * @constructor
 */
function MutationAction(paramsOrTarget, key, descriptor) {
    if (!key && !descriptor) {
        /*
         * This is the case when `paramsOrTarget` is params.
         * i.e. when used as -
         * <pre>
            @MutationAction({mutate: ['incrCount']})
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        return mutationActionDecoratorFactory(paramsOrTarget);
    }
    else {
        /*
         * This is the case when `paramsOrTarget` is target.
         * i.e. when used as -
         * <pre>
            @MutationAction
            async getCountDelta() {
              return {incrCount: 5}
            }
         * </pre>
         */
        mutationActionDecoratorFactory({})(paramsOrTarget, key, descriptor);
    }
}


//# sourceMappingURL=index.js.map

// EXTERNAL MODULE: external "vue"
var external_vue_ = __webpack_require__(622);
var external_vue_default = /*#__PURE__*/__webpack_require__.n(external_vue_);
;// ./src/store/modules/KwixeoTicketsStore.ts



var KwixeoTicketsStore = /** @class */ (function (_super) {
    (0,tslib_es6/* __extends */.C6)(KwixeoTicketsStore, _super);
    function KwixeoTicketsStore() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.tagsLoaded = false;
        _this.tags = [];
        _this.categoriesLoaded = false;
        _this.categories = [];
        _this.templatesLoaded = false;
        _this.templates = [];
        return _this;
    }
    // Sort a list alphabetically
    KwixeoTicketsStore.prototype.orderList = function (param) {
        var key = param.key;
        param.list.sort(function (a, b) {
            var aKey = a[key].toLowerCase();
            var bKey = b[key].toLowerCase();
            if (aKey < bKey)
                return -1;
            else if (aKey > bKey)
                return 1;
            else
                return 0;
        });
    };
    // Change the loaded state
    KwixeoTicketsStore.prototype.setTagsLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.tagsLoaded = state;
    };
    // Set the tags
    KwixeoTicketsStore.prototype.setTags = function (tags) {
        this.tags = tags;
    };
    // Add or update a tag
    KwixeoTicketsStore.prototype.updateTag = function (tag) {
        if (!this.tagsLoaded) {
            return;
        }
        var index = this.tags.findIndex(function (type) { return type.id === tag.id; });
        if (index >= 0) {
            external_vue_default().set(this.tags, index, tag);
        }
        else {
            this.tags.push(tag);
        }
    };
    // Remove a tag
    KwixeoTicketsStore.prototype.removeTag = function (tag) {
        if (!this.tagsLoaded) {
            return;
        }
        var index = this.tags.findIndex(function (type) { return type.id === tag.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.tags, index);
        }
    };
    // Load the tags from api
    KwixeoTicketsStore.prototype.loadTags = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.tagsLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwTickets.axios.get('/ticket/tag?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setTags', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setTagsLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a tag
    KwixeoTicketsStore.prototype.setTag = function (tag) {
        this.context.commit('updateTag', tag);
        if (this.tagsLoaded) {
            this.context.commit('orderList', { list: this.tags, key: 'label' });
        }
    };
    // Delete a tag
    KwixeoTicketsStore.prototype.deleteTag = function (tag) {
        this.context.commit('removeTag', tag);
    };
    // Change the loaded state
    KwixeoTicketsStore.prototype.setCategoriesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.categoriesLoaded = state;
    };
    // Set the categories
    KwixeoTicketsStore.prototype.setCategories = function (categories) {
        this.categories = categories;
    };
    // Add or update a category
    KwixeoTicketsStore.prototype.updateCategory = function (category) {
        if (!this.categoriesLoaded) {
            return;
        }
        var index = this.categories.findIndex(function (type) { return type.id === category.id; });
        if (index >= 0) {
            external_vue_default().set(this.categories, index, category);
        }
        else {
            this.categories.push(category);
        }
    };
    // Remove a category
    KwixeoTicketsStore.prototype.removeCategory = function (category) {
        if (!this.categoriesLoaded) {
            return;
        }
        var index = this.categories.findIndex(function (type) { return type.id === category.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.categories, index);
        }
    };
    // Load the categories from api
    KwixeoTicketsStore.prototype.loadCategories = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.categoriesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwTickets.axios.get('/ticket/category?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setCategories', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setCategoriesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a category
    KwixeoTicketsStore.prototype.setCategory = function (category) {
        this.context.commit('updateCategory', category);
        if (this.categoriesLoaded) {
            this.context.commit('orderList', { list: this.categories, key: 'label' });
        }
    };
    // Delete a category
    KwixeoTicketsStore.prototype.deleteCategory = function (category) {
        this.context.commit('removeCategory', category);
    };
    // Change the loaded state
    KwixeoTicketsStore.prototype.setTemplatesLoaded = function (state) {
        if (state === void 0) { state = true; }
        this.templatesLoaded = state;
    };
    // Set the templates
    KwixeoTicketsStore.prototype.setTemplates = function (templates) {
        this.templates = templates;
    };
    // Add or update a template
    KwixeoTicketsStore.prototype.updateTemplate = function (template) {
        if (!this.templatesLoaded) {
            return;
        }
        var index = this.templates.findIndex(function (type) { return type.id === template.id; });
        if (index >= 0) {
            external_vue_default().set(this.templates, index, template);
        }
        else {
            this.templates.push(template);
        }
    };
    // Remove a template
    KwixeoTicketsStore.prototype.removeTemplate = function (template) {
        if (!this.templatesLoaded) {
            return;
        }
        var index = this.templates.findIndex(function (type) { return type.id === template.id; });
        if (index >= 0) {
            external_vue_default()["delete"](this.templates, index);
        }
    };
    // Load the templates from api
    KwixeoTicketsStore.prototype.loadTemplates = function (force) {
        if (force === void 0) { force = false; }
        return (0,tslib_es6/* __awaiter */.sH)(this, void 0, Promise, function () {
            var response;
            return (0,tslib_es6/* __generator */.YH)(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!(!this.templatesLoaded || force)) return [3 /*break*/, 3];
                        return [4 /*yield*/, external_vue_default().prototype.$kwTickets.axios.get('/ticket/template?per_page=500&sort=label')];
                    case 1:
                        response = _a.sent();
                        return [4 /*yield*/, this.context.commit('setTemplates', response.data.data)];
                    case 2:
                        _a.sent();
                        this.context.commit('setTemplatesLoaded');
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    // Add or update a template
    KwixeoTicketsStore.prototype.setTemplate = function (template) {
        this.context.commit('updateTemplate', template);
        if (this.templatesLoaded) {
            this.context.commit('orderList', { list: this.templates, key: 'label' });
        }
    };
    // Delete a template
    KwixeoTicketsStore.prototype.deleteTemplate = function (template) {
        this.context.commit('removeTemplate', template);
    };
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "orderList", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "setTagsLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "setTags", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "updateTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "removeTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "loadTags", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "setTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "deleteTag", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "setCategoriesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "setCategories", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "updateCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "removeCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "loadCategories", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "setCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "deleteCategory", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "setTemplatesLoaded", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "setTemplates", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "updateTemplate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Mutation
    ], KwixeoTicketsStore.prototype, "removeTemplate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "loadTemplates", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "setTemplate", null);
    (0,tslib_es6/* __decorate */.Cg)([
        Action
    ], KwixeoTicketsStore.prototype, "deleteTemplate", null);
    KwixeoTicketsStore = (0,tslib_es6/* __decorate */.Cg)([
        Module({
            namespaced: true
        })
    ], KwixeoTicketsStore);
    return KwixeoTicketsStore;
}(VuexModule));
/* harmony default export */ var modules_KwixeoTicketsStore = (KwixeoTicketsStore);

// EXTERNAL MODULE: external "@kwixeo/interface-vue"
var interface_vue_ = __webpack_require__(2652);
;// ./src/broadcasts/team.ts

/* harmony default export */ var team = (function (store) { return ([
    {
        name: '.TicketsCategoryCreated',
        callback: function (category) {
            store.dispatch('tickets/setCategory', category);
        }
    },
    {
        name: '.TicketsCategoryUpdated',
        callback: function (category) {
            store.dispatch('tickets/setCategory', category);
        }
    },
    {
        name: '.TicketsCategoryDeleted',
        callback: function (category) {
            store.dispatch('tickets/deleteCategory', category);
        }
    },
    {
        name: '.TicketsTagCreated',
        callback: function (tag) {
            store.dispatch('tickets/setTag', tag);
        }
    },
    {
        name: '.TicketsTagUpdated',
        callback: function (tag) {
            store.dispatch('tickets/setTag', tag);
        }
    },
    {
        name: '.TicketsTagDeleted',
        callback: function (tag) {
            store.dispatch('tickets/deleteTag', tag);
        }
    },
    {
        name: '.TicketsTemplateCreated',
        callback: function (template) {
            store.dispatch('tickets/setTemplate', template);
        }
    },
    {
        name: '.TicketsTemplateUpdated',
        callback: function (template) {
            store.dispatch('tickets/setTemplate', template);
        }
    },
    {
        name: '.TicketsTemplateDeleted',
        callback: function (template) {
            store.dispatch('tickets/deleteTemplate', template);
        }
    },
    {
        name: '.TicketsTicketCreated',
        callback: function (ticket) {
            interface_vue_.emitter.emit('ticketCreated', ticket);
        }
    },
    {
        name: '.TicketsTicketUpdated',
        callback: function (ticket) {
            interface_vue_.emitter.emit('ticketUpdated', ticket);
        }
    },
    {
        name: '.TicketsTicketDeleted',
        callback: function (ticket) {
            interface_vue_.emitter.emit('ticketDeleted', ticket);
        }
    },
    {
        name: '.TicketsCommentCreated',
        callback: function (comment) {
            interface_vue_.emitter.emit('ticketsCommentCreated', comment);
        }
    },
    {
        name: '.TicketsCommentUpdated',
        callback: function (comment) {
            interface_vue_.emitter.emit('ticketsCommentUpdated', comment);
        }
    },
    {
        name: '.TicketsCommentDeleted',
        callback: function (comment) {
            interface_vue_.emitter.emit('ticketsCommentDeleted', comment);
        }
    }
]); });

;// ./src/install.ts






var KwixeoTickets = {
    install: function (Vue, options) {
        // Install lang
        this.installLang(options);
        Vue.prototype.$kwTickets = options;
        // Install VueX
        this.installVueX(options);
        // Install routes
        this.installRoutes(options);
        __webpack_require__(1848);
        // Initialize broadcasts
        this.installBroadcasts(Vue, options);
    },
    installVueX: function (options) {
        var store = options.store;
        // Register VueX modules
        var modules = {
            tickets: modules_KwixeoTicketsStore
        };
        forEach_default()(modules, function (module, key) {
            if (!store.hasModule(key)) {
                store.registerModule(key, module);
            }
        });
    },
    installRoutes: function (options) {
        var router = options.router;
        var i18n = options.i18n;
        router_routes(i18n).forEach(function (route) {
            router.addRoute(route);
        });
        config(i18n).forEach(function (route) {
            router.addRoute('configuration', route);
        });
    },
    installLang: function (options) {
        var i18n = options.i18n;
        forEach_default()(lang, function (messages, locale) {
            i18n.mergeLocaleMessage(locale, messages);
        });
    },
    installBroadcasts: function (Vue, options) {
        var broadcast = Vue.prototype.$broadcast;
        if (!broadcast) {
            return;
        }
        broadcast.registerListeners('team', team(options.store));
    }
};
/* harmony default export */ var install = (KwixeoTickets);

;// ./src/validate.ts
var validate = {
    whiteMarkNoKwixeo: function (value) {
        if (value && value.match(/kwixeo|kwixéo|kwix&eacute;o/gi)) {
            return 'Vous ne devez pas citer Kwixéo pour les clients des revendeurs';
        }
    }
};
/* harmony default export */ var src_validate = (validate);

// EXTERNAL MODULE: ./src/fetchDatas/ticket.ts
var ticket = __webpack_require__(6886);
// EXTERNAL MODULE: ./src/fetchDatas/myTicket.ts
var myTicket = __webpack_require__(7124);
;// ./src/index.ts












































;// ./node_modules/@vue/cli-service/lib/commands/build/entry-lib-no-default.js



}();
module.exports = __webpack_exports__;
/******/ })()
;
//# sourceMappingURL=tickets.common.js.map